const all_election_data = [
  {
    firstname: "Daniel",
    lastname: "La Spata",
    ballotorder: 1,
    "ward#": 1,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "02/26/1981",
    civic:
      "North Park Univ., BA; UIC, MPP; policy and planning associate for Friends of the Parks",
    candidatevideo: "",
    website: "https://www.daniellaspata.com/",
    fb: "https://www.facebook.com/DanielLaSpata1stWard/",
    twitter: "@DanielLaSpata",
    ig: "https://www.instagram.com/daniel.la.spata/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/dlaspata",
    statement:
      "My primary focus is on the issues of public safety, affordable housing, reliable public transportation, people-powered government, environmental protections and sustainable economic development. As alderperson, I created a fully transparent zoning process, implemented participatory budgeting, invested in protected bike lanes and began long-overdue infrastructure projects. I believe we ask our police officers to do too much; I support programs like the Treatment Not Trauma campaign’s creation of a city-wide non-police crisis response program. While I’m proud of my accomplishments from my first term, my focus is on keeping our progress and momentum for the next four years.",
  },
  {
    firstname: "Proco Joe",
    lastname: "Moreno",
    ballotorder: 3,
    "ward#": 1,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Safety and training consultant",
    dob: "03/19/1972",
    civic:
      "Augustana College, BA; DePaul Univ., MBA; former 1st Ward alderperson (2010-2019)",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public Safety Plan: Immediately allocate up to $4 million from the Aldermanic Menu Fund, spread across four years, to build a state-of-the-art 12th District satellite police station on the 800 block of North Wood Street. Bring back our beat patrol officers to Chicago Avenue and Division Street. Fully fund CVI's such as Chicago Cred, READI and Communities Partner 4 Peace. Advocate strongly with the administration to acquire additional police for our ward. Increase funding in the city budget for mental health services for constituents as well as for our police women and men.",
  },
  {
    firstname: "Sam",
    lastname: "Royko",
    ballotorder: 4,
    "ward#": 1,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Attorney",
    dob: "07/23/1987",
    civic:
      "DePaul Univ., BA, political science; Georgetown Univ. Law Center, JD; built coalition of 10 neighborhood organizations and stakeholders",
    candidatevideo: "",
    website: "https://www.roykoforchicago.com/",
    fb: "https://www.facebook.com/roykoforchicago",
    twitter: "@RoykoForChicago",
    ig: "https://www.instagram.com/roykoforchicago/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/samroyko",
    statement:
      "We must focus on creating safer neighborhoods, advocating for more affordable housing options and revitalizing local business corridors. I will advocate for more community police officers and support funding for violence prevention programs while also addressing the root causes of crime, like mental health and poverty. In order to protect the character of our neighborhoods, while also increasing housing supply, I am committed to a fully open and transparent community review process for zoning and development proposals. To help encourage economic growth, I will cut red tape and create an office that helps local businesses succeed in the 1st Ward.",
  },
  {
    firstname: "Stephen “Andy”",
    lastname: "Schneider",
    ballotorder: 2,
    "ward#": 1,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Publisher and editor",
    dob: "03/12/1980",
    civic:
      "Univ. of Illinois U-C; president of Logan Square Preservation; former reporter; helped develop affordable housing; led efforts to improve traffic safety",
    candidatevideo: "",
    website: "https://www.andyforall.com/",
    fb: "",
    twitter: "@Ward1Andy",
    ig: "https://www.instagram.com/Ward1Andy/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/andrew-schneider-5496237/",
    statement:
      "A top issue facing our neighborhoods is a lack of leadership. There is incredible talent and vision, rich artistic and cultural institutions, but also anxiety and sometimes fear among our neighbors. If we are effectively going to address our shared concerns, we must do it together. For the last 15 years I've brought our community together to harness our talents and input to deliver better outcomes. We can have both progressive leadership on the Council and robust community engagement. I have a demonstrated track record of listening to neighbors and fostering consensus. That's what I'll continue to do as alderperson.",
  },
  {
    firstname: "Brian",
    lastname: "Hopkins",
    ballotorder: 1,
    "ward#": 2,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "https://www.aldermanhopkins.com/",
    fb: "https://www.facebook.com/aldermanhopkins/",
    twitter: "@AldermanHopkins",
    ig: "",
    tiktok: "",
    youtube: "https://www.youtube.com/channel/UC5cwpcj4n6_QwvTFCGzu1qQ/videos",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Pat",
    lastname: "Dowell",
    ballotorder: 1,
    "ward#": 3,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "05/13/1957",
    civic:
      "Univ. of Rochester, BA; UChicago, MA; Department of Planning and Development, former deputy commissioner",
    candidatevideo: "",
    website: "https://www.citizensforpatdowell.com/",
    fb: "https://www.facebook.com/illinoisfordowell",
    twitter: "@ILforDowell",
    ig: "https://www.instagram.com/citizensforpatdowell/",
    tiktok: "",
    youtube: "https://www.youtube.com/channel/UCjv_isCUk9jjT-GHp7I4UVg",
    linkedin: "https://www.linkedin.com/in/pat-dowell-a20933b/",
    statement:
      "The most pressing issue facing the 3rd Ward is public safety and I share the concerns of my constituents who are frustrated with the rise in crime across Chicago. As alderperson and chair of the Budget Committee, I am fighting to fully fund the police department to guarantee that we not only have enough officers to deter crime, but to ensure that our officers and city have the technology and support they need to protect and serve its residents. I am also focused on improving the underlying conditions that contribute to crime – access to better schools, jobs and affordable housing.",
  },
  {
    firstname: "Ebony",
    lastname: "Lucas",
    ballotorder: 5,
    "ward#": 4,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Real estate attorney",
    dob: "12/04/1975",
    civic:
      "Univ. of Michigan, JD; Case Western Reserve Univ., MA, nonprofit management; Univ. of Michigan, BS, elementary education",
    candidatevideo: "",
    website: "https://www.ebony4alderman.com/",
    fb: "https://www.facebook.com/profile.php?id=100086477663145",
    twitter: "@Lucasfor4th",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/ebony-lucas-8464a053/",
    statement:
      "The three biggest issues impacting the 4th Ward are affordability, public safety and inequitable delivery of services. The burden of financing the city is impacting housing stability. As Alderperson, I plan to focus on budget efficiency, growth of commercial corridors and increasing affordable housing options such as ADUs and tiny homes. I will develop strategic partnerships between business, community-based organizations, parks and schools to create safe, positive development activities for youth. I will utilize participatory budgeting and town hall meetings to listen to residents, understand needs, and deploy menu money to adequately address roads, safety, parks, and sanitation needs.",
  },
  {
    firstname: "Helen",
    lastname: "West",
    ballotorder: 1,
    "ward#": 4,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Retired educator",
    dob: "02/19/1953",
    civic:
      "DePaul Univ., BS, business education; Chicago State Univ., MS educational technology; American College of Education, MS/EdD, Educational Leadership",
    candidatevideo: "",
    website: "https://www.citizensforhelenwest.com/",
    fb: "https://www.facebook.com/profile.php?id=100088065694190",
    twitter: "@vote4helenwest",
    ig: "",
    tiktok: "",
    youtube: "https://www.youtube.com/channel/UCG7Sc1hSEJxQsKCAeguurVg",
    linkedin: "https://www.linkedin.com/in/helen-yolanda-west-b141496b/",
    statement:
      "Crime and Public Safety: I would propose an ordinance requiring high quality cameras and lighting (at entrances and parking lots) for all businesses with public access; collaborate with law enforcement to reduce loitering. Affordable Housing: Assure new developments in the 4th Ward include allocations for equitable affordable rental and home ownership opportunities. Economic Development: Push more proactively to nurture and drive the startup and growth of minority and women-owned businesses in the 4th Ward, including business incubators.",
  },
  {
    firstname: "Lamont",
    lastname: "Robinson",
    ballotorder: 3,
    "ward#": 4,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Illinois state legislator",
    dob: "02/21/1982",
    civic:
      "Clark Atlanta Univ., BA; National Louis Univ., MBA; Special Service Area commissioner; Kappa League, executive director; Quad Community Development Corporation, board member",
    candidatevideo: "",
    website: "https://votelamontrobinson.com/",
    fb: "https://www.facebook.com/lamontrobinsonfor4/",
    twitter: "@LamontJRobinson",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public safety. The lack of opportunities in many neighborhoods is often the driving force behind the young people who commit crimes. An effective way in combating crime would be to coordinate with schools and community leaders to identify young people most at-risk of being perpetrators of violent crime and invest in direct mentorship programs, before and after school programs and work with the business community to create jobs and skills training for them. Along with investing more money into trained professionals such as social workers, mental health professionals and violence interrupters to work alongside CPD/Sheriff's Department.",
  },
  {
    firstname: "Matthew “Khari”",
    lastname: "Humphries",
    ballotorder: 4,
    "ward#": 4,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Self-employed consultant",
    dob: "02/21/1974",
    civic:
      "St. Xavier Univ., BS; Grand Blvd Neighborhood 4th Ward Advisory Council, education chair; Quad Communities Development Corporation, board member",
    candidatevideo: "",
    website: "https://www.electkharihumphries.com/",
    fb: "https://www.facebook.com/people/Matthew-Khari-Humphries-for-4th-Ward-Alderman/100087469225954/",
    twitter: "@Khari4Progress",
    ig: "https://www.instagram.com/khari4progress/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/khari-matthew-humphries-4818a3134/",
    statement:
      "As the 4th Ward alderperson, I will provide independent representation in Chicago’s City Council to provide access to: quality education; housing that families at every income level can afford; economic development for all ward residents; a renewed sense of community and security, and accountable leadership from someone who has a track record of getting the job done. Key in addressing all of these needs is to engage the community to: utilize the sustainable community school model to improve our schools as has occurred in other cities; encourage business by offering subsidies, grants and forgivable loans; and engage our youth directly.",
  },
  {
    firstname: "Prenctice C.",
    lastname: "Butler",
    ballotorder: 6,
    "ward#": 4,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Chief of staff for 4th Ward alderperson",
    dob: "06/16/1980",
    civic:
      "UChicago, BA, MA; Loyola Univ. Chicago, MA; Leadership Greater Chicago 2022 fellow; UChicago Association of Black Alumni, president",
    candidatevideo: "",
    website: "https://www.prentice4ward.vote/",
    fb: "https://www.facebook.com/profile.php?id=100086281038231",
    twitter: "@prentice4ward",
    ig: "https://www.instagram.com/prentice4ward/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/prenticebutler",
    statement:
      "Public Safety: More funding for violence interrupters; hiring more public safety officers; mental health pilot programs. We have to connect our youth with jobs through workforce development opportunities. Quality Schools: The investment in our children is the largest investment we make and they have the right to attend quality neighborhood schools within walking distance from their homes. Government Transparency: Our elected officials should be fully focused on the needs of their constituents. The 4th Ward Advisory Council has started the process of providing the local community a mechanism to articulate their concerns.",
  },
  {
    firstname: "Tracey",
    lastname: "Bey",
    ballotorder: 2,
    "ward#": 4,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/TraceyYBeyfor4thWardAlderman/",
    twitter: "@beyfor4thward",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Desmon",
    lastname: "Yancy",
    ballotorder: 8,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Religious charity director",
    dob: "11/17/1971",
    civic:
      "Grassroots Alliance for Police Accountability, co-founder and lead strategist; worked with SEIU union to fight for $15/hr min wage.",
    candidatevideo: "",
    website: "https://www.yancyforthe5th.com/",
    fb: "https://www.facebook.com/profile.php?id=100087384380207",
    twitter: "@yancyforthe5th",
    ig: "https://www.instagram.com/yancy_for_the_5th/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/desmonyancy",
    statement:
      "Public safety, economic development and environmentalism are top issues in the ward. I will work with the community and both Chicago Police and Univ. of Chicago Police to make sure residents feel protected in the ward, and feel safe in their encounters with law enforcement. Regarding economic development, I will work with the various chambers of commerce to identify opportunities for small business creation and expansion to attract new businesses to our corridors. I will partner with the Army Corps Engineers and elected officials to prevent erosion of our shorelines, save Promontory Point, and prevent the flooding of our homes.",
  },
  {
    firstname: "Dialika “Dee”",
    lastname: "Perkins",
    ballotorder: 7,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Pro boxer",
    dob: "05/04/1981",
    civic:
      "Loyola Univ. Chicago, BBA; Little Brothers Friends of the Elderly, former volunteer; volunteer youth mentor; boxing coach",
    candidatevideo: "",
    website: "https://pickperkins.com/",
    fb: "https://www.facebook.com/Perkins.5thWardPeoplesChamp",
    twitter: "@5thpeopleschamp",
    ig: "https://www.instagram.com/5thwardpeopleschamp/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Top issues are public safety, housing and local development. My solution is to create a Community Patrol + Response team (CPRt), comprised of trained, ward-based paid/unpaid volunteers and employees. My CPR team will handle issues from littering to loitering to mental health crisis and initial medical response when needed, to missing children & pets. Local development will be speared by community ownership. Housing will be addressed through rent and property tax protections, creating co-op housing, working with property managers to address owner, tenant & neighbor concerns, and connecting those interested in homeownership with resources such as the TIF Rehab Purchase Program.",
  },
  {
    firstname: "Gabriel",
    lastname: "Piemonte",
    ballotorder: 10,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Self-employed",
    dob: "05/14/1968",
    civic:
      "Suffolk Univ., BA, communications/journalism; Italian American Heritage Society of Chicago, founder; Southside Center of Hope, former president; Save the Shrine NFP, founder",
    candidatevideo: "",
    website: "https://gabrielpiemonteforfifthwardalderman.com/",
    fb: "https://www.facebook.com/gabeforfive",
    twitter: "@gabrielpiemonte",
    ig: "https://www.instagram.com/gabeforfive/",
    tiktok: "https://www.tiktok.com/@gabrielpiemonte",
    youtube: "https://www.youtube.com/@gabeforfive",
    linkedin: "https://www.linkedin.com/in/gabriel-piemonte-45a0aa6a/",
    statement:
      "Economic and environmental justice are uniquely bound together in our ward and manifest as a housing crisis and a public safety crisis. Meanwhile, our unemployment rate is at least three times the citywide rate. The Obama Center project has triggered housing market instability and a massive influx of real estate speculators. Our ward, once known for its independence, has been controlled by Cook County Board President and Democratic Party Chair Toni Preckwinkle for a quarter century. We have a narrow window of opportunity to reclaim our independence and regulate the speculation and profit taking happening in our neighborhoods.",
  },
  {
    firstname: "Jocelyn",
    lastname: "Hare",
    ballotorder: 6,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Higher education administrator",
    dob: "10/02/1980",
    civic:
      "Univ. of Illinois U-C, BA, sociology; UChicago, MPP urban policy; Pride Action Tank; the Illinois Safe Schools Alliance; Youth Pride Center",
    candidatevideo: "",
    website: "https://www.hareforfive.com/",
    fb: "https://www.facebook.com/hareforchifive",
    twitter: "@HareForFive",
    ig: "https://www.instagram.com/hareforfive/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jocelynhare/",
    statement:
      "Based on my past six years of work with the South Side Housing Data Initiative, I firmly believe rising costs of living is the most pressing issue facing the 5th Ward. Safe, healthy, affordable housing — the foundation of thriving communities — is under major threat in Hyde Park, Woodlawn and South Shore. I will continue to work collaboratively with residents and stakeholders on strategies and policies that address this issue.",
  },
  {
    firstname: "Joshua",
    lastname: "Gray",
    ballotorder: 3,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Political consultant",
    dob: "08/25/1983",
    civic:
      "Sam Houston State Univ., BS; Cook County Juvenile Temporary Detention Center Advisory Board, chairman; Jackson Park Highlands Association, board member; CVLS Southeast Free Legal Clinic, founder",
    candidatevideo: "",
    website: "https://jgray.info/",
    fb: "https://www.facebook.com/BetterChicago",
    twitter: "",
    ig: "https://www.instagram.com/justjoshingyall/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/joshua-gray-a5194b6b/",
    statement:
      "The top issues in my ward are crime, community development and economic development. My office will work to create meaningful youth engagement that is accessible and varied while championing more support for existing organizations and developing a database of available programs. We will work to develop corporate partnerships to bolster job creation and bring more flagship retail to the ward. My administration will work with the police department to enact meaningful reforms and foster a better relationship among my constituents.  We will also work to create partnerships with developers to ensure there is more quality affordable housing throughout the ward.",
  },
  {
    firstname: "Kris",
    lastname: "Levy",
    ballotorder: 9,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Sales director",
    dob: "12/14/1971",
    civic:
      "Univ. of Illinois UC, BS, industrial engineering; Jack & Jill Chicago Chapter, Distinguished Dad of the Year",
    candidatevideo: "",
    website: "https://krislevyfor5th.com/",
    fb: "https://www.facebook.com/KrisLevyFor5th/",
    twitter: "@KrisLevyFor5th",
    ig: "https://www.instagram.com/kris_levy_for_5th/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issues facing my ward are public safety, mental health services, economic development and youth engagement. Public Safety: Enforced loitering laws in public places of commerce; community policing with foot patrol; and increased employment services for ex-offenders. Mental Health Services: Free substance abuse services; mobile crisis services; and youth mental health teams. Economic Development: Develop trade programs; tax incentives for local hires, and development of an arts/tourist industry. Youth Engagement: Increase job opportunities; sports and arts programs; and community mentors.",
  },
  {
    firstname: "Marlene",
    lastname: "Fisher",
    ballotorder: 2,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Information technology administrator",
    dob: "07/10/1972",
    civic:
      "Bradley Univ., BS, business computer systems; Nature, Culture, and Human Health Network Steering Committee, member; Habitat for Humanity community organizer; Greenwood Block Club, president",
    candidatevideo: "",
    website: "https://fisherfor5thward.com/",
    fb: "https://www.facebook.com/profile.php?id=100088143176827",
    twitter: "",
    ig: "https://www.instagram.com/fisherfor5thward/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/marlenefisher",
    statement:
      "Issues facing the ward and how I plan to address them: Affordable housing: increase affordable housing to 30% for new development, rental assistance, homeowner/condominium assistance for repairs, fully fund the roof and porch program, property tax reform. Financial literacy programs for recipients of grants for rental, homeowner and condominium assistance. Public safety: work with the community and CAPS, funds for violence prevention and victim support. Private patrolling security to supplement police. Economic investment: small business incubator in South Shore, trade school, universal basic income, small business assistance and support the Chicago Social Bonds program.",
  },
  {
    firstname: "Martina “Tina”",
    lastname: "Hone",
    ballotorder: 5,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Lawyer",
    dob: "10/21/1962",
    civic:
      "UChicago, BA; Univ. of California, Berkeley, JD; City of Chicago, Chief Engagement Officer; US House of Representatives; US Department of Commerce",
    candidatevideo: "",
    website: "https://hone5thward.com/",
    fb: "https://www.facebook.com/hone5thward",
    twitter: "@tinahone",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/martina-tina-hone-56b90a2/",
    statement:
      "The 5th Ward is a microcosm of our city. My priority is ending economic disparities at the root of our public safety crisis. We need thriving communities. Residents need jobs. Our youth need safe venues to be kids. We must close achievement gaps, restore trades education, and increase African American participation in construction unions. Affordable housing must be preserved alongside pathways to homeownership and protections for existing homeowners. We must address trauma, ensure equitable access to city services, restore reliable public transit, protect our environment, save the Point, and with 16 new alderpersons -- seize the opportunity to improve city government.",
  },
  {
    firstname: "Renita Q.",
    lastname: "Ward",
    ballotorder: 1,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Health care attorney",
    dob: "01/27/1977",
    civic:
      "DePaul Univ., JD; UChicago, MA; Univ. of Georgia, MA, BA, journalism; Cook County Circuit Court Criminal Division, clerk for judge",
    candidatevideo: "",
    website: "http://www.electrenitaward.com/",
    fb: "https://www.facebook.com/ElectRenitaQWard/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/renita-ward-2355482/",
    statement:
      "Top issues: Safety – I will collaborate to actualize an effective safety plan. This includes advocating that the CPD budget aligns with adequate number of police officers, and increased clearance rates. I will also support The Office for Gun Violence Prevention. Youth - I will advocate for funding for youth programs and ensure youth take full advantage of opportunities. Specifically, I mean maximizing on programs such as computer literacy, job training, and trauma resiliency. Economic Development - There are organizations in the 5th Ward that have well thought out economic development plans. I will work to help bring such plans to fruition.",
  },
  {
    firstname: "Robert",
    lastname: "Palmer",
    ballotorder: 4,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Teacher",
    dob: "11/12/1960",
    civic:
      "National Louis Univ., MA; Roosevelt Univ., BPS, psychology; LSC member, Special Olympics, football, basketball coach; Keller Athletic Association, past president",
    candidatevideo: "",
    website: "https://friendstoelectrobertpalmer.com/",
    fb: "https://www.facebook.com/profile.php?id=100088459154256",
    twitter: "@Palmer5th",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Crime: We need economic opportunities, mentorships, internships helping citizens with entrepreneur training. Work with the newly elected police board members and commanders of the police districts in ward; promote community policing. Lack of equitable services to all parts of the ward: Open up services to all parts of the ward. Will equitably use any discretionary funds in the most needed areas fairly. Fair Housing and displacement: The Obama Center may be a positive for the ward, but possibly causing displacement in the ward. We need to have a signed CBA from the Obama Foundation.",
  },
  {
    firstname: "Wallace",
    lastname: "Goode Jr.",
    ballotorder: 11,
    "ward#": 5,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "https://www.wallacegoode.com/",
    fb: "https://www.facebook.com/wallace.goode/",
    twitter: "@wallacegoodefa",
    ig: "https://www.instagram.com/wallacegoodeforalderman/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Aja",
    lastname: "Kearney",
    ballotorder: 8,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Unemployed",
    dob: "01/28/79",
    civic:
      "Univ. of Illinois U-C, BA; Local School Council member; member, CPS PAC; ​​former member, CPS PTA",
    candidatevideo: "",
    website: "https://ajakearney.com/",
    fb: "https://www.facebook.com/profile.php?id=100087578138051",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 6th ward is a vibrant community with a rich history. I envision focusing on neighborhood engagement by re-instituting block club organizations to combat the influx of crime and create a partnership with law enforcement agencies to make our neighborhoods safer. I envision helping small businesses flourish and working to draw new businesses to the ward. I envision bringing after-school programs to the schools and encourage the return of trades in schools to allow children the opportunity to be career-ready when they graduate. I envision increasing the housing stock in blighted areas.",
  },
  {
    firstname: "Barbara",
    lastname: "Bunville",
    ballotorder: 4,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Police technology support",
    dob: "01/13/1972",
    civic:
      "Argosy Univ., PhD; Chicago School of Professional Psychology, MS; board member, The Legacy Group of Chicago; board member, The DuSable Black History Museum and Education Center",
    candidatevideo: "",
    website: "https://friends4barbarabunville.com/",
    fb: "https://www.facebook.com/Friends4BarbaraBunville",
    twitter: "@Friends4Barbara",
    ig: "https://www.instagram.com/friends4barbara/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      'Fighting crime: To reduce violence, I support mandatory gun locks, advanced ballistics technology such as "microstamping," and frequent gun buyback events. To combat carjacking and theft, I support roving tactical and citywide safety teams to work in trouble spots. Increasing economic development: To attract development, I support the expansion of Accessory Dwelling Units, smaller lot sizes, and streamlined rezoning and permitting procedures. To increase density, I support purchasing and resale of vacant land by the Cook County Land Bank Authority. Reviving quality of life: Broken streetlights, dilapidated parks, and dirty streets will be repaired and cleaned regularly.',
  },
  {
    firstname: "Kimberly",
    lastname: "Egonmwan",
    ballotorder: 11,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Attorney and radio host",
    dob: "03/02/1976",
    civic:
      "UIC Law, JD; Univ. of Illinois U-C, BA; legislative director, O'Hare and Midway Airports, O'Hare Modernization Program, Illinois Department of Public Health; former chairman, Election Protection Initiative",
    candidatevideo: "",
    website: "https://www.kimforchicago.org/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/kimberley-egonmwan-esq-352b7513/",
    statement:
      "Economic development will be improved on. For failing schools, I'd demand answers — why aren't ward schools preparing children for math and reading proficiency? No more experimentation with Black schools. Make CPS raise educational standards in the ward to match other communities. On liveability/safety, I'd ensure speedy ward services. Residents call us, we'll call 311 to track progress of requests. I’d demand that residents are policed with the same respect as other wards and push policies to catch more criminals and protect innocent residents. I’d also recruit our neighbors to serve on the force. On economics, I'd sponsor policies giving residents capital for businesses and services in vacant storefronts, provide extra incentives if businesses employ residents and open the ward to developers.",
  },
  {
    firstname: "Kirby",
    lastname: "Birgans",
    ballotorder: 5,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Middle school science teacher",
    dob: "09/30/1983",
    civic:
      "Chicago State Univ., BS; Malcolm X College, AA; former candidate, U.S. Congress (IL-01); member: Black Men Build, Black Male Educators Alliance, Reclaim Chicago",
    candidatevideo: "",
    website: "https://www.friendsofkirbybirgans.com/",
    fb: "https://www.facebook.com/profile.php?id=100063972608094",
    twitter: "@kirby4the6th",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/kirby-birgans-12b6b176/",
    statement:
      "As a 7th grade science teacher and community activist, I see the impact of disinvestment and disenfranchisement that negatively impact the quality of life for Chicagoans. The top issues facing the 6th Ward are public safety, infrastructure, economic development, and housing affordability. I will ensure that our officers have support, while protecting civilian oversight. Flooding and deteriorating public works will be repaired or replaced using surplus TIF funds. To foster economic development, I will work to increase funding for job readiness programs. As a fierce proponent of the Bring Chicago Home ordinance, I will also fight to keep housing affordable.",
  },
  {
    firstname: "Patrick",
    lastname: "Brutus",
    ballotorder: 3,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "City planner",
    dob: "01/31/1970",
    civic:
      "Univ. of Illinois UC, MBA; former vice-president, Grand Crossing Park Advisory Council; member, DuSable Park Coalition; Local School Council, Lenart Elementary School and Ray Elementary School",
    candidatevideo: "",
    website: "https://www.patrickforthe6th.com/",
    fb: "https://www.facebook.com/Patrickforthe6th/",
    twitter: "@Patrick4the6th",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/patrick-brutus-74b30a7",
    statement:
      'The most important issues facing the ward are safety, the economic viability and sustainability of our commercial corridors, leadership, infrastructure and the quality of education being provided in our schools. 1) To restore the neighborhood and drive homebuyers into our Ward. We have a lot of available real estate (inventory) that are perfect opportunities for new homeowners, and I am hopeful that by working with realtors and brokers that together we can devise a marketing strategy to create a "we sell the 6th" residential revival. 2) Drive investment into our business districts and create new retail/commercial opportunities. This will create jobs for the unemployed and create destinations that will increase our local tourism and economy.',
  },
  {
    firstname: "Paul",
    lastname: "Bryson Sr.",
    ballotorder: 6,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Alderman assistant",
    dob: "12/25/1963",
    civic:
      "Lindblom Math and Science Academy; organized and helped lead The Fatherhood Initiative Program at Apostolic Church of God; active trustee at First Church of Deliverance",
    candidatevideo: "",
    website: "https://vote4bryson.com/",
    fb: "https://www.facebook.com/profile.php?id=100087713055641",
    twitter: "",
    ig: "https://www.instagram.com/friendsofpaulbryson/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The inequities in the city services being provided to the 6th ward residents is one of the biggest challenges. The change from ward based services to grid based services, led by the Rahm Emanuel administration, has caused the ward to be severely underserved. The grid based system has caused a lack of accountability in providing adequate services the residents need and deserve, and made it extremely challenging to properly maintain the ward’s cleanliness. Regular maintenance and cleaning of the ward is vital and will help improve economic development. As Alderman, I will advocate to bring back ward based service.",
  },
  {
    firstname: "Richard A.",
    lastname: "Wooten",
    ballotorder: 2,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Pastor",
    dob: "06/21/1965",
    civic:
      "Calumet College of St. Joseph, BAS; member, Illinois Farm Bureau; president, Greater Chatham Alliance, Fraternal Order of Police Lodge 7",
    candidatevideo: "",
    website: "https://wooten4us.com/",
    fb: "https://www.facebook.com/wooten4us",
    twitter: "@TeamRichWooten",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/richard-wooten-1a852459/",
    statement:
      "The top issues: Crime: Vote problem liquor establishments dry and moratorium on liquor licenses on day one. Fund block clubs and neighborhood watch organizations. Problem landlord tenant accountability meetings. Health and Wellness: Restore department of aging senior programs eliminated. Reopen mental health clinics and domestic violence resources. Education: Elected school board, and vacant school buildings. Economic Development: Obama Presidential Center Small Business Growth Initiative, Chamber of commerce, Food desert, and job growth. Community Engagement: Establish senior, youth, block clubs, and homeowners association councils and menu funding participation meetings.",
  },
  {
    firstname: "Sharon E.",
    lastname: "Pincham",
    ballotorder: 9,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "State senator staff member",
    dob: "08/07/1950",
    civic:
      "Chicago State Univ., BA; real estate broker, Chicago Association of Realtors; community representative; Local School Council Community, Gillespie Elementary School, Harlan Community Academy High School",
    candidatevideo: "",
    website: "https://www.sharonpincham.com/",
    fb: "https://www.facebook.com/sharon.pincham",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/sharon-banks-pincham-074a668/",
    statement:
      "Crime, economic disinvestment, and public schools are the top issues. These problems require a multifaceted solution. First, increase police hiring and redeployment with a public safety curriculum and a recruitment program through Chicago Public Schools and community colleges. Next, implement traditional apprentice trade programs in CPS along with 21st-century job skills curricula like cyber security and drone pilots. Third, state and federal resources do not efficiently reach the constituents of the 6th ward due to a lack of information and technical assistance needed to help individuals and businesses secure these funds. TIFs should be more effectively directed toward disadvantaged communities.",
  },
  {
    firstname: "Sylvester",
    lastname: "Baker Jr.",
    ballotorder: 1,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Tavares",
    lastname: "Briggs",
    ballotorder: 10,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Educator",
    dob: "03/01/1981",
    civic:
      "DePaul Univ., BS; committee member, US 7th Congressional District Legislative Education and Multi-Ethical Advisory; chair, Illinois House 10th District Campaign; community representative, Local School Council",
    candidatevideo: "",
    website: "https://www.briggsfor6thward.com/",
    fb: "",
    twitter: "@TavaresBriggs",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/tavares-briggs-6b705b87/",
    statement:
      "Public safety initiative: Expansion of Safe Passage Program days and hours; Neighbor Safety Zone Ordinances, bringing additional penalties for specific crimes; Expand neighborhood safety initiatives such as Community org. ECCSC and other violence prevention organizations; Incentivize Block Club formation and invest in community organizing. School Quality improvement Plan: Expansion of programs and services provided to families; Invest in the expansion of MTSS resources; Effective Social Emotional Learning Curriculum by implementing a curriculum that is adaptable and relatable in all communities to increase effectiveness; Mandatory trauma supports and services for all students CPS or charter that have been victims of crimes; Support funding increases for schools; Support school building renovations",
  },
  {
    firstname: "William",
    lastname: "Hall",
    ballotorder: 7,
    "ward#": 6,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Pastor",
    dob: "6/12/1984",
    civic:
      "Harold Washington City College, AA, BS; DePaul Univ., MDiv.; Urban League Fellow; WVON 40 Under 40; Dr. Martin Luther King Board of Preachers Inductee",
    candidatevideo: "",
    website: "https://www.williamhallfor6.com/",
    fb: "https://www.facebook.com/FriendsofWilliamE.Hall",
    twitter: "",
    ig: "https://www.instagram.com/williamhallfor6/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 6th Ward has suffered from a lack of investment and equity. The 6th Ward deserves the same level of city services as any other zip code. While public safety is now a concern throughout the city it has been a concern that the 6th ward has dealt with for far too long. A lack of fully funded schools and mental health services only exacerbates the issue. No investment in human life leads to broken lives. The city budget must address these items NOW. The priorities of downtown and other communities should not trump the concerns of 6th ward residents.",
  },
  {
    firstname: "Gregory",
    lastname: "Mitchell",
    ballotorder: 1,
    "ward#": 7,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "http://friendsofgregmitchell.com/",
    fb: "https://www.facebook.com/AldGregMitchell/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Linda",
    lastname: "Hudson",
    ballotorder: 3,
    "ward#": 8,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Tax consultant",
    dob: "04/26/1962",
    civic: "Chicago State Univ., BA",
    candidatevideo: "",
    website: "http://www.lindafor8.com/",
    fb: "https://www.facebook.com/lindahudson.8ward",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "https://www.youtube.com/@lindahudson8827",
    linkedin: "",
    statement:
      "The 8th Ward faces issues of crime, economic development, and no strategic plan. In two years, this once prosperous community will be the gateway to the Obama Center. Sadly, visitors will see nothing but blocks of boarded up businesses. Add an uptick in crime to the dilapidation, and they will see what we feel -- terrorized. Poor leadership and lack of effective communication have hindered economic development and a sense of community. I am committed to creating a Leadership Council, holding regular community meetings, courting new/established businesses and making the Obama Center safe for our residents and visitors. The council will explore and research new and innovative concepts in safety including community policing and dramatically expand the reach of drones and license plate readers which have proven to be effective tools in combating crime.",
  },
  {
    firstname: "Michelle A.",
    lastname: "Harris",
    ballotorder: 1,
    "ward#": 8,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "12/13/1961",
    civic:
      "Chicago State Univ., BA; 8th Ward Democratic Committeeperson; State Central Democratic Committeeperson, 1st Congressional District; current chair, City Council Committee on Committees and Rules",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/aldermanharris/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public safety and economic development are top issues. I will continue working with my four police districts in implementing sound block level community policing strategies, while engaging residents on safety measures to better protect themselves and their property, including attending Police Beat meetings. I will also continue to leverage public and private funds, such as INVEST South/West Initiative, TIF and SBIF, to invest in business and residential development in the ward. I will continue to convene community meetings as residents seeking information are cognizant of the role government should play to help improve their quality of life.",
  },
  {
    firstname: "Sean",
    lastname: "Flynn",
    ballotorder: 2,
    "ward#": 8,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Government staffer",
    dob: "12/05/1975",
    civic:
      "UIC, BA, MPA; former assistant, Ald. Leslie Hairston; former Chief of Staff, Ald. David Moore; former mentor, By the Hand Club",
    candidatevideo: "",
    website: "https://flynnfor8th.com/",
    fb: "https://www.facebook.com/people/Elect-Sean-Flynn/100085652552484/",
    twitter: "",
    ig: "https://www.instagram.com/flynnfor8th/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/mrseanmflynn/",
    statement:
      "Community Engagement: I plan to host a series of safe events that allow community residents to get out and together. From live music events, financial literacy workshops, monthly town hall meetings, educational events about our local history, yoga in the park, Zumba classes, tax preparation seminars, and CPR training. Crime: I will push to have police officers more accessible in the community - from walking beats, to bike patrols or riding pedways. I will have town hall meetings where beat officers are present and introduce themselves to the community. Economic Development: I will solicit several big box retailers, chain businesses, and local business owners that would be a great fit for the 8th Ward.",
  },
  {
    firstname: "Anthony A.",
    lastname: "Beale",
    ballotorder: 2,
    "ward#": 9,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "10/22/1967",
    civic: "Little league baseball coach; 25 years as alderperson",
    candidatevideo: "",
    website: "https://www.ward09.com/",
    fb: "https://www.facebook.com/AldBeale/",
    twitter: "@Alderman_Beale",
    ig: "https://www.instagram.com/aldbeale/?hl=en",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Employment and public safety are, as they always have been, the top issues in Ward 9. That said over the past eight years, we have made great progress — we have added 2,000 new jobs, attracting Amazon, Method, SC Johnson, Gotham Greens, Whole Foods Midwest Distribution Center, the National Park, two Black owned restaurants and a Potbelly restaurant to the ward, along with a vibrant shopping center, anchored by a union-built Walmart, and brought more than $500 million in investment for businesses, new housing and homes, improvement of schools and parks and the creation of the largest community/education/recreation center in Chicago.",
  },
  {
    firstname: "Cameron",
    lastname: "Barnes",
    ballotorder: 3,
    "ward#": 9,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "04/03/1998",
    civic:
      "Central State Univ., BS; former National Youth Director, Rainbow PUSH",
    candidatevideo: "",
    website: "https://cameronfor9.com/",
    fb: "",
    twitter: "@Cameronfor9",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/cameron-barnes-63506a135/",
    statement:
      "We are in dire need of economic development in the 9th Ward, development that will not displace black constituents, as it has for the last three decades. We must revitalize without gentrifying. Our education system needs to be brought to the 21st century with STEM, coding, robotics and investment in trades for college alternatives to ensure our students can competitively enter the workforce. Lastly, we need to reprioritize our resource allocation to ensure that 9th ward constituents are not continuously left out and have an equitable reach at necessary resources and opportunities they are owed.",
  },
  {
    firstname: "Cleopatra",
    lastname: "Draper",
    ballotorder: 1,
    "ward#": 9,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Community organizer",
    dob: "03/27/1987",
    civic:
      "UIC, MS; Eastern Illinois Univ., BA; founder, Roses in Roseland; former delegate candidate, Elizabeth Warren; community representative, Local School Council, Corliss High School",
    candidatevideo: "",
    website: "https://votecleopatra.com/",
    fb: "",
    twitter: "@FollowCleopatra",
    ig: "https://www.instagram.com/followcleopatra/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/yourfavoritemillennial/",
    statement:
      'On behalf of many residents in the 9th ward, we are not poor, we have poor leadership. We want more than anything, to overcome food insecurity, equitable economic development, affordable housing, and healthcare services. In other words, we want a community that consists of a 15-minute walk to improve our quality of life. My plan is to welcome, support, and work across city government to help fund the stability of small owned and operated businesses that will increase fresh food and produce access. The incubation of "ma & pop" grocers is our safest investment.',
  },
  {
    firstname: "Ana",
    lastname: "Guajardo",
    ballotorder: 3,
    "ward#": 10,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Organizer and consultant",
    dob: "01/08/1979",
    civic:
      "Univ. of Minnesota, MA; Chicago State Univ., BA; former president, Hispanic/Latinx Employment Plan Advisory Council; member, Local School Council, John Marsh Elementary School",
    candidatevideo: "",
    website: "https://www.anafor10.com/",
    fb: "https://www.facebook.com/AnaForAlderwoman/",
    twitter: "@AnaAlderwoman",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/ana-guajardo-625166123/",
    statement:
      "Public safety: dedicated patrol units and fire trucks for the 10th Ward. Hire more detectives to improve the clearance rate. Solving more crimes will restore trust within the community and increase morale within the department. Invest in officer wellness — our officers are working too much overtime. Restoring staffing levels will reduce burnout. Respond to emergencies with appropriate services. Mental health emergencies deserve a mental health approach. Education: Our community deserves fully funded neighborhood schools with counselors, nurses, and smaller classroom sizes. Our ward currently needs several new school buildings.",
  },
  {
    firstname: "Jessica A.",
    lastname: "Venegas",
    ballotorder: 2,
    "ward#": 10,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Police officer and attorney",
    dob: "06/06/1981",
    civic:
      "UIC Law, JD; DePaul Univ., BA; volunteer, Cub Scouts, East Side Chamber of Commerce; co-founder of Tia & Gramma Organization",
    candidatevideo: "",
    website: "https://community4venegas.com/",
    fb: "https://www.facebook.com/profile.php?id=100085839256960",
    twitter: "",
    ig: "https://www.instagram.com/communityforvenegas/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "When it comes to public safety, I will advocate for stronger crime response and develop programs to help youth find meaningful activities and a positive path in life. In order to resolve our economic issues I will advocate for less tax increases and seeking other funding to fill economic gaps. I will address the educational infrastructure issue by advocating for increases in our school budgets and seeking out other funding opportunities for our schools. To help solve our environmental issues I will ensure that there is proper vetting of any new building in the 10th Ward ensuring the health and safety of our residents.",
  },
  {
    firstname: "Oscar",
    lastname: "Sanchez",
    ballotorder: 5,
    "ward#": 10,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Urban planner",
    dob: "",
    civic:
      "Harold Washington College, AA; Local School Council, George Washington High School",
    candidatevideo: "",
    website: "https://oscarfor10.com/",
    fb: "https://www.facebook.com/people/Oscar-for-10/100085555112127/",
    twitter: "@oscarfor10",
    ig: "https://www.instagram.com/oscarfor10/",
    tiktok: "https://www.tiktok.com/@oscarfor10",
    youtube: "",
    linkedin: "",
    statement:
      "We have issues of public safety, food and transit accessibility related to economic insecurity and housing insecurity. In order to address these issues we must create co-governance so community members have a say in the budgeting and zoning that impact their livelihood. Co-governance and organizing are essential to building power and uniting our communities. I plan to introduce the first Cumulative Environmental Impacts Ordinance to prioritize the health and well-being of our residents and end sacrifice zones. Alongside, re-establishing the Department of the Environment and implementing policies to shift us to a green economy.",
  },
  {
    firstname: "Peter",
    lastname: "Chico",
    ballotorder: 1,
    "ward#": 10,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Police officer",
    dob: "01/03/1983",
    civic:
      "DePaul Univ., MA; Benedictine Univ., BA; community representative, George Washington High School; board Member of Hegewisch Bulldogs Football Organization",
    candidatevideo: "",
    website: "https://www.chicofor10.com/",
    fb: "https://www.facebook.com/chicofor10/",
    twitter: "@chicofor10",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issues are public safety and economic development. I work as a police officer in the 004th District, which has about 90% of the 10th Ward. I know the strategies we can use to create more police presence to make residents feel safer. We will also need to create safe spaces at our local high schools for the entire community until we can locate and raise funds for community centers. When it comes to economic development, we need to create a special tax district because we cannot compete with Indiana. It is time to recognize something needs to happen.",
  },
  {
    firstname: "Yessenia",
    lastname: "Carreón",
    ballotorder: 4,
    "ward#": 10,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Media executive",
    dob: "08/09/1982",
    civic:
      "Community liaison and special events coordinator for former 10th Ward Alderman John Pope; former board member, South Chicago Chamber of Commerce; board member, South Chicago Development Commission",
    candidatevideo: "",
    website: "https://yessfor10.com/",
    fb: "https://www.facebook.com/yessfor10",
    twitter: "@yessfor10",
    ig: "https://www.instagram.com/yessfor10/",
    tiktok: "https://www.tiktok.com/@yessfor10",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/yesseniacarreon",
    statement:
      "Our top issues are economic development and safety. Our top priority is to rebuild our\nbusiness districts by empowering our chambers and business associations. We need to attract new businesses and capital investment so that more jobs can be created and local entrepreneurs can thrive. Invest in existing infrastructure to attract and encourage potential businesses. My extensive experience in economic development combined with my ability to use social media is what is needed to help stimulate local economic growth for our current local businesses. With a thriving business district and working economic plan, our safety problem gets addressed as well.",
  },
  {
    firstname: "Ambria",
    lastname: "Taylor",
    ballotorder: 2,
    "ward#": 11,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Middle school social studies teacher",
    dob: "10/22/1987",
    civic:
      "UChicago, MA; Shimer College, BA; volunteer, Benton House Community Center; union delegate for CTU",
    candidatevideo: "",
    website: "https://ambriaforalderman.com/",
    fb: "https://www.facebook.com/ambria.n.taylor",
    twitter: "@AmbriaTaylor",
    ig: "https://www.instagram.com/ambriaforalderman/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Ambria is the only progressive running in the 11th Ward. She’s politically independent, hard-working, and practical — like the people she will represent. Ambria will create committees with resident representatives to make sure there is a formal way for community-based decision making and transparency. There will be an organized system for responding to calls and complaints from residents, rather than the hit-or-miss way it’s handled now. Multilingual access to services is a priority. On City Council, Ambria will not be a rubber stamp for the mayor, no matter who that person is. She will fight for good city staffing so that our schools, parks, libraries, and infrastructure function like they should.",
  },
  {
    firstname: "Anthony",
    lastname: "Ciaravino",
    ballotorder: 1,
    "ward#": 11,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "https://www.anthony11thward.com/",
    fb: "https://www.facebook.com/profile.php?id=100088646266072",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Don",
    lastname: "Don",
    ballotorder: 7,
    "ward#": 11,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Firefighter",
    dob: "08/25/1975",
    civic:
      "Chicago Fire Academy graduate; co-founder, Chinatown/Bridgeport Neighborhood Watch groups; former Chicago Firefighters Local 2 Union Steward",
    candidatevideo: "",
    website: "https://www.dondonfor11.org/",
    fb: "https://www.facebook.com/profile.php?id=100086238284171",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "As one of the co-founders of the Chinatown/Bridgeport Watch groups, I will continue our missions to educate the community on the importance of working together with the Chicago Police Department; advocating for additional resources which would include more officers and technological means such as functional podcams to meet the needs of the community. If the increase of crime is not prioritized, the quality of life for the residents and visitors of the 11th Ward will continue to be diminished. Without people in the ward, that decrease will impact the vitality of businesses from prospering resulting in urban decay.",
  },
  {
    firstname: "Elvira “Vida”",
    lastname: "Jimenez",
    ballotorder: 3,
    "ward#": 11,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Self-employed",
    dob: "12/13/1957",
    civic:
      "Realtors Real Estate School, licensed appraiser; community representative, CAPS; president, We Can Community Block Club, United American Latino Organization; volunteer, Chinatown Chamber of Commerce",
    candidatevideo: "",
    website: "https://vidachicago2023.com/",
    fb: "https://www.facebook.com/profile.php?id=100086284510251",
    twitter: "@VIDACHICAGO2023",
    ig: "https://www.instagram.com/VidaChicago2023/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I am a lifelong resident of Bridgeport and I believe my experience in life, in business, as a community volunteer and as a crime prevention activist provide me with a deep understanding of the people, organizations and business community in the 11th Ward. The biggest problems we face are crime, rising property taxes threatening generational wealth transfers, and disorganized economic development planning. The 11th Ward is one of the most demographically diverse wards in the city and I will use the power of my office to make us safer, more prosperous and more inclusive of every resident and family.",
  },
  {
    firstname: "Froylan “Froy”",
    lastname: "Jimenez",
    ballotorder: 5,
    "ward#": 11,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Teacher and basketball coach",
    dob: "04/04/1976",
    civic:
      "Univ. of Liverpool, MPA; National Louis Univ., MA; member, Local School Council Advisory Board; legislative issues staff for Speaker Michael J. Madigan; chief of staff for State Senator Chuy Garcia",
    candidatevideo: "",
    website: "https://www.froyjimenez11.com/",
    fb: "https://www.facebook.com/froylan.jimenez.733",
    twitter: "@Helptaxpayers",
    ig: "https://www.instagram.com/helptaxpayers/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "As a CPS civics teacher, with state legislative experience, I'm all about good government, improving public safety and helping overburdened taxpayers. I'm not afraid to call out bad public decisions by the mayor, the Democratic party, CTU, Democratic Socialists, or any other powerful insiders in order to change our ward and city for the better. Solutions to crime and exaggerated taxes require an alderman that is an Independent thinker, looks for input, and has the courage to stand up to anybody that gets in the way of good government and fair services.",
  },
  {
    firstname: "Nicole",
    lastname: "Lee",
    ballotorder: 4,
    "ward#": 11,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "12/23/1974",
    civic:
      "UChicago, MPP; Indiana Univ., BS; member, UIC Asian American Advisory Council; former chair, Local School Council, Haines Elementary School",
    candidatevideo: "",
    website: "https://votenicolelee.com/",
    fb: "https://www.facebook.com/votenicolelee11",
    twitter: "@votenicolelee11",
    ig: "https://www.instagram.com/votenicolelee11/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/nicolelee888/",
    statement:
      "Public safety is the most important issue for residents; people want safer streets and less crime. This is a complex issue, but I believe the best ways to address it include continuing investment in the Chicago Police Department through a focus on recruitment, retention and better services to help our officers; improving local infrastructure through well-lit streets and tools for calming traffic; and increasing economic and educational opportunities in underserved neighborhoods. Residents want an alderman they can rely on. While in office, I’ve shown I’m committed to transparency, open communication, fighting for more resources, and responding to constituent concerns.",
  },
  {
    firstname: "Steve",
    lastname: "Demitro",
    ballotorder: 6,
    "ward#": 11,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Lawyer",
    dob: "07/05/62",
    civic:
      "UIC, JD, BA; VP Ukrainian National Museum; former chair, Illinois Educational Funding Advisory Board",
    candidatevideo: "",
    website: "https://demitrofor11thward.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Some of the issues in the 11th Ward: crime, city services, property taxes and education.Plan for our community: Safer Community – Revamp CAPS program and add more police officers. Police officers will walk neighborhood beats. Benefits include but not limited to; (1) Increased visibility. (2) Improved relationships. (3) Opportunity to observe and identify potential problems. Better city service, including extra clean up in alleys and streets. Vocational schools provide skills for good paying jobs in the trades without college debt. Lower property taxes – Increased homeowners exemptions for specific groups of individuals. Experts review ways to cut city waste and pass on to homeowners.",
  },
  {
    firstname: "Anabel",
    lastname: "Abarca",
    ballotorder: 2,
    "ward#": 12,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "09/21/1985",
    civic:
      "Loyola Univ. Chicago, JD; Arizona State Univ., MPA; former chief of staff for Ald. George Cardenas; former congressional aide for Rep. Mike Quigley",
    candidatevideo: "",
    website: "https://anabelfor12.com/",
    fb: "https://www.facebook.com/AlderwomanAbarca",
    twitter: "@Anabelfor12",
    ig: "https://www.instagram.com/anabelafor12/",
    tiktok: "",
    youtube: "",
    linkedin: "https://linkedin.com/in/anabelabarca",
    statement:
      "Public safety, education, business development, and infrastructure are the most important issues in the 12th Ward. I plan on taking a collaborative and hands on approach to all four of them. This means working with stakeholders as well as neighboring wards.",
  },
  {
    firstname: "Julia",
    lastname: "Ramirez",
    ballotorder: 1,
    "ward#": 12,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "School administrator",
    dob: "04/19/1991",
    civic:
      "Northeastern Illinois Univ., BS, MS; organizer, Back of the Yards Neighborhood Council; former fundraiser, Increase the Peace; former member, Latinos Progresando and Instituto del Progreso Latino",
    candidatevideo: "",
    website: "https://www.ramirezfor12.com/",
    fb: "https://www.facebook.com/Ramirezfor12",
    twitter: "@Ramirezfor12",
    ig: "https://www.instagram.com/ramirezfor12th/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public safety, government transparency and environmental justice are the top issues in our ward. I have a holistic approach to public safety that provides short and long term goals to assist in reducing violence, while providing resources as a prevention measure to address the root causes of violence. For decades, our communities have been left out of key decision making. I will establish community-driven zoning and participatory budgeting processes to ensure community stakeholders are involved in decision making. This lack of community involvement is what led to corporate polluters, like MAT Asphalt, to reside in our communities despite community opposition.",
  },
  {
    firstname: "Marty",
    lastname: "Quinn",
    ballotorder: 1,
    "ward#": 13,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "12/07/1974",
    civic: "St. Xavier Univ., BA, sociology",
    candidatevideo: "",
    website: "https://www.martyandangie.com/",
    fb: "https://www.facebook.com/MartyQuinn13Ward/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issue facing the 13th Ward is creating a place where people are safe, want to raise their families and set down roots. I create and support policies that ensure our streets are safe, first responders are supported, and strong educational and job opportunities exist. I do this by providing exceptional constituent services. I am working with residents to create a new local police district to better serve the community. I oversaw nearly $300 million investment in 13th Ward schools, including the first selective enrollment high school on the Southwest Side.",
  },
  {
    firstname: "Paul",
    lastname: "Bruton",
    ballotorder: 2,
    "ward#": 13,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Parent",
    dob: "04/17/1986",
    civic:
      "Northwestern Univ., MPPA; UChicago, BA; former analyst, Chicago Office of the Inspector General; president, associate board, Chicago Public Library Foundation",
    candidatevideo: "",
    website: "https://www.brutonforchicago.com/",
    fb: "https://www.facebook.com/groups/brutonforward13",
    twitter: "@BrutonforWard13",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/paul-bruton-ab876613/",
    statement:
      "The 13th Ward deserves an honest government that serves everyone. For too long, the 13th Ward has been controlled by a political organization that bullies residents, rewards insiders, and leaves anyone who doesn’t play ball out in the cold. We deserve an alderman who will work collaboratively with neighbors to improve safety, fight corruption, and invest in our neighborhoods. If elected, I will tackle Chicago’s big problems head on, treat all of our neighbors with respect, restore public trust in city government, and work every day to make the 13th Ward — and the city of Chicago — the best it can be.",
  },
  {
    firstname: "Jeylú B.",
    lastname: "Gutiérrez",
    ballotorder: 1,
    "ward#": 14,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Cook County employee",
    dob: "09/05/1987",
    civic:
      "Instituto Tecnológico de Monterrey, BA; Kendall College, BA; Universidad del Valle de Mexico, AA; former member, Local School Council at Irene Hernandez Middle School",
    candidatevideo: "",
    website: "https://www.jeylugutierrez.com/",
    fb: "https://www.facebook.com/jeylufor14/",
    twitter: "@JeyluFor14",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "As alderperson, public safety, education, and providing quality and timely mannered city services, will be my top priorities. We can increase public safety efforts through violence prevention, youth engagement programs, workforce opportunities, and mental health support. Improving access to quality education from early childcare to post-secondary education through strategic coordination across educational institutions and systems are fundamental. Additionally, the city must be true to its values as a welcoming city and protect immigrants, regardless of country of origin or status. We also must also continue to protect worker rights through the right to organize and improve workplace conditions.",
  },
  {
    firstname: "Raul",
    lastname: "Reyes",
    ballotorder: 2,
    "ward#": 14,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/ReyesFor14",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Gloria A.",
    lastname: "Williams",
    ballotorder: 3,
    "ward#": 15,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Religious charity coordinator",
    dob: "06/24/1965",
    civic:
      "Chicago State Univ., BS; Northern Seminary, MA; president, founder of Voices of West Englewood; member, Quality of Life Plan in the Greater Englewood Community",
    candidatevideo: "",
    website: "https://gloriawilliamsfor15.com/",
    fb: "",
    twitter: "@Gloriafor15",
    ig: "https://www.instagram.com/gloriafor15/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "As a long-time resident of the 15th ward, I have a deep understanding of the issues and challenges facing our community, which are many to say the least. I have a proven track record of working hard to address these issues like food insecurity, abandoned properties, vacant lots, homelessness, crime and public safety, unemployment, mental illness, and lack of valuable resources. In addition, I'm a leader who has a history of getting things done. I have a strong record of collaborating with community organizations and local leaders to find solutions to the challenges we face, because I believe progress is a collective effort and that it takes a village to bring about a change.",
  },
  {
    firstname: "Raymond",
    lastname: "Lopez",
    ballotorder: 1,
    "ward#": 15,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "05/26/1978",
    civic:
      "15th Ward Democratic committeeman; member, Holy Name of Jesus Society; supporter, Boy Scouts of America; member, Canaryville Veterans Association",
    candidatevideo: "",
    website: "https://www.withray2023.com/",
    fb: "https://www.facebook.com/AldermanRaymondLopez/",
    twitter: "@RLopez15thWard",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 15th Ward is a diverse ward of multiple neighborhoods spanning the southwest side of Chicago. Public safety is the number concern of residents, particularly in new areas of the ward where troubled buildings and gang conflicts have gone unanswered. The unequal delivery of city service and investment is another major concern. My two terms in office have proven I know how to address these concerns in a methodical and fair way. I will continue to lead by bringing all communities together based on shared values and common sense.",
  },
  {
    firstname: "Victoria",
    lastname: "Alvarez",
    ballotorder: 2,
    "ward#": 15,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Ward chief of staff",
    dob: "06/18/88",
    civic: "UChicago, BA; founder, South Side Mutual Aid Solidarity",
    candidatevideo: "",
    website: "https://vickofor15.com/",
    fb: "https://www.facebook.com/VickoFor15/",
    twitter: "@VickoFor15",
    ig: "https://www.instagram.com/vickofor15/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issues facing the 15th ward are infrastructure delays, inequitable neighborhood services, and lack of investment in public resources. Our ward remains gerrymandered and it has resulted in extensive favoritism and divided neighborhoods. I will use my experience as Chief of Staff of the 33rd Ward and my familiarity with city departments to process all requests expeditiously and provide real transparency into our ward infrastructure budget. I will have clear communication with neighbors about my priorities for the city budget every year and push investments where they need them most including reopening our mental health clinics and schools.",
  },
  {
    firstname: "Carolynn",
    lastname: "Crump",
    ballotorder: 1,
    "ward#": 16,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Police officer",
    dob: "10/07/1975",
    civic:
      "Argosy Univ., PhD; Saint Xavier Univ., MA; Saint Xavier Univ., MBA; Univ. of Illinois U-C, BA",
    candidatevideo: "",
    website: "http://www.drcarolynncrump.org/",
    fb: "https://www.facebook.com/profile.php?id=812345062",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/dr-carolynn-d-crump/",
    statement:
      'Combating high crime rates. I support: mandatory gun locks, advanced ballistics technology such as "microstamping," and more gun buyback events to reduce violence; strengthening patrols in high crime areas with roving tactical and citywide safety teams consisting of CPD officers and sheriff’s deputies; increasing information sharing between law enforcement agencies to track and reduce carjackings. Strengthening residential and business development. I support: expanding Accessory Dwelling Units, permitting smaller lot sizes, and streamlining rezoning and permitting procedures; increasing funding for local government purchases and resale of vacant land; helping income-qualified homebuyers with down payment assistance.',
  },
  {
    firstname: "Eddie",
    lastname: "Johnson III",
    ballotorder: 3,
    "ward#": 16,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "School administrator",
    dob: "02/27/1979",
    civic:
      "Northeastern Illinois Univ., BA; Northern Seminary, MA; former PAC co-chair, NAACP Chicago Southside Branch;  former subcommittee chairperson, advisor, 7th District CAPS; SEIU Local 73 union steward",
    candidatevideo: "",
    website: "https://www.eddie16thward.com/",
    fb: "https://www.facebook.com/eddie16thward",
    twitter: "@EddieJohnsonlll",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 16th Ward is seriously suffering and the quality of life for 16th Ward residents isn’t improving. We need money for infrastructure, education, community services, and public safety. We must end the ongoing gun violence that has spawned an epidemic norm in the 16th Ward for too many years. As 16th Ward alderperson I will address the lack of economic opportunities and affordable housing opportunities for current families. The top issues facing the 16th Ward are public safety and lack of economic/jobs opportunities for residents.",
  },
  {
    firstname: "Stephanie",
    lastname: "Coleman",
    ballotorder: 2,
    "ward#": 16,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "04/13/1987",
    civic:
      "Spertus Institute, MA; Robert Morris Univ., BA; 16th Ward Democratic committeeperson; aide to former Cook County Commissioner Dennis Deer",
    candidatevideo: "",
    website: "https://stephaniedcoleman.com/",
    fb: "https://www.facebook.com/AldermanStephanieDColeman",
    twitter: "",
    ig: "https://www.instagram.com/stephaniedcoleman/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/stephanie-coleman-720385a4/",
    statement:
      "In four years as the voice for all 16th Ward residents in City Hall, my approach has always been community first. While I have worked tirelessly to improve lives throughout our city – providing funding for violence prevention programs and affordable housing among many other measures – the residents of my ward have always been front and center. I go to bat for ward residents every single day, from advocating for economic development projects such as the innovative Englewood Connect community hub, to sponsoring Englewood’s first music festival to building affordable housing for our seniors. We must continue our progress.",
  },
  {
    firstname: "David",
    lastname: "Moore",
    ballotorder: 1,
    "ward#": 17,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "02/21/1966",
    civic:
      "Western Illinois Univ., BA; Loyola Univ. Chicago, MA; member, Rainbow PUSH Coalition; board member, Kodero Hunter “MVP” Foundation; deacon, Fellowship Missionary Baptist Church",
    candidatevideo: "",
    website: "https://citizensformoore.com/",
    fb: "https://www.facebook.com/profile.php?id=100064140667699",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Top issues in the 17th Ward are: economic development, crime and cleanliness. Economic development: working with the administration to have a greater focus on the Englewood community to get a new field house at Ogden Park and redeveloping 69th St., between Damen and Ashland, which has a large number of vacant lots allowing us to issue a RFP. Crime: make sure aldermen get a police car when they call in criminal activity in each district. Cleanliness: continue to push for passage of my Keep Chicago Clean Campaign Ordinance.",
  },
  {
    firstname: "Derrick G.",
    lastname: "Curtis",
    ballotorder: 1,
    "ward#": 18,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "06/03/1968",
    civic:
      "Former Democratic committeeman, precinct captain and coordinator; former union member: Teamsters, FOP, AFSCME; president of two Local School Councils",
    candidatevideo: "",
    website: "https://www.derrickgcurtis.com/",
    fb: "https://www.facebook.com/derrick.curtis.18",
    twitter: "@aldcurtis18",
    ig: "https://www.instagram.com/aldermancurtis18/",
    tiktok: "",
    youtube: "https://www.youtube.com/channel/UCH8hsCz02M5HnHvDxaFMFYw/videos",
    linkedin: "",
    statement:
      "Issue 1 is public safety. I will work to increase police patrols, and take measures to decrease speeding and drag racing issues. Issue 2 is arterial street maintenance. Three large intermodal transport hubs cause heavy truck traffic. I will advocate for more state/federal infrastructure funds to maintain the structural integrity and prohibit excessive train whistle noise. Issue 3 was having a food desert. I brought a grocery store chain into the community along with new real estate developments. Finally, I am leading the plans for revitalization of the last Chicago indoor mall, Ford City Mall.",
  },
  {
    firstname: "Heather",
    lastname: "Wills",
    ballotorder: 2,
    "ward#": 18,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Labor organizer",
    dob: "07/15/1986",
    civic:
      "Chicago Theological Seminary, MA; Saint Xavier Univ., MBA; Univ. of Illinois U-C, BS; 18th Ward Aldermanic Office Community Representative; member, OPEIU Local 9",
    candidatevideo: "",
    website: "https://www.willsfor18.com/",
    fb: "https://www.facebook.com/WillsFor18",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issues in the 18th Ward are the need for community engaged public safety, developing infrastructure, and advancing community resources. Our solutions are increasing and engaging with block clubs, neighborhood watch programs, enhancing our civic organizations, developing participatory budgeting, and ensuring better educational and mental health resources are available. As well, our ward needs progressing CAPS programs, cultivated relationships with the new ECPS councils, expansion of the Additional Dwelling Unit Ordinance, and more livable wage jobs.",
  },
  {
    firstname: "Matthew J.",
    lastname: "O'Shea",
    ballotorder: 2,
    "ward#": 19,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "08/26/1969",
    civic:
      "St. Mary’s Univ., BA; current vice president, board of directors of Special Olympics Chicago; board member: John McNicholas Pediatric Brain Tumor Foundation, Chicago Police Memorial Foundation",
    candidatevideo: "",
    website: "https://mattoshea.net/",
    fb: "https://www.facebook.com/mattoshea19",
    twitter: "@mattoshea19",
    ig: "https://www.instagram.com/oshea_matt/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Crime is the top issue facing the 19th Ward and addressing it will require a comprehensive approach that includes increased staffing levels at CPD, and investment in new technology including cameras, license plate readers (LPRs), and helicopters. Simultaneously, we need to provide resources to data driven violence prevention programs with a track record of success. These programs can help address the root causes of crime. In the 19th Ward, I’ve expanded our camera network and funded a private security pilot program. I’ve also partnered with mentoring programs like Becoming a Man to help young people make positive choices.",
  },
  {
    firstname: "Michael T.",
    lastname: "Cummings",
    ballotorder: 3,
    "ward#": 19,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Small business owner",
    dob: "11/02/1958",
    civic:
      "St. Xavier Univ., BA; Glenmary Mission volunteer to Frenchburg, Kentucky; volunteer, Mercy Home for Boys and Girls; volunteer, Chicago Police Memorial",
    candidatevideo: "",
    website: "https://www.cummings19thward.com/",
    fb: "https://www.facebook.com/profile.php?id=100086092747631",
    twitter: "@cummings_4_19th",
    ig: "https://www.instagram.com/cummings_4_19th/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public safety is the number issue in our ward and in our city. I will use my 35 years of police experience to restore public safety and rebuild CPD. I will implement policies that will support our police officers, such as a desirable work schedule with mandatory time off. These policies will make CPD a more desirable department for recruits to work and veteran officers to continue their employment. I will eliminate the bureaucracy so officers who want to return from a leave of absence can do so immediately. Economic development is also a concern for our ward. I will assemble an experienced team to address the issues and revitalize our business corridors.",
  },
  {
    firstname: "Tim",
    lastname: "Noonan",
    ballotorder: 1,
    "ward#": 19,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Self-employed consultant",
    dob: "08/08/1968",
    civic:
      "Marquette Univ., BS; founder, 19th Ward Mutual Aid group; OMA/FOIA officer for Kellogg elementary's Local School Council; director, Ridge Historical Society; president, Beverly Improvement Association",
    candidatevideo: "",
    website: "http://www.noonan19.com/",
    fb: "https://www.facebook.com/timnoonan19",
    twitter: "@noonanfor19",
    ig: "https://www.instagram.com/noonanfor19/",
    tiktok: "",
    youtube: "https://www.youtube.com/channel/UCWqLZHqic5XrmxqlXdmDaJg",
    linkedin: "https://www.linkedin.com/in/tim-noonan",
    statement:
      "The 19th Ward’s top issues are public safety and detached communities. In the absence of an involved community, crime flourishes. Unite the 19th Ward: provide safe places to play and socialize like restoring outdoor basketball courts, recruiting businesses to open in our area and providing incentives for hiring locals, and develop clubs and organizations to meet in a safe environment. Everyone is safer when we are looking out for each other. Expand mental health services for the police and community with programs like Treatment Not Trauma and Bring Chicago Home. Focus on vocational jobs because our kids are our future.",
  },
  {
    firstname: "Andre",
    lastname: "Smith",
    ballotorder: 3,
    "ward#": 20,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Jeanette B.",
    lastname: "Taylor",
    ballotorder: 1,
    "ward#": 20,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "05/15/1975",
    civic: "Dunbar Vocational High School; member, Local School Council",
    candidatevideo: "",
    website: "http://jeanettebtaylor.com/",
    fb: "https://www.facebook.com/people/Alderwoman-Jeanette-B-Taylor-20th-ward/100057997031768/",
    twitter: "@taylorfor20th",
    ig: "https://www.instagram.com/taylorfor20th/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jeanette-taylor-a84b32195/",
    statement:
      "The top issues facing the 20th ward are as followed: lack of resources for young people, housing for all, senior services and protection. I currently work with all the institutions in the community to connect neighbors with resources. We currently have monthly ward nights with presentations from different city departments based on neighbors request. We have a weekly constitute day where neighbors can meet with me without an appointment to discuss concerns and work on ward solutions.",
  },
  {
    firstname: "Jennifer",
    lastname: "Maddox",
    ballotorder: 2,
    "ward#": 20,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Nonprofit director",
    dob: "09/10/1971",
    civic:
      "Saint Xavier Univ., MBA; UIC, BA; community chair, Local School Council, Fiske Elementary; co-beat facilitator for Beat 312 (003rd District)",
    candidatevideo: "",
    website: "https://maddox4ward20.com/",
    fb: "https://www.facebook.com/maddox4ward20",
    twitter: "",
    ig: "https://www.instagram.com/maddox4ward20/",
    tiktok: "https://www.tiktok.com/@maddox4ward20",
    youtube: "",
    linkedin: "",
    statement:
      "Education: We currently have a combination of schools that are either under-resourced, under attended, and/or understaffed. There are limited programs during and after school and not enough parent involvement especially with LSC and PAC. My plan is to continue informing and educating the parents around the challenges that the schools are experiencing and work to inform the parents to stand up and be a voice at their children's schools around funding and lack of attention to students' well being. Public Safety: We currently support the schools around arrival and dismissal with parent involvement. We keep parents informed by passing out information as it relates to public safety.",
  },
  {
    firstname: "Ayana",
    lastname: "Clark",
    ballotorder: 6,
    "ward#": 21,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Community advocate",
    dob: "09/14/1994",
    civic:
      "Purdue Univ. Northwest, MA, BA; alumna, Obama Foundation Community Leadership Corp; alumna, Congressional Black Caucus Institute Political Bootcamp; junior board member, Building Brighter Futures Foundation",
    candidatevideo: "",
    website: "https://www.ayanaclarkfor21.com/",
    fb: "https://www.facebook.com/clarkfor21/",
    twitter: "@clarkfor21",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "My ward has suffered from decades of divestment, lack of resources, increasing violence, and underfunded neighborhood schools. Community members are on limited incomes and cannot afford the rising costs of living coupled with the lack of support from our elected officials. I will fight to increase funding for our schools, implement year-round youth employment programs, create a community resource newspaper, and donate 20% of my salary back to residents to help fund projects in the ward. I also plan to open a community pantry in my ward office to help fill in the gap for residents in need.",
  },
  {
    firstname: "Cornell",
    lastname: "Dantzler",
    ballotorder: 1,
    "ward#": 21,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Retired firefighter",
    dob: "01/15/1960",
    civic:
      "Fenger High School; founder, STEPS Mentoring Program; co-founder Community Empowerment Coalition; former president, Fernwood Advisory Council Board",
    candidatevideo: "",
    website: "https://dantzler4alderman.org/",
    fb: "https://www.facebook.com/DantzlerFor21/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Issues facing the 21st Ward include economic disinvestment, deteriorating infrastructure, public safety, and affordable housing. Plans include working proactively to identify root causes contributing to issues surrounding public safety; creating employment opportunities; working with law enforcement to increase their presence and response to crime in the ward—prioritizing creating safe communities for our seniors and youth. Will prioritize rebuilding streets, sidewalks, and alleys in the ward. Plan to partner with businesses in the ward to improve the frontages of commercial districts. Will work to address homelessness in the ward developing resources surrounding affordable housing utilizing the more than 1000 vacant lots/abandon homes in the ward, where possible.",
  },
  {
    firstname: "Daliah",
    lastname: "Goree",
    ballotorder: 5,
    "ward#": 21,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Police officer",
    dob: "05/15/1972",
    civic:
      "Crane High School; Colleges Triton College, AA; Calumet of St. Joseph, BA; Local School Council Sgt at Arms, FOP representative; Weapon Safety/Uniform committee, FOP",
    candidatevideo: "",
    website: "https://www.daliahgoree21.com/",
    fb: "https://www.facebook.com/DaliahGoree21",
    twitter: "@DaliahGoree21",
    ig: "https://www.instagram.com/DaliahGoree21/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The issues faced in our ward are public safety, economic development and employment. Strengthening our neighborhood commercial areas is also extremely important and a strong neighborhood business corridors improve the quality of life in our neighborhoods. The 21st Ward on Chicago’s Far South Side has suffered disinvestment for decades. Our businesses suffer from high property taxes and lack of infrastructure and our ward suffers public transportation. Strengthening those three would bring in affordable housing in the community. City Council needs to refrain from raising property taxes, strengthening our Far South Side and struggling businesses with grants.",
  },
  {
    firstname: "Kweli",
    lastname: "Kwaza",
    ballotorder: 7,
    "ward#": 21,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Nonprofit director",
    dob: "01/03/1963",
    civic:
      "National Lewis Univ., Ph.D; UChicago, MA; founder and president, 21st Ward Block Club Network; Southside PRIDE Event Coordinator; Local School Council community representative",
    candidatevideo: "",
    website: "https://electdrkwelikwaza.com/",
    fb: "https://www.facebook.com/electdrkwelikwaza/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Crime: I will make it uncomfortable for criminals with the use of technology i.e., cameras, plate readers, facial recognition devices and drones. Would-be criminals will feel uncomfortable with even the thought of committing a crime in the 21st Ward. Those that do commit a crime will be apprehended more swiftly because of the use of technology. Inflation: Residents who earn $35,000 or less will be exempt from paying city taxes (property taxes etc.).",
  },
  {
    firstname: "Larry J.",
    lastname: "Lloyd",
    ballotorder: 3,
    "ward#": 21,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Attorney",
    dob: "01/18/1974",
    civic:
      "Western Michigan Univ., JD; Chicago State Univ., BS, Criminal Justice",
    candidatevideo: "",
    website: "https://www.larrylloyd21.com/",
    fb: "https://www.facebook.com/lloydfor21/",
    twitter: "@lloydfor21st",
    ig: "https://www.instagram.com/llloydfor21/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issues are crime, infrastructure and economic development. Once elected, my plan to address crime will be to collaborate with community-based organizations as well as addressing funding to hire more officers, thereby leading to increased visibility within the ward. As for infrastructure, improving response times for city service requests and to repair crumbling streets and sidewalks. As for economic development, I will incentivize small business growth via grant options and work to implement a chamber of commerce for the business districts within the ward to maintain and attract new businesses.",
  },
  {
    firstname: "Preston",
    lastname: "Brown Jr.",
    ballotorder: 2,
    "ward#": 21,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Attorney",
    dob: "12/29/1972",
    civic:
      "Northern Illinois Univ., JD; UIC, MBA; Democratic Committeeman of the 34th Ward; Secretary, Local School Council, Percy L. Julian High School",
    candidatevideo: "",
    website: "https://prestonfor21.org/",
    fb: "https://www.facebook.com/PrestonBrownJr",
    twitter: "@Prestonfor21",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/preston-brown-jr-7b0b5973",
    statement:
      "The top issues in the 21st Ward are public safety, education, economic\ndevelopment, infrastructure, affordable housing, and requiring the heads of city\ndepartments to be accountable to Ward residents in the timely delivery of city\nservices. We need to offer incentives to recruit and retain more police officers\nthat live in the ward, we need city funded violence prevention programs, we need\nskills-based education (i.e. trades) in our neighborhood schools, we need to deal\nwith the issues of homelessness and affordable housing, we need our mental\nhealth clinics reopened. I am the candidate that is a forward-thinking leader who\nwill manage the issues of the ward while developing, recommending and fighting\nfor transformative change.",
  },
  {
    firstname: "Ronnie",
    lastname: "Mosley",
    ballotorder: 4,
    "ward#": 21,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Consulting company founder",
    dob: "08/21/91",
    civic:
      "Morehouse College, BA; Deputy Cannabis Regulation Officer of External Affairs and Communication for the State of Illinois; community affairs specialist for Lieutenant Governor Juliana Stratton",
    candidatevideo: "",
    website: "https://www.ronniemosley.com/",
    fb: "https://www.facebook.com/RLMosley21",
    twitter: "@RLMosley21",
    ig: "https://www.instagram.com/rlmosley21/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "One of the most pressing issues facing the 21st Ward is the lack of economic development and resources available to members of the ward. As Alderman, I would focus on funneling resources into the community to incentivize small businesses to establish in the ward and create a community where families can spend their time and money within their own community. Creating a strong and vibrant retail district will be the centerpiece of my office. By attracting more retailers to open up stores in the 21st Ward, as well as establishing robust job training programs, we can develop the self-sufficient and transformative retail economy that the citizens of my community deserve.",
  },
  {
    firstname: "Kristian",
    lastname: "Armendariz",
    ballotorder: 3,
    "ward#": 22,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "https://www.kristianfor22ward.com/",
    fb: "https://www.facebook.com/profile.php?id=100087166841104",
    twitter: "",
    ig: "https://www.instagram.com/kristianfor22ward/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Michael D.",
    lastname: "Rodriguez",
    ballotorder: 1,
    "ward#": 22,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "08/31/1978",
    civic:
      "DePaul Univ., BA; UChicago, MA; 22nd Ward Democratic committeeperson; board member, Juvenile Justice Institute; former gubernatorial appointee, Illinois Juvenile Justice Commission",
    candidatevideo: "",
    website: "https://www.mikerodriguez.org/",
    fb: "https://www.facebook.com/friendsofmikerodriguez",
    twitter: "@rodriguezfor22",
    ig: "https://instagram.com/friendsofmikerodriguez",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/michael-d-rodr%C3%ADguez-0379972",
    statement:
      "I will continue to make public safety a priority by working to implement the Empowering Communities for Public Safety Ordinance and investing more dollars into violence prevention initiatives. I will prioritize expanding Chicago’s resources for being a Welcoming City, including providing care and support to the current influx of migrants our city is seeing driven to us by the racist and xenophobic Texas governor. I will fight for the rights of workers to organize, advocate for improvements to the CTA, and run a ward office that is transparent and that delivers city services to its residents.",
  },
  {
    firstname: "Neftalie",
    lastname: "Gonzalez",
    ballotorder: 2,
    "ward#": 22,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "TSA officer",
    dob: "09/08/1964",
    civic: "Quigley Seminary North High School",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/Neftalie22/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "My top priorities are jobs and reducing crime, which go hand in hand. Financial instability and poverty breed crime, local jobs paying a livable wage provide stability and real income, both of which are powerful antidotes to crime. I will propose measures that solve this issue from both ends, attracting middle class jobs to the 22nd ward, hiring more police, and increasing training for new recruits. I do not accept campaign contributions from anyone, I owe no favors. This makes me able to tackle the issues facing 22nd ward, putting the people of the 22nd ward first, not campaign contributors.",
  },
  {
    firstname: "Eddie",
    lastname: "Guillen",
    ballotorder: 2,
    "ward#": 23,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Events manager",
    dob: "05/07/1990",
    civic:
      "Bogan High School; volunteer facilitator, Chicago Police Beat 823; West Lawn Neighborhood Watch Committee member; former chief of staff for State Rep. Angelica Guerrero-Cuellar",
    candidatevideo: "",
    website: "https://www.eddieguillen.com/",
    fb: "https://www.facebook.com/eddieguillefor23rdward",
    twitter: "@Eddiefor23rd",
    ig: "https://www.instagram.com/eddieguillenfor23rdward/",
    tiktok: "",
    youtube: "",
    linkedin: "http://linkedin.com/in/eddie-guillen-a19b886b",
    statement:
      "Residents in the 23rd Ward are concerned about public safety, educational opportunities, and quality constituent services. These issues will be my priority to address all the residents in Garfield Ridge, West Elsdon, and West Lawn. My experience as a small business owner, community organizer, Chicago Police beat facilitator, community representative LSC and volunteer with nonprofit organizations gives me a comprehensive and in-depth perspective on bringing neighborhoods and people together. The incumbent has failed the Hispanic community and non-responsive to what the 23rd Ward needs. Our community needs someone who understands daily issues and has the capacity to deliver solutions.",
  },
  {
    firstname: "Silvana",
    lastname: "Tabares",
    ballotorder: 1,
    "ward#": 23,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "January 7, 1979",
    civic:
      "Columbia College, BA; Richard J. Daley College, AA; 23rd Ward committeeperson; former 21st District state representative",
    candidatevideo: "",
    website: "https://www.ward23.org/",
    fb: "https://www.facebook.com/23rdWardTabares/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/aldermantabares/",
    statement:
      "The top issues are crime and taxes. Residents don’t feel safe as crime skyrockets in our neighborhoods. I’ve invested thousands of dollars in technology to provide more POD cameras, but more needs to be done. The current CPI mode of property tax increases is pricing families out of homes. I supported a measure to roll back the property tax increases because we must encourage home ownership. Middle-class neighborhoods are diminishing, and until we get serious about stopping crime and encouraging family homebuyers, our neighborhoods will suffer.",
  },
  {
    firstname: "Creative",
    lastname: "Scott",
    ballotorder: 6,
    "ward#": 24,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Firearms instructor",
    dob: "08/31/1972",
    civic: "Collins High School",
    candidatevideo: "",
    website: "https://www.scottfor24.com/",
    fb: "https://www.facebook.com/CreativeFor24thWard/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The lack of public safety, housing and economic opportunities have plagued the 24th ward. The most pressing issue is that the issues have not been adequately addressed in a significant manner. I would take a multipronged approach which is necessary due to the multiple issues that surround our community. I would implement innovative ideas to create lasting changes.",
  },
  {
    firstname: "Drewone",
    lastname: "Goldsmith",
    ballotorder: 7,
    "ward#": 24,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Firefighter instructor",
    dob: "03/14/1970",
    civic:
      "Foreman High School; U.S. Marine Corps Gulf War veteran; volunteer, Lawndale Community Church; founder, Millie Goldsmith Christmas Tree; Chicago FD community basketball volunteer",
    candidatevideo: "",
    website: "https://www.goldsmithfighting424ward.com/",
    fb: "https://www.facebook.com/drewonegoldsmithfor24ward",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/drew-goldsmith-49723a3a/",
    statement:
      'Standing firm on addressing crime. Demanding fair & accountable policing. Crime prevention by uniting each block in the ward. Introducing Community Benefit Agreements on major projects. Advocating for sustainable living wage jobs. Encouraging business development. Addressing the disinvestment in the community by connecting residents and existing businesses with current city programs and resources. Help Create More Social / Recreational Space & Programs for Our Youth. Initiating trade school programs. Present, professional, courteous, open, transparent governing. Help Create Paths for ex-offenders through restorative justice. Addressing food deserts. Preserving home ownership. Initiate the "Stand Up & Stand Out" Program to protect our Children.',
  },
  {
    firstname: "Edward",
    lastname: "Ward",
    ballotorder: 5,
    "ward#": 24,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Restorative justice coordinator",
    dob: "11/17/1992",
    civic:
      "DePaul Univ., BA; restorative justice public policy advocate, helped create S.B. 100 to mandate restorative justice practices in Illinois schools",
    candidatevideo: "",
    website: "https://edwardwardchicago.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issues facing my ward are as follows: Economic Decay: We need to be sure that businesses in the ward are given the opportunity to not only be created but sustained. My solution is to set aside accessible funding for the small businesses. Violence: Violence in the community is directly linked to the economic conditions of the community. When you address the need you address the underlying issues. Structural Decay: We need to have participatory budgeting practices to find better ways of utilizing the menu fund for the ward. No solution is one size fits all.",
  },
  {
    firstname: "Larry",
    lastname: "Nelson",
    ballotorder: 2,
    "ward#": 24,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Luther",
    lastname: "Woodruff",
    ballotorder: 3,
    "ward#": 24,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Sanitation worker",
    dob: "11/18/1981",
    civic:
      "Providence St. Mel High School; volunteer, Greater Rock Missionary Baptist Church; organized/participated: community clean-ups, food drives, senior engagement events, music production mentoring for youth",
    candidatevideo: "",
    website: "https://lutherwoodruff.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      'Violence is the number one issue facing our ward and our city. Economic development and job creation are equally important. Lack of home ownership and rising property taxes are also negatively affecting the quality of life in the 24th Ward and throughout the West Side. Our community needs resources. As Rev. Dr. Martin Luther King Jr. said, we need a "radical redistribution of political and economic power.',
  },
  {
    firstname: "Monique",
    lastname: "Scott",
    ballotorder: 1,
    "ward#": 24,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "12/02/1971",
    civic:
      "Jackson State Univ., BA; National Louis Univ., MBA; Douglas Park Advisory councilmember; volunteer for Ald. Michael Scott Jr.",
    candidatevideo: "",
    website: "http://aldermanscott.com/",
    fb: "https://www.facebook.com/CitizensForScott",
    twitter: "@aldermanscott24",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/monique-scott-731991a/",
    statement:
      "Unfortunately, the 24th ward has more than just one issue. We have a problem with health and public safety, lack of investment from the city, parity in our educational system and a lack of housing. You can't decouple any one of those issues; they all work hand in hand. I will start with tackling the city owned vacant lots in 24th ward. Housing prevents violence, adds jobs and increases population density. I will continue my community meetings to address the vacant lots and how we can work to rebuild and reclaim our community.",
  },
  {
    firstname: "Traci",
    lastname: "Treasure Johnson",
    ballotorder: 8,
    "ward#": 24,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Community advocate",
    dob: "01/16/1988",
    civic:
      "Oak Park and River Forest High School; secretary, Midwest Community Council",
    candidatevideo: "",
    website: "https://treasuredymond.wixsite.com/treasureyourvote24-c",
    fb: "https://www.facebook.com/CitizensforTreasure24thward/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Some of the top issues that the 24th Ward is experiencing are a lack of affordable housing, economic development, high crime/unemployment, lack of youth programs, access to fresh produce and grocery stores to start. As the next alderman, our administration will work with developers to bring affordable housing and economic development without displacement. Developing on the many vacant lots that plagues the ward and ensure that Community Bargaining Agreements are fulfilled to include the residents. Tackle the crime and unemployment by providing opportunities within the ward, creating jobs, utilizing the closed CPS buildings for vocational training centers, youth/senior centers etc.",
  },
  {
    firstname: "Vetress",
    lastname: "Boyce",
    ballotorder: 5,
    "ward#": 24,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Business owner",
    dob: "10/14/1964",
    civic:
      "Coldwell Banker School of Real Estate, real estate license; Ald. candidate 2011, 2015; outreach for 2015/2019 Willie Wilson an 2019 Alexi Giannoulias campaigns; VP, Chicago Reparations Commission",
    candidatevideo: "",
    website: "https://www.boycefor24.com/",
    fb: "https://www.facebook.com/VetressBoyce4Alderman24thWard",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      'The number one pressing issue in the 24th Ward is poverty. Poverty breeds every other disastrous element we are faced with: crime, gun violence, drugs, mental illness, poor health/healthcare, food deserts, abandonment, poor education, incarceration, recidivism, drug relapse, filth, domestic abuse, finance issues, hopelessness, child abuse and unemployment. The solution for the 24th Ward and the City, is to "reinvest" in areas that have been financially left out. Accountability is needed for organizations granted to help solve these pressing issues. Collaboration is needed by all local governing bodies associated with the ward, led by the aldermen. 50 plus years of neglect won\'t happen overnight.',
  },
  {
    firstname: "Aida",
    lastname: "Flores",
    ballotorder: 2,
    "ward#": 25,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Assistant principal",
    dob: "11/15/1985",
    civic:
      "Georgetown Univ., BA; National-Louis Univ., MA; Harvard Graduate School, ME; Local School Council Student Representative, Benito Juarez Community Academy",
    candidatevideo: "",
    website: "https://aidafloresforalderwoman.com/",
    fb: "https://www.facebook.com/floresfor25",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/aida-flores-58640510",
    statement:
      "Robust City Services: I will work to ensure we develop responsive systems to manage requests and deliver promptly to the needs of our constituents. Public Safety: I will be a steadfast advocate for public safety reform rooted in transformative and restorative justice practices. Protecting and Expanding Affordable Housing: It is vital that we preserve and increase affordable and accessible housing. We can and should have mixed income in the community. Strengthening our Public Schools: I will continue to work at the local level to increase the resources to support our students, our teachers, and administrators and increase local community engagement.",
  },
  {
    firstname: "Byron",
    lastname: "Sigcho Lopez",
    ballotorder: 1,
    "ward#": 25,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "07/07/1983",
    civic:
      "Cumberland Univ., BA; UIC, MA; former: president of the Hispanic Literacy Council of Chicago, Local School Council member at Jungman Elementary",
    candidatevideo: "",
    website: "https://www.sigchofor25.com/",
    fb: "https://www.facebook.com/SigchoFor25/",
    twitter: "@SigchoFor25",
    ig: "https://www.instagram.com/SigchoFor25/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/byron-sigcho-lopez-2b576a11",
    statement:
      "​​The 25th Ward faces skyrocketing property taxes, rental increases, displacement, and violence. I have voted against all property tax increases. We have created and preserved over 800 units of affordable housing. We have invested in violence prevention programs and held city departments accountable on behalf of our constituents. After decades of corruption, 25th Ward residents can meet with their alderperson every Tuesday night. Our streets and sidewalks are in better condition including our successful effort to repave Cermak Road. We have been both principled and effective, striving for inclusiveness and consensus building in all our efforts together with our communities.",
  },
  {
    firstname: "Angee Gonzalez",
    lastname: "Rodriguez",
    ballotorder: 3,
    "ward#": 26,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Laboratory coordinator",
    dob: "08/28/1971",
    civic:
      "Trinity Law School, MS; American Intercontinental Univ., BS; Democratic committeeperson, 26th Ward, 2020-present",
    candidatevideo: "",
    website: "https://www.angeefor26.com/",
    fb: "https://www.facebook.com/angeefor26",
    twitter: "@angeefor26",
    ig: "https://www.instagram.com/angeefor26wardalderwoman/",
    tiktok: "https://www.tiktok.com/@angeegonzalez6",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/angee-gonzalez-10466a7b/",
    statement:
      "Every four years the voters have a critical opportunity to elect both mayor and their alderman who will plan the development of the ward, enact ordinances, to develop a budget and produce sustainable ideas to improve the quality of life in the ward. I intend to bring this opportunity for full community participation using Town Hall meetings to discuss budgets and listen to all the residents, all the voters in the community coming together to meet and discuss solutions. The priorities: ward safety, youth programs, property taxes, housing costs, best use of parks and ward assets, ward sanitation",
  },
  {
    firstname: "Jessie",
    lastname: "Fuentes",
    ballotorder: 2,
    "ward#": 26,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Policy director",
    dob: "02/07/1991",
    civic:
      "Northeastern Illinois Univ., BA, MA; founding member, Illinois Latino Agenda 2.0; co-chair, Puerto Rican Agenda of Chicago",
    candidatevideo: "",
    website: "https://www.jessiefor26thward.com/",
    fb: "https://www.facebook.com/Jessiefor26thward",
    twitter: "@jessiefor26th",
    ig: "https://www.instagram.com/jessiefor26th/",
    tiktok: "",
    youtube: "",
    linkedin: "https://linkedin.com/in/jessie-fuentes-ma-25660376",
    statement:
      "Public safety, housing, economic development and education. I will promote and advocate for curriculums that are culturally and linguistically relevant to its students, and work to create schools that are a safe and inviting place for personal and academic exploration. I will fight to make sure parents, community, students and teachers have a voice on what happens in every school building in the 26th Ward - this means working towards a fully elected school board. I will champion an equitable funding formula, and demand investment in restorative practices that humanize our young people.",
  },
  {
    firstname: "Julian",
    lastname: "Perez",
    ballotorder: 1,
    "ward#": 26,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Small business owner and DJ",
    dob: "09/12/1964",
    civic:
      "Proviso West High School; founder of the Julian Jumpin Perez Foundation",
    candidatevideo: "",
    website: "https://www.voteforjulian.com/",
    fb: "https://www.facebook.com/votejulianperez",
    twitter: "@VoteJulianPerez",
    ig: "https://www.instagram.com/votejulianperez/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/julian-jumpin-perez-77b37551/",
    statement:
      "Public Safety - Collaborate with law enforcement, local organizations, and members of our community to bring about positive change in the ward. Economic Development - Work to foster balanced development to bring in new businesses and affordable housing opportunities that will create jobs and provide needed housing. Education - Improve relationships between educators, parents, and students to enhance academic outcomes. City Services - Ensure that our community has access to the necessary services it needs through reliable and accessible leadership.",
  },
  {
    firstname: "Walter",
    lastname: "Burnett Jr.",
    ballotorder: 1,
    "ward#": 27,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/27thward/",
    twitter: "@AldermanBurnett",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Jason",
    lastname: "Ervin",
    ballotorder: 1,
    "ward#": 28,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "05/07/1974",
    civic:
      "Southern Illinois Univ., BS; Governor’s State Univ., MPA; 28th Ward alderperson since 2011",
    candidatevideo: "",
    website: "http://www.aldermanervin.com/",
    fb: "https://www.facebook.com/AldermanErvin/",
    twitter: "@AldermanErvin",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jason-c-ervin-8a951654",
    statement:
      "For decades now, the South and West sides of Chicago have suffered from a lack of investment, out-of-date infrastructure, and focus on educating our children. This cannot continue. I have always and will continue to focus on more investment in our communities and addressing the top concern of public safety. We need more funding for violence interruption programs, after-school programs, job training, and job creation.",
  },
  {
    firstname: "Shawn A.",
    lastname: "Walker",
    ballotorder: 2,
    "ward#": 28,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Construction consultant",
    dob: "03/21/1973",
    civic:
      "Univ. of Phoenix, MBA; director, Jesus Outreach Food Pantry; minister, Cook County Jail; founder, Garfield Park Little League; former 28th Ward Republican committeeman",
    candidatevideo: "",
    website: "https://vote4shawn.org/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public safety and crime; lack of real economic development and job opportunities; quality grocery stores and restaurants in our Ward (East/West Garfield Park); lack of youth and senior programs; quality schools and senior housing.",
  },
  {
    firstname: "CB",
    lastname: "Johnson",
    ballotorder: 2,
    "ward#": 29,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Chris",
    lastname: "Taliaferro",
    ballotorder: 1,
    "ward#": 29,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "12/09/1965",
    civic:
      "Lewis Univ., BA; UIC Law, JD; board member, Northwest Side Community Coalition; 29th Ward Democratic committeeman; former board member, Total Enrichment Services, Inc.",
    candidatevideo: "",
    website: "https://christaliaferro.com/",
    fb: "https://www.facebook.com/29th.Ward.Alderman.Taliaferro/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public safety remains a top issue in the 29th Ward. It’s important we remain strategic and cutting edge in our approach to reducing violence in our neighborhoods. Efforts in building sustainable relationships with residents and forming proactive crime strategies is imperative. By implementing newer patrol tactics, I would encourage the use of verified technology in reducing gun violence to include the use of gun recognition and detection technology, which is quite different from sound based detection. I would consider the roll-out of incentivizing communities impacted by violence with community-based grant programs designed to encourage community engagement and that are performance based.",
  },
  {
    firstname: "Corey",
    lastname: "Dooley",
    ballotorder: 3,
    "ward#": 29,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Student",
    dob: "12/18/1997",
    civic: "Concordia Univ. Chicago, BA; Arizona State Univ., MA",
    candidatevideo: "",
    website: "https://www.communitycorey.com/",
    fb: "https://www.facebook.com/CommunityCorey/",
    twitter: "@community_corey",
    ig: "https://www.instagram.com/communitycorey/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "As an economic developer, young people ally, and public safety enthusiast, Corey is the only candidate who has been a grassroot organizer in the community, in our fight for small business, trauma informed health care, equitable housing, and green jobs. As Alderman, he will bridge the community and build the economy to put the 29th Ward on the right track. Corey stands for the community, not privatized interest and systemic political influence. He will progress creative, resourceful solutions that engage in peacekeeping strategies, cross-network communication and neighborhood revitalization. Corey is a survivor of gun violence.",
  },
  {
    firstname: "Jessica",
    lastname: "Gutiérrez",
    ballotorder: 3,
    "ward#": 30,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Former high school teacher",
    dob: "02/13/1988",
    civic:
      "UIC, BA; former director of policy, Puerto Rican Cultural Center; former North Side field coordinator for Chuy Garcia for Congress",
    candidatevideo: "",
    website: "https://www.jessica2023.com/",
    fb: "https://www.facebook.com/Jessicafor30",
    twitter: "",
    ig: "https://www.instagram.com/jessicafor30/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public safety: I am a strong advocate of police accountability as a means to reestablish the relationships and trust between community residents and the police fighting against the criminals that threaten our neighborhoods. Quality neighborhood schools: As a teacher, I know how to improve education and I will make it a priority to fully fund our schools so we can prepare all of our children for the future. Spending reform: Some aldermen are increasing their salary by $12,000 this year. It’s time to hold the line on property taxes and create responsible budgets that prioritize people over politicians.",
  },
  {
    firstname: "JuanPablo",
    lastname: "Prieto",
    ballotorder: 1,
    "ward#": 30,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "CTA diversity director",
    dob: "12/07/1985",
    civic:
      "Northside College Preparatory High School; DePaul Univ., BA; treasurer, Spanish Coalition for Housing; board member, La Casa Norte; board member, Latino Worker Safety Center",
    candidatevideo: "",
    website: "https://juanpabloprieto.com/",
    fb: "https://www.facebook.com/JuanPablo30thWard",
    twitter: "@JPPrieto85",
    ig: "https://www.instagram.com/juanpabloprieto_chicago/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/juanpablo-prieto/",
    statement:
      "The top issues facing the 30th Ward are public safety, equitable development, and small business investment. We need to ensure that we have the appropriate levels of policing in the ward, ensure CPD increases civilian positions to incidents involving mental health, substance abuse, and homelessness. With my experience in coalition building, I plan to bring developers and the community to the table to set goals and ensure they are met. I will use my expertise in government and small business development to bring resources to help existing 30th Ward businesses grow and attract new businesses to fill the vacant storefronts.",
  },
  {
    firstname: "Ruth",
    lastname: "Cruz",
    ballotorder: 2,
    "ward#": 30,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Higher education administrator",
    dob: "12/04/1983",
    civic:
      "Roosevelt Univ., BS, MBA; volunteer, Avondale Restorative Justice Community Court; member, Local School Council, Foreman High School",
    candidatevideo: "",
    website: "https://www.ruthcruzfor30.com/",
    fb: "https://www.facebook.com/profile.php?id=100085263365966",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Residents are most concerned about increasing crime rates, improving the quality of education in our communities, affordability in housing and other living expenses, and increased access to affordable mental health services. We need a comprehensive approach to public safety such as more CAPS engagement. We also need to address root causes of crime. For education we need to make sure schools are funded properly. And for mental health, we need to reopen the clinics. I see all these issues as linked, and I come ready to find solutions, instead of just the same old platitudes of the past.",
  },
  {
    firstname: "Warren",
    lastname: "Williams",
    ballotorder: 4,
    "ward#": 30,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Community organizer and filmmaker",
    dob: "06/18/1989",
    civic:
      "Founder, 30th United; member, The People’s Lobby; progressive campaign volunteer for Fair Tax Act, Pre-Trial Fairness Act, Climate and Equitable Jobs Act; hosted community cleanups",
    candidatevideo: "",
    website: "https://www.warrenfor30.com/",
    fb: "https://www.facebook.com/WarrenFor30",
    twitter: "@WarrenFor30",
    ig: "https://www.instagram.com/warrenfor30th/",
    tiktok: "https://www.tiktok.com/@warrenfor30",
    youtube: "",
    linkedin: "https://linkedin.com/in/warren-williams-45366834",
    statement:
      "I believe in preventative public safety measures, and will fight for the Treatment not Trauma Ordinance, increased access to mental health services, and funding for youth programs and CPS. Chicago needs more affordable housing that’s easily accessible to fast, reliable transit to ensure everyone has a safe place to live and neighbors can remain in their communities. I believe in making our CTA free to ride. I will fight for a strong Dept. of Environment/Green New Deal for Chicago to ensure clean air and water, to create publicly funded jobs to update infrastructure and decarbonize our city, and for raising revenue without taxing working class people to ensure that the wealthy pay their fair share and that our social services are fully funded.",
  },
  {
    firstname: "Esteban Burgoa",
    lastname: "Ontañon",
    ballotorder: 2,
    "ward#": 31,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Broker",
    dob: "01/22/1963",
    civic: "Local School Council at Falconer and Bateman elementary schools",
    candidatevideo: "",
    website: "https://estebanburgoa.com/",
    fb: "https://www.facebook.com/esteban.burgoa.777/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "https://www.youtube.com/channel/UCh2RPjvFX2z4wVGc39eG90w",
    linkedin: "https://www.linkedin.com/in/esteban-burgoa-66160924/",
    statement:
      "Crime, affordable housing, rent is too high. TIF funds mismanagement. Lock of street parking, public transportation, education. Health care issues. No services for single parents, immigration. Broken side walks, not paved streets. Real estate is up and the current alderman is giving out Remodeling permits that is destroying the Bungalow facade for profits. Living out working families in the area. Rents are up, displacing working families to move out, causing a drop of students enrollment in Chicago Public Schools. My plan is to get the community involved in the ward decisions. Empowering them for a better future. We have a plan and hope the incumbent debates publicly in front of the community.",
  },
  {
    firstname: "Felix",
    lastname: "Cardona Jr.",
    ballotorder: 1,
    "ward#": 31,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "12/10/1974",
    civic:
      "Northeastern Univ., BA; volunteer, Chicago Park District; director of special assessments, Cook County Assessor's Office; assistant to the commissioners, Cook County Board of Review",
    candidatevideo: "",
    website: "https://felixcardonajr.com/",
    fb: "https://www.facebook.com/felixcardona2023",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issue facing the 31st ward is what the city is facing as a whole, and that is public safety. I work closely with our two police districts to stay informed about the activity taking place in the ward. In addition, my staff attends each CAPS meeting to hear directly from the residents. I installed a camera at an intersection where there was increased activity and this very camera was instrumental in identifying a suspect in an alleged kidnapping. It takes the continued effort of CPD, my office, and residents to continue to tackle the issue of public safety.",
  },
  {
    firstname: "Scott",
    lastname: "Waguespack",
    ballotorder: 1,
    "ward#": 32,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "https://www.ward32.org/",
    fb: "https://www.facebook.com/Waguespack32/",
    twitter: "@ward32chicago",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Laith",
    lastname: "Shaaban",
    ballotorder: 3,
    "ward#": 33,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Finance",
    dob: "11/15/1980",
    civic:
      "Indiana Univ. Bloomington, BA, BS, MPA; member, Mayor of Chicago’s New Americans Advisory Council",
    candidatevideo: "",
    website: "https://www.laithfor33.com/",
    fb: "https://www.facebook.com/faithinlaith",
    twitter: "@33forlaith",
    ig: "https://www.instagram.com/laithfor33rdward/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/laith-s-861a2a12/",
    statement:
      "To address public safety we need to create an Office of Gun Violence prevention, reduce city-wide patrols to put officers back in the districts and walking the streets to get to know the community. We need a ward office that is responsive to the needs of the ward, not just national movements. We need to support our small businesses with microgrants to offset startup costs and fill our empty storefronts.",
  },
  {
    firstname: "Rossana",
    lastname: "Rodríguez-Sánchez",
    ballotorder: 1,
    "ward#": 33,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "11/13/1978",
    civic:
      "Univ. of Puerto Rico, Rio Piedras, BA; Univ. of Manchester, MA; artist director, Albany Park Theater Project; founding member, 33rd Ward Working Families; member, United Working Families",
    candidatevideo: "",
    website: "https://www.rossanafor33.org/",
    fb: "https://www.facebook.com/rossanafor33",
    twitter: "@RossanaFor33",
    ig: "https://www.instagram.com/rossanafor33",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issues facing the 33rd ward are public safety and housing. To be safe, people need access to healthcare, safe and affordable housing, and to live in a connected and caring community. I have introduced Treatment Not Trauma to reopen the public mental health clinics and create a new model to prevent, manage, and respond to mental health crises with clinicians and EMTs. I have brought new affordable housing to the ward, and introduced the Healthy Homes ordinance to protect renters. During the pandemic, I set up mutual aid networks, food pantries, and wellness checks with seniors.",
  },
  {
    firstname: "Samie",
    lastname: "Martinez",
    ballotorder: 2,
    "ward#": 33,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Zoning project coordinator",
    dob: "11/13/1986",
    civic:
      "DePaul Univ., BA; UIC, MPH; former chief of staff for former Ald. George Cardenas",
    candidatevideo: "",
    website: "https://www.samieforalderman33.com/",
    fb: "https://www.facebook.com/Samie-Martinez-for-33rd-Ward-Alderman-103376642616894/",
    twitter: "@Samie33rdWard",
    ig: "https://www.instagram.com/samiefor33rdward/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/samie-martinez-47b82816",
    statement:
      "Gang violence/crime is the number one concern and vacant business space being second in the 33rd ward. Expansion of the Neighborhood Opportunity Fund to the Northwest side would provide incentives to renovate commercial spaces and grow existing business while providing subsidies to hire local youth. I propose to advocate for residents when problem properties are identified and pursue legal action against property owners that allow gang or drug activity on their properties. I propose to fund lighting improvements and displace crime with strategically placed observational devices. These improvements and a strong business community will keep our ward from falling into decline.",
  },
  {
    firstname: "Bill",
    lastname: "Conway",
    ballotorder: 1,
    "ward#": 34,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Adjunct professor and business owner",
    dob: "05/08/1978",
    civic:
      "UChicago, MBA; Georgetown Univ., JD; intelligence officer, US Navy; Democratic candidate, Cook County State’s Attorney; former assistant state’s attorney, Cook County State’s Attorney’s Office",
    candidatevideo: "",
    website: "https://newdayconway.com/",
    fb: "https://www.facebook.com/NewDayConway",
    twitter: "@NewDayConway",
    ig: "https://www.instagram.com/NewDayBillConway/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/bill-conway-3990a114",
    statement:
      "Public Safety and Thoughtful Development. 1) Our police officers need better resources to effectively solve and deter crime, including proper equipment and staffing levels in our neighborhoods and on the CTA. We must also ensure the City addresses the root causes of crime by investing more in mental health, homelessness, and disadvantaged communities. 2) We need to revitalize our Central Business District and surrounding downtown communities so they can be thriving places where people not just work, but also live, visit, and raise a family. This type of development growth requires us to be thoughtful about infrastructure and community impact.",
  },
  {
    firstname: "Jim",
    lastname: "Ascot",
    ballotorder: 2,
    "ward#": 34,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Real estate broker",
    dob: "12/09/1949",
    civic:
      "Lane Tech High School; Bradley Univ., BS, MA; Columbia Pacific Univ., PhD; chair, Lane Tech Local School Council; candidate for IL Congressional District 7",
    candidatevideo: "",
    website: "http://jimascotforalderman.com/",
    fb: "https://www.facebook.com/profile.php?id=100085194478005",
    twitter: "@Ascot4Alderman",
    ig: "https://www.instagram.com/AscotForAlderman/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jim-ascot-96072224b/",
    statement:
      "The main issues facing the 34th Ward are access to timely government services, public safety, infrastructure capacity, and the homelessness crisis. My priority will be to establish a ward office that is accountable, accessible, transparent, and responsive to all our constituents. I will work closely with City Hall to implement community-based policing initiatives, specifically reestablishing the use of police foot-patrols and specialized transit patrols, to better protect our neighborhoods. I will work in partnership with my fellow alderpersons and the mayor, with input from community organizations, to implement policies that benefit the 34th ward and the city as a whole.",
  },
  {
    firstname: "Carlos",
    lastname: "Ramirez-Rosa",
    ballotorder: 1,
    "ward#": 35,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "02/18/1989",
    civic:
      "Univ. of Illinois at U-C, BA; 35th Ward Democratic committeeman; member: United Working Families, United Neighbors of the 35th Ward, Chicago Democratic Socialists of America, Mijente",
    candidatevideo: "",
    website: "https://www.carlosrosa.org/",
    fb: "https://www.facebook.com/votecarlosrosa",
    twitter: "@CDRosa",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/carlosramirezrosa/",
    statement:
      "Housing affordability is the top concern I hear from residents – 35th Ward families continue to face displacement due to the high cost of rent and rising property taxes. Accordingly, I have worked to keep families in their homes and ensure our neighborhoods are affordable, integrated, and diverse. I voted against property tax increases, supported the construction of ADUs, passed anti-deconversion and anti-demolition ordinances for portions of Logan Square, and assisted our unhoused residents in finding housing. I also led the successful effort to build the all-affordable Lucy Gonzalez Parsons Apartments, a 100-unit housing development next to the Logan Square Blue Line.",
  },
  {
    firstname: "David",
    lastname: "Herrera",
    ballotorder: 3,
    "ward#": 36,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Financial consultant",
    dob: "11/10/1982",
    civic:
      "Loyola Univ. Chicago, BAs in economics and finance; former treasurer, Ukrainian Village Neighborhood Association",
    candidatevideo: "",
    website: "https://www.herrerafor36.com/",
    fb: "https://www.facebook.com/herrerafor36",
    twitter: "",
    ig: "https://www.instagram.com/herrerafor36/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/daveherrera/",
    statement:
      "My priorities include filling the uniformed police vacancies as soon as possible as well as working with the command staff of the districts in the ward to restore the community policing model that prioritizes beat integrity. I’d like to see the funds currently spent on private security by the CTA redirected to hire more CPD officers. Additionally, I’m a strong proponent of re-opening the 13th District Station West Town. Until that happens, I will dedicate up to 10% of the $1.6 million menu budget allocated to each Ward for private security patrols comprised of off-duty or retired law enforcement officers.",
  },
  {
    firstname: "Gilbert",
    lastname: "Villegas",
    ballotorder: 2,
    "ward#": 36,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "10/26/1970",
    civic:
      "Northeastern Illinois Univ., BA; board member: Democratic Municipal Officials, National Association of Latino Elected Officials; former chief of staff, Illinois Capital Development Board; Gulf War veteran",
    candidatevideo: "",
    website: "https://www.gilbertforchicago.com/",
    fb: "https://www.facebook.com/GilbertVillegasforAlderman",
    twitter: "",
    ig: "https://www.instagram.com/GilbertVillegasforAlderman/",
    tiktok: "",
    youtube: "",
    linkedin:
      "https://www.linkedin.com/company/alderman-gilbert-villegas/about/",
    statement:
      "Public safety is the top concern in my community. As a former Marine, I know the benefits of strong public safety systems and how additional training and resources equip a squad for success. I will continue working to get more officers on the force, modernize training and technology, and increase the tools our public safety professionals use to catch criminals. I am appropriately focused on investments in our communities and have fought for a focus on neighborhoods like mine that are primarily represented by Latinos. We need to provide affordable housing so neighborhood families thrive and spur more economic growth.",
  },
  {
    firstname: "Jacqueline",
    lastname: "Baez",
    ballotorder: 4,
    "ward#": 36,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Self-employed",
    dob: "01/18/1971",
    civic:
      "Triton College, AA; Wright College, AA; member, Cook County Commission on Women’s Issues (8th Dist.); ambassador for Neighborhood Policing Initiative",
    candidatevideo: "",
    website: "https://www.baezforillinois.com/",
    fb: "https://www.facebook.com/BaezForIllinois",
    twitter: "",
    ig: "https://www.instagram.com/baezforillinois/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jacqueline-baez-43836a60/",
    statement:
      "Public Safety - Enhancing safety and quality of life by strengthening community policing relations we help restore the trust in our police. Property Taxes - if we trim Chicago’s government waste by removing unnecessary layers, we could offer residents much-needed property tax relief. Children and Youth - By investing in children and youth we ensure that they have access to windows of opportunities and resources to succeed not only in school but in life. Economic Development - Empowering people to become small business owners by providing training and resources and by offering tax benefits for existing empty stores.",
  },
  {
    firstname: "Lori",
    lastname: "Torres Whitt",
    ballotorder: 1,
    "ward#": 36,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Teacher",
    dob: "07/09/73",
    civic:
      "Eastern Illinois Univ., BS; Concordia Univ., MS; elected representative, Chicago Teachers Union; executive board, Chicago Teachers Union Legislative Chair",
    candidatevideo: "",
    website: "https://www.torresfor36.com/",
    fb: "https://www.facebook.com/Torresfor36",
    twitter: "",
    ig: "https://www.instagram.com/Torresfor36/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I’m running for Alderman in the 36th Ward because our community wants rooted, progressive leadership that will focus on the issues most impacting working people; building safe communities, housing stability, healthcare access, quality public education, and creating good paying jobs. As a public school teacher with two decades of experience, I know these problems require holistic, community informed, and evidence based solutions and that is why I will fight for policies like Treatment Not Trauma, the Bring Chicago Home Ordinance, reopening shuttered mental health clinics, and prioritizing resources to fully fund our schools and vital city services.",
  },
  {
    firstname: "Corey Denelle",
    lastname: "Braddock",
    ballotorder: 4,
    "ward#": 37,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Self-employed business consultant",
    dob: "03/17/1971",
    civic:
      "Wabash College, BA; Saint Xavier Univ., MBA; former police officer/investigator, CPD, Indiana State Police; member, Local School Council Orr High School",
    candidatevideo: "",
    website: "https://coreydbraddockforthe37th.com/",
    fb: "https://www.facebook.com/CoreyBraddock37",
    twitter: "@CoreyBraddock37",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/corey-d-braddock-mba-ms-94413330/",
    statement:
      "Incumbent is not accessible/responsive to business owner needs, and transparency/access related to TIF money. Stream live all meetings and post them on website. Business license and economic develop communications will be via email and accessible to everyone. No FOIA necessary. Quality of life. Encourage citizens to report needs for CSR's; encourage everyone to be volunteer precinct captain's,and community organizer's. Other issues: Cultural bias of city employees/official elected and appointed; educational neglect; homelessness, epidemic of trauma/safety/abuse; etc.",
  },
  {
    firstname: "Emma",
    lastname: "Mitts",
    ballotorder: 2,
    "ward#": 37,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "06/12/1955",
    civic:
      "Chair, West Side Black Elected Officials (WSBEO); CAPS facilitator, 15th CPD District; volunteer, Henry Horner Boys and Girls Club; president/founder, Community Action Council",
    candidatevideo: "",
    website: "https://em-37.com/",
    fb: "https://www.facebook.com/EmmaMittsAld37",
    twitter: "",
    ig: "https://www.instagram.com/emma.mitts/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Years after WWII brought decades of disinvestment and decline to Austin, as our areas experienced demographic and economic changes that today still negatively affect Chicago’s West Side urban neighborhoods: poverty, housing instability, health, educational and crime challenges and more. 37th Ward communities have seen good/difficult times, but thanks to my strong partnerships, leadership and comprehensive strategies, positive changes are emerging. My master economic development plans promote collaborative, collective transparency and input for all stakeholders. I support policies creating TIF fund equality for all. More city police and expanded community interactions/accountability. More school funding & youth engagement resources. Phased mixed income housing-market rate, affordable & public housing units/property tax reform.",
  },
  {
    firstname: "Howard",
    lastname: "Ray",
    ballotorder: 1,
    "ward#": 37,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "https://www.howardrayforalderman.com/",
    fb: "",
    twitter: "@Hrayfor37thWard",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Jake",
    lastname: "Towers",
    ballotorder: 3,
    "ward#": 37,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Pre-K teacher",
    dob: "02/22/1992",
    civic:
      "Harold Washington College, AAS; block club president; former volunteer mentor, By the Hand Club",
    candidatevideo: "",
    website: "https://jaketowerschicago.com/",
    fb: "https://www.facebook.com/profile.php?id=100083136618441",
    twitter: "@JakeTowersChi",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jake-towers-50970523a",
    statement:
      "Disinvestment is a top issue in my ward. Investment is the key, urban communities have lacked resources and opportunities for far too long. Our youth should be top priority, which includes bringing in quality mental health services, trade programs, healthy grocery stores, and equitable jobs. The simple needs of the people are not being met. I’ve worked with youth all my life, and I’ve learned that if you don’t give them something to do, they will find something to do. The fact that West Side communities are still known as under-resourced neighborhoods is a disgrace.",
  },
  {
    firstname: "Bruce",
    lastname: "Randazzo",
    ballotorder: 5,
    "ward#": 38,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100089184078177",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Cynthia",
    lastname: "Santos",
    ballotorder: 1,
    "ward#": 38,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Environmental agency executive",
    dob: "07/30/1961",
    civic:
      "Northeastern Illinois Univ., MA; commissioner, Metropolitan Water Reclamation District 1996-2016; former Democratic state central committeewoman for 5th Congressional District; Delegate and State of Illinois Elector for President Biden",
    candidatevideo: "",
    website: "https://www.santosfor38.org/",
    fb: "https://www.facebook.com/santosfor38thward",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Safety is a concern for 38th Ward residents. Implementing measures to reduce crime is my priority. A retired police officer as part of my administration will guide neighborhood watch programs and real time community crime alerts. Installing license plate scanners throughout the ward will give law enforcement information needed to apprehend offenders. Adding additional police officers in the 16th District will ensure that response time improves. The current lack of community input silences residents and their voices. I will develop a Community Advisory Council with representatives from the entire ward to be part of policy and program decision-making.",
  },
  {
    firstname: "Ed",
    lastname: "Bannon",
    ballotorder: 4,
    "ward#": 38,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Parent and community volunteer",
    dob: "01/06/1971",
    civic:
      "Univ. of Illinois U-C, BS; public relations chair, 38th Ward Democrats; organizer of annual Clean&Green/summer events for the Dunning Library; Local School Council, Dever Elementary School",
    candidatevideo: "",
    website: "https://edbannon.com/",
    fb: "https://www.facebook.com/EdBannonfor38",
    twitter: "@EdBannonfor38",
    ig: "https://www.instagram.com/edbannonfor38/",
    tiktok: "",
    youtube: "https://www.youtube.com/channel/UCSI-quXhejTdKtvWx47QfkA",
    linkedin: "https://www.linkedin.com/in/ed-bannon-2733782/",
    statement:
      "The 38th Ward needs a new leader who understands our community's challenges. I have the energy and new ideas to overcome the stagnation in our ward and to tackle those challenges among others. My track record shows I’m not a politician focused on personal gains, but a public servant dedicated to rolling up my sleeves and getting work done. I am a proud lifelong Northwest Sider who has worked for years on community improvements at local parks, schools and libraries. That’s how you know I will continue to work for you when elected.",
  },
  {
    firstname: "Franco",
    lastname: "Reyes",
    ballotorder: 2,
    "ward#": 38,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Software engineer manager",
    dob: "04/15/1988",
    civic:
      "Lincoln Park High School; Northern Illinois Univ., BS, Computer Science",
    candidatevideo: "",
    website: "https://www.francoforward38.com/",
    fb: "https://www.facebook.com/francofor38",
    twitter: "@francofor38",
    ig: "https://www.instagram.com/francofor38/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/francoreyes/",
    statement:
      "Top issues of the ward are crime, cost of living and city services. To address crime I will work with CPD to increase officers on patrol. Another part of this is to build community trust by holding officers accountable and ensure that the city properly funds mental health services, anti-poverty programs, our schools and housing for the homeless. To address the cost of living I will allow denser development. This increases the housing supply and strengthens the tax base which reduces the tax burden on residents. I also will work to make city services prompt and efficient.",
  },
  {
    firstname: "Nicholas",
    lastname: "Sposato",
    ballotorder: 3,
    "ward#": 38,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "10/07/1958",
    civic:
      "Former 36th Ward alderman; Local School Council Sayre School, parent and community rep; VP, MCEP Lions Club, MCEP Chamber of Commerce; Local 2 Union steward",
    candidatevideo: "",
    website: "https://nicholassposato.com/",
    fb: "https://facebook.com/nick.sposato.3",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The major issue facing my ward and this city is crime. We need to back our police and show them that we will stand with them and against criminals. This will be the only way to attract new police candidates. Once people feel safe and the criminals know that they will face consequences, people will feel safer and we will attract business to the city and its neighborhoods. I am a big supporter of police, business and education.",
  },
  {
    firstname: "Denali",
    lastname: "Dasgupta",
    ballotorder: 1,
    "ward#": 39,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Researcher",
    dob: "02/20/1983",
    civic:
      "Yale Univ., BA; New York Univ., MPA; Mayfair Mutual Aid, Volunteer Income Tax Preparer; foster parent; CPS Parent Leadership Council; member, 39th Ward Neighbors United",
    candidatevideo: "",
    website: "https://www.denalifor39.com/",
    fb: "https://www.facebook.com/denalifor39",
    twitter: "@DenaliFor39",
    ig: "https://www.instagram.com/denalifor39/",
    tiktok: "",
    youtube: "https://www.youtube.com/@denalifor39",
    linkedin: "https://linkedin.com/in/denalidasgupta/",
    statement:
      "Equitable distribution of services and the inclusion of all communities and neighbors in the way our ward works and our council members vote is my biggest ward level priority. This campaign is an ask for every neighbor to show up and participate - to share their experiences, observations, and visions so we can create a ward that works for everyone. When leaders are accountable to their community and value active civic engagement, we have the power to make real change in our neighborhoods. It’s not customer service. It’s not done to us or for us. It’s something we do together.",
  },
  {
    firstname: "Samantha",
    lastname: "Nugent",
    ballotorder: 2,
    "ward#": 39,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "04/27/1977",
    civic:
      "Univ. of Connecticut, BA; Loyola Univ. Chicago, JD; created ordinance for citywide ban on single-use plastics for delivery/take out; implemented participatory budgeting, 39th Ward",
    candidatevideo: "",
    website: "https://www.samanthanugent39.com/",
    fb: "https://www.facebook.com/samfor39/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/samantha-nugent-6829bb5/",
    statement:
      "Over the past four years, I have prioritized public safety, education and building a vibrant business community. I’ve worked to bring more officers and technologies to improve safety in the Ward. As a CPS parent, I have delivered long-needed improvements at our neighborhood schools so our children can thrive. Students need a robust curriculum, combined with extracurricular activities and support from a full-time counselor and social worker. I’ve supported local businesses through COVID-19 with grants and brought new businesses to the Ward to add jobs and revitalize our commercial corridors. Let’s continue building a safer, better 39th Ward.",
  },
  {
    firstname: "Andre",
    lastname: "Vasquez",
    ballotorder: 1,
    "ward#": 40,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "05/21/1979",
    civic:
      "Kaplan Univ., AA; Organizer: Reclaim Chicago, The People's Lobby, National People’s Action",
    candidatevideo: "",
    website: "https://www.andrefor40th.com/",
    fb: "",
    twitter: "@Andrefor40th",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issue in my ward, like many others, has been safety. As I believe a connected community is a safe community, we’ve used holistic and proactive approaches to establish the most progressive civilian oversight committee in the country, lead neighborhood watch programs, and have regularly worked alongside CAPS, CPD, mental health organizations like NAMI, and gang intervention groups to keep our community informed, and safe. To address feelings of exclusion from government, we have established a participatory budget and community-driven zoning process, as well as streamlined our 311 system so our ward’s collective voice is what moves us forward.",
  },
  {
    firstname: "Christian",
    lastname: "Blume",
    ballotorder: 2,
    "ward#": 40,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Lawyer",
    dob: "12/03/1984",
    civic:
      "US Air Force Academy, BS; Northeastern Illinois Univ., MS; UIC Law, JD; Chicago Volunteer Legal Services, volunteer lawyer in mortgage foreclosure defense; Chicago Bar Association member",
    candidatevideo: "",
    website: "http://blume40th.com/",
    fb: "https://www.facebook.com/profile.php?id=100087909427818",
    twitter: "@Blume40th",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/christian-blume-74911ba3/",
    statement:
      "Service - Returning the position of Alderman and the Ward office to function for the community; facilitating services for our neighbors. Public Safety - Improving our public safety departments, including increasing the hiring of more social service and mental health professionals. Affordability - keeping families and individuals, at all levels of financial means, in our neighborhood through business growth, employment opportunities, public program access, and education improvements (including income based after-school care).",
  },
  {
    firstname: "Jane",
    lastname: "Lucius",
    ballotorder: 3,
    "ward#": 40,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Small business owner",
    dob: "08/19/1954",
    civic:
      "Mundelein College, AA; former beat facilitator, CAPS; former president, Neighbors of Edgewater West; volunteer, Chicago Alliance for Animals",
    candidatevideo: "",
    website: "https://www.janeforthe40th.com/",
    fb: "",
    twitter: "@janeforthe40th",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "One of my top priorities is public safety. A great relationship between the alderman and CPD is extremely important to the ward in order to work together to come up with efficient strategies to take on crime. A solution is better communication and due to my involvement with the 20th and 24th District CAPS program, I have a strong understanding of both the police and citizens' sides to issues. Another priority is property taxes and I would vote against any budgets that would increase them. Thirdly, I would advocate for small businesses in regards to community development.",
  },
  {
    firstname: "Anthony",
    lastname: "Napolitano",
    ballotorder: 1,
    "ward#": 41,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "03/29/1975",
    civic:
      "Calumet College of St. Joseph, BS; former Chicago police officer, firefighter, EMT; American Hearing Impaired Hockey Association participant; state certified police officer, Firefighter/EMT",
    candidatevideo: "",
    website: "https://www.napolitanofor41.com/",
    fb: "https://www.facebook.com/napolitanofor41",
    twitter: "@aldnapolitano41",
    ig: "https://www.instagram.com/napolitanofor41/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "It is a tremendous honor to represent the 41st ward, my lifelong home. We've made great strides over the last 7.5 years including infrastructure improvements, expansion of our overcrowded schools, and new amenities throughout our ward. My main focus is public safety. I was a partner Alderman who helped bring a state of the art Strategic Decision Support Center to the 16th District. Utilizing this amazing technology, I implemented the 41st Ward Public Safety Initiative which will provide camera surveillance throughout the entire ward that is monitored 24/7 at the 016th District. I will continue to be a strong independent voice in the City Council.",
  },
  {
    firstname: "Paul",
    lastname: "Struebing",
    ballotorder: 2,
    "ward#": 41,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Civil litigation attorney",
    dob: "10/06/1987",
    civic:
      "Miami Univ. (Ohio), BA; Loyola Univ. Chicago, JD; VP, Edison Park Community Council; community representative, Ebinger Elementary Local School Council",
    candidatevideo: "",
    website: "https://www.paulfor41.com/",
    fb: "https://www.facebook.com/Paulfor41",
    twitter: "@Paulfor41",
    ig: "https://www.instagram.com/paul_for_41/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/paulstruebing/",
    statement:
      "I am running for 41st Ward Alderman because I believe in the Northwest Side. But, I have seen our Ward become less safe, our business districts and communities less vibrant, and pensions increasingly insecure – despite ever rising taxes. I will show up and work hard every day to get more out of our investment in the city. I will tirelessly advocate for more officers and safe streets while fighting for resources needed to fund pensions, enhance services, fix roads and transit, improve schools, and revitalize business districts.",
  },
  {
    firstname: "Brendan",
    lastname: "Reilly",
    ballotorder: 1,
    "ward#": 42,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "12/26/1971",
    civic:
      "Hobart College, BA; Democratic committeeman; former vice mayor of Chicago; City Council President Pro Tempore 2019-Present; elected Biden delegate, 7th Congressional District (2020)",
    candidatevideo: "",
    website: "http://www.reillyforchicago.com/",
    fb: "",
    twitter: "@AldReilly",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Crime is the top issue facing our ward since 2019. My solutions are and have been: becoming the first alderman to use menu funds to purchase License Plate Reader cameras for local police districts; enlisting the help of Sheriff Dart to open a Command Post in River North, bringing dozens of deputies downtown, 7-days a week; demanding CPD leadership restore the 300+ police patrol officers that the downtown 18th and 1st police districts have lost over the past 4 years.",
  },
  {
    firstname: "Brian C.",
    lastname: "Comer",
    ballotorder: 2,
    "ward#": 43,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Renewable energy executive",
    dob: "09/14/1974",
    civic:
      "DePaul Univ., BSB; president, Sheffield Neighborhood Association; beat facilitator, 18th Chicago Police District; co-founder, 43rd Ward Alliance; president, Trinity Volunteer Corps; volunteer, Dignity Diner",
    candidatevideo: "",
    website: "https://www.briancomer.com/",
    fb: "https://www.facebook.com/Comerforward43",
    twitter: "@COMERfor43",
    ig: "https://www.instagram.com/Comerfor43/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/briancomer/",
    statement:
      "Crime: Focus CPD budget to fund more rank & file officers. Engage residents in ongoing collaboration with 18th District police district. Secure public & private funds to acquire more cameras. Economic Development – Small Business: Reduce red tape hurdles on small businesses. Work to develop tax holidays for small businesses. Schools: Work with our state officials to secure more state dollars for capital improvements; Chicago is not getting our fair share of tax revenue. Secure resources from public private partnerships. Build community in schools – ward nights, special events in neighborhood schools.",
  },
  {
    firstname: "Rebecca",
    lastname: "Janowitz",
    ballotorder: 3,
    "ward#": 43,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Retired",
    dob: "10/29/53",
    civic:
      "Univ. of Sussex, BA; Loyola Univ. Chicago, JD; UChicago, MPP; former chair of the Board of the Illinois Council Against Handgun Violence",
    candidatevideo: "",
    website: "https://rebeccajanowitz.com/",
    fb: "https://www.facebook.com/RebeccaJanowitzChicago",
    twitter: "@RebeccaJanowitz",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Crime is the top issue, followed by transportation, public education and affordable housing. 43rd Ward residents understand that the decline in population hurts the city as a whole, not just the neighborhoods most impacted. City leadership must understand the deep need to restore confidence in our collective decision making processes at the council and agency levels.",
  },
  {
    firstname: "Steve",
    lastname: "Botsford",
    ballotorder: 4,
    "ward#": 43,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Commercial real estate developer",
    dob: "03/28/1989",
    civic:
      "Notre Dame Univ., BA; Georgetown Univ., MA; Northwestern Univ., MBA",
    candidatevideo: "",
    website: "https://botsfordforchicago.com/",
    fb: "https://www.facebook.com/BotsfordforAlderman",
    twitter: "@sfbots",
    ig: "https://www.instagram.com/sfbots/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/sfbots/",
    statement:
      "The biggest issue facing my ward is crime. We need to focus on solving our city’s violent crimes by investing more in our detective units and giving them the resources to end this current crime surge. We also need to utilize our mental health professionals because every 911 call should not be responded to with armed force. This, in turn, frees up police to remain in our communities and patrol hotspots. We also need to try new innovative ideas like collecting and registering the DNA of convicted felons, which studies in Denmark have shown to significantly reduce new convictions.",
  },
  {
    firstname: "Steven",
    lastname: "McClellan",
    ballotorder: 5,
    "ward#": 43,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Business owner",
    dob: "02/11/1982",
    civic:
      "LaSalle Language Academy; Kenwood Academy; Univ. of Illinois U-C, BA; four terms as Local School Council Community Representative, LaSalle Language Academy",
    candidatevideo: "",
    website: "https://www.43forsteve.com/",
    fb: "https://www.facebook.com/McClellan43/",
    twitter: "@chi1837",
    ig: "https://www.instagram.com/mcclellanfor43rdward/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/slmcclellan/",
    statement:
      "Public Safety: As Alderperson I will push for more investments in youth prevention programs & reform, introduce stronger ordinances against violent crimes, increased training modules for officers and focus on recruitment & cadet retention. I will work with the 18th and 19th district commanders and council to bring back the beat cop and walk the beat with officers, leading by example. Property Taxes: I will join the Budget Committee as well as create a 43rd Ward budget committee so constituents can participate in the budget process throughout the entire year. I will also look for alternative ways to generate revenue such as, create a new tax base and TIF reform to increase funds to the budget.",
  },
  {
    firstname: "Timmy",
    lastname: "Knudsen",
    ballotorder: 1,
    "ward#": 43,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "06/05/1990",
    civic:
      "Univ. of Illinois U-C, BA, JD; Founder, pro-bono law firm representing LGBTQ+ asylum applicants in Chicago and Tijuana, Mexico; former chairman, Chicago Zoning Board of Appeals",
    candidatevideo: "",
    website: "https://www.knudsenfor43.com/",
    fb: "",
    twitter: "@knudsenfor43",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/timknudsen/",
    statement:
      "Public safety and fiscal stability are two of the 43rd Ward’s primary concerns. To deter crime, we invested ward infrastructure dollars into strategically placed security cameras and innovative license plate readers. I’ve built strong relationships with local CPD commanders and co-sponsored ordinances to crack down on illegal guns and improve CTA safety. The city budget illustrated ways to tackle both priorities: investing $100M more in anti-violence programs, $20M more to fund more officers, and $242M in advance pension payments — all without increasing property taxes. I’ll keep working to be a pragmatic progressive alderman who gets stuff done for our ward.",
  },
  {
    firstname: "Wendi",
    lastname: "Taylor Nations",
    ballotorder: 6,
    "ward#": 43,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Public relations executive",
    dob: "02/23/1963",
    civic:
      "DePauw Univ., BA; Northwestern Univ., MBA; board of Trustees member, DuSable Museum of Black History, Tree House Human Society, RANCH Triangle Community Conservation Association",
    candidatevideo: "",
    website: "https://www.wendifor43.com/",
    fb: "https://www.facebook.com/WendiFor43",
    twitter: "@wendifor43",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "http://linkedin.com/in/wenditaylornations",
    statement:
      'Crime is the primary concern for 43rd Ward residents. 70% of Chicago voters named crime and public safety as their #1 or #2 top issue. No other issue comes close. I propose: 1. More cops on street. 2. Get kids back in school. Use some of the federal pandemic recovery funds to find the students that CPS "lost" during the pandemic. 3. Support District Councils. 4. Support the assault weapons ban. 5. Provide immediate updates on crime to residents.',
  },
  {
    firstname: "Bennett",
    lastname: "Lawson",
    ballotorder: 1,
    "ward#": 44,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Ward chief of staff",
    dob: "07/02/1978",
    civic:
      "Loyola Univ. Chicago, BA; board member, Ride for AIDS Chicago; gala committee, Equality Illinois; campaign work for Sara Feigenholtz, Jan Schakowsky",
    candidatevideo: "",
    website: "https://www.bennettfor44.com/",
    fb: "https://www.facebook.com/bennettfor44",
    twitter: "@lawsonfor44",
    ig: "https://www.instagram.com/bennettfor44/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/bennett-lawson-349a94b/",
    statement:
      "My priorities are supporting our schools, improving public safety, and fostering economic growth and sustainable development. Building safer, thriving communities will help ensure our ward remains a desirable place to live and do business. I support safe and accessible options for walkers, cyclists, drivers and transit riders. I will also elevate the voices of the community by making the office more transparent and accessible to those in the ward. Finally, I support the development of market-rate housing, supporting affordable housing models, and building additional transit-oriented development.",
  },
  {
    firstname: "Ana",
    lastname: "Santoyo",
    ballotorder: 4,
    "ward#": 45,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Library worker",
    dob: "7/30/1989",
    civic:
      "Northeastern Illinois Univ., BA; Syracuse Univ., MS; organizer, ANSWER Coalition; co-founder, Pueblo Unido Albany Park; volunteer, Justice for Anthony Alvarez; member, Party for Socialism and Liberation",
    candidatevideo: "",
    website: "https://www.anaforward45.com/",
    fb: "https://www.facebook.com/anaforward45",
    twitter: "@anaforward45",
    ig: "https://www.instagram.com/anaforward45/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "There are so many pressing issues in our ward. We need affordable housing, we need more resources for education and teachers, we need to fight back against racism and police abuses, and we need to remove all of the lead pipes. These and much more can all be done, it is only a question of political will. Ultimately though, this campaign isn't about me. I'm running to put power into the hands of working people through regular community interaction and consultation. What we need is not just another politician, but a people’s movement, and that's what my campaign is about.",
  },
  {
    firstname: "James",
    lastname: "Gardiner",
    ballotorder: 3,
    "ward#": 45,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "04/17/1976",
    civic:
      "Saint Xavier Univ., BA; former CPS special education teacher; former Chicago firefighter/EMT",
    candidatevideo: "",
    website: "https://www.gardinerfor45th.com/",
    fb: "https://www.facebook.com/AldermanGardiner",
    twitter: "",
    ig: "https://www.instagram.com/aldermangardiner/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issues impacting our community are directly related to public safety. Although our area is safer than most, residents are concerned about gun violence, burglaries, and other crime that has infiltrated our community while having to deal with a shortage of police manpower. After sharing those concerns with Mayor Lightfoot and Superintendent Brown on many occasions, our community has yet to secure the additional resources we deserve. With that said, I will be helping support a mayoral candidate who is willing to listen and better address our concerns.",
  },
  {
    firstname: "James",
    lastname: "Suh",
    ballotorder: 6,
    "ward#": 45,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Small business owner and IT manager",
    dob: "11/8/1980",
    civic:
      "Univ. of Illinois U-C, BS; UChicago, MS; parent representative, Local School Council; VP of fundraising for the school’s parent-teacher association",
    candidatevideo: "",
    website: "https://www.suhfor45.com/",
    fb: "https://www.facebook.com/suhfor45th",
    twitter: "@SuhFor45",
    ig: "https://www.instagram.com/SuhFor45/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/james-suh-40377a1/",
    statement:
      "The issues I hear most about from residents are public safety, economic development, and the need for leadership who can bring the community together to affect positive change. Relying on my professional and small-business experience, I will work with our local chambers of commerce and neighborhood organizations to promote thoughtful economic development and create a climate that attracts new businesses to the area which fit with the needs and character of our communities. I will work with public safety officials, city agencies, neighbors, and local stakeholders to build relationships, collaborate, and deliver resources that make for safer and stronger communities.",
  },
  {
    firstname: "Marija",
    lastname: "Tomic",
    ballotorder: 5,
    "ward#": 45,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Finance and accounting manager",
    dob: "12/19/1977",
    civic: "DePaul Univ., BS; Regina Dominican HS",
    candidatevideo: "",
    website: "https://www.marijaforthe45th.com/",
    fb: "https://www.facebook.com/marijaforthe45thward",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/marijatomicchicago6342/",
    statement:
      "The quality of life in the 45th Ward is slipping away. Chicagoans know that public safety is the elephant in the room. Graffiti, carjackings and shootings are becoming commonplace. We must stop police redeployments and fully fill the current police vacancies. This will increase police presence and reduce their 911 response times. Local businesses are struggling. Too many empty storefronts haunt our ward. Prompt and efficient response to business owners' needs and residents' service requests must be addressed. We must repeal the Lightfoot ordinance tying property taxes to the rate of inflation.",
  },
  {
    firstname: "Megan",
    lastname: "Mathias",
    ballotorder: 2,
    "ward#": 45,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Attorney",
    dob: "02/07/1977",
    civic:
      "Michigan State Univ., BA; Chicago-Kent College of Law, JD; board member: Belding Elementary Local School Council, Life Span, YWCA of Metropolitan Chicago",
    candidatevideo: "",
    website: "https://www.meganfor45thward.com/",
    fb: "https://www.facebook.com/meganmathiasfor45thward",
    twitter: "@meganfor45th",
    ig: "https://www.instagram.com/meganfor45thward/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The three most salient challenges/issues in the 45th ward are: 1) public safety, 2) economic development, and 3) affordability. I have spent more than 100 hours interviewing officers and residents on safety issues. We need to focus on initiatives that rebuild trust between the police and the communities they serve. Moreover, we must act to stem the tide of early retirement and lateral attrition. I have developed an economic development plan entitled Vision45 which will utilize an Economic Advisory Board to develop policies and projects to spur economic growth. Finally, I will prioritize affordability issues through public dialogue and engagement.",
  },
  {
    firstname: "Susanna",
    lastname: "Ernst",
    ballotorder: 1,
    "ward#": 45,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Former finance executive",
    dob: "05/12/1969",
    civic:
      "Univ. of Northern Colorado, BA; president/co-founder, Northwest Chicago Historical Society; co-founder, Jefferson Park Neighborhood Association; co-founder, Jefferson Park Forward/Steering Committee",
    candidatevideo: "",
    website: "https://www.susannafor45.com/",
    fb: "https://www.facebook.com/SusannaFor45/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/susanna-ernst/",
    statement:
      "To ensure equitable services and clear communication, all civic groups will be invited to meet regularly, and the office will be open to all constituents. Residents will be regularly informed of important legislation in City Council. Public safety is a major concern; I will proactively work to get more officers deployed as well as foster relationships between our community and our police. I will also collaborate with City Council colleagues to promote holistic solutions. For economic development, I will support of small businesses and funding of local chambers. Development that addresses the needs of the neighborhoods will be a standard.",
  },
  {
    firstname: "Angela",
    lastname: "Clay",
    ballotorder: 1,
    "ward#": 46,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Community organizer",
    dob: "03/30/1991",
    civic:
      "DePaul Univ., BA; Local School Council member, Brennemann Elementary",
    candidatevideo: "",
    website: "https://angelafor46.com/",
    fb: "https://www.facebook.com/ClayFor46/",
    twitter: "@ClayFor46",
    ig: "https://www.instagram.com/ClayFor46/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Affordability and public safety. Neighbors I grew up with can no longer afford to live here. Some are experiencing homelessness without resources to get permanently housed. Available housing stock impacts the longevity of our schools. Public safety relies on stable communities where people know their neighbors and is dependent on effective mental health resources and community-driven approaches. I support addressing root causes by creating a dedicated revenue stream for homeless support services through The Bring Chicago Home Ordinance, building new and preserving existing development that promotes affordability, and creating mental health crisis response through the Treatment not Trauma Ordinance.",
  },
  {
    firstname: "Kim",
    lastname: "Walz",
    ballotorder: 2,
    "ward#": 46,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Business executive",
    dob: "02/28/1975",
    civic:
      "Georgetown Univ., MPP; Beloit College, BA; former director of policy analysis/chief of staff for Cook County Commissioner Mike Quigley; volunteer, House of Good Shepherd Domestic Violence Shelter",
    candidatevideo: "",
    website: "https://kimwalz.com/",
    fb: "https://www.facebook.com/kimfor46/",
    twitter: "@KimberlyJWalz",
    ig: "https://www.instagram.com/kimfor46/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/kimberlyjwalz/",
    statement:
      "First, we need to address crime in our community and city. I will work to fully staff our police districts and invest in communities that have been historically left behind by funding crucial social safety net programs. Secondly, we need to keep our ward affordable not only through the development of affordable housing, but I will also pursue and support policies that preserve naturally occurring affordable housing and fight to lower property taxes. Finally, I will work to increase support for those experiencing homelessness and mental illness. I will move the 46th ward forward while leaving no one behind.",
  },
  {
    firstname: "Marianne",
    lastname: "Lalonde",
    ballotorder: 6,
    "ward#": 46,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Energy efficiency consultant",
    dob: "09/03/1986",
    civic:
      "Case Western Reserve Univ., BS; Northwestern Univ., PhD; former energy & environment policy fellow for US Senator Sherrod Brown (D-OH); former president, Lakeside Area Neighbors Association",
    candidatevideo: "",
    website: "https://www.mariannefor46.com/",
    fb: "https://www.facebook.com/marianneuptown",
    twitter: "@marianneuptown",
    ig: "https://www.instagram.com/marianneuptown/",
    tiktok: "",
    youtube: "https://www.youtube.com/@friendsofmariannelalonde",
    linkedin: "https://www.linkedin.com/in/mblalonde/",
    statement:
      "The top issues facing the ward are public safety, transportation, and housing. I’d like to explore the use of non-sworn personnel for tasks like traffic enforcement, which would free up officers for detective work, enabling CPD to quickly deploy officers in response to calls and increase case clearance rates. Improving safety on transit, perhaps with unarmed conductors who were eliminated in 1998, could both improve staff retention and increase ridership. Finally, adding more affordable housing in the ward, loosening the criteria to qualify for affordable housing, and simplifying the application process will help maintain diversity and reduce homelessness.",
  },
  {
    firstname: "Michael",
    lastname: "Cortez",
    ballotorder: 5,
    "ward#": 46,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Real estate broker",
    dob: "12/02/1962",
    civic: "Niles West High School",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "My name is Michael Cortez, Uptown has been my home for the past 21 years, and I have been a real estate broker in the area for the past 23 years. I am determined to make the 46th Ward a better place to live, work, and play. Some of my concerns include safety - we must feel safe to move around within our community; I envision new businesses in the community (restaurants, entertainment, etc.); helping the homeless - I truly want to help and I have an idea that will provide the homeless with work and a place to live.",
  },
  {
    firstname: "Patrick",
    lastname: "Nagle",
    ballotorder: 3,
    "ward#": 46,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Judge",
    dob: "10/08/69",
    civic:
      "College of the Holy Cross, BA; Univ. of Notre Dame, JD; former VP, East Lakeview Neighbors; member, 46th Ward Zoning and Development; former federal prosecutor",
    candidatevideo: "",
    website: "https://patricknaglefor46.com/",
    fb: "https://www.facebook.com/NagleFor46/",
    twitter: "@Naglefor46",
    ig: "https://www.instagram.com/naglefor46/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/patrick-nagle-82920568/",
    statement:
      "While the 46th Ward faces many challenges, violent crime is our greatest concern. We must increase our 19th district police staff, develop a comprehensive city-wide plan to reduce crime, and partner with federal law enforcement to curb gun violence. We must also tackle our ward housing shortage by encouraging development while meeting our affordable housing responsibilities. I will champion a more vibrant and flourishing small business community that creates jobs for residents. Finally, we need to humanely and effectively implement a coordinated approach for solving unsheltered homelessness with housing, health care, and supportive services instead of unsafe outdoor living alternatives.",
  },
  {
    firstname: "Roushaunda",
    lastname: "Williams",
    ballotorder: 4,
    "ward#": 46,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Bartender",
    dob: "12/28/67",
    civic:
      "Western Illinois Univ., BS; VP of the executive board, Illinois AFL-CIO; former social worker",
    candidatevideo: "",
    website: "https://roushaundawilliams.org/",
    fb: "https://www.facebook.com/WilliamsFor46/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Residents of the 46th Ward and across our city want to feel safe and sound. We need to address the foundations that allow a person to feel secure and flourish, including housing, mental health services, high-quality jobs, and health care access. I have spent the last two decades bringing people together to win what seemed impossible - safety, security and hope. My background in social work and law enforcement, along with my experience as an organizer with my union, has provided me with an understanding of what it takes to ensure everyone in our community can be safe and sound.",
  },
  {
    firstname: "Matthew J.",
    lastname: "Martin",
    ballotorder: 1,
    "ward#": 47,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "03/05/84",
    civic:
      "Northwestern Univ., BA, BM; Harvard Law, JD; founder, Heart of Lincoln Square Neighbors Association; former member, 47th Ward Zoning Advisory Council",
    candidatevideo: "",
    website: "https://www.matt47.com/",
    fb: "https://www.facebook.com/MattMartinChi/",
    twitter: "@MattMartinChi",
    ig: "https://www.instagram.com/MattMartinChi/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/matt-martin-04012b8/",
    statement:
      "To improve public safety thoughtfully and aggressively, city government must scale-up its support for violence-prevention organizations; modernize our public safety departments; and bring a crisis-response team to every Chicago community. Residents across Chicago are also struggling to afford their homes. That’s why I will support 100% affordable developments for working families; expand affordability within new market-rate buildings; and help build more ADUs. Finally, improved transportation infrastructure is critical for Chicago’s vitality. We must expand our EV charging infrastructure; create a citywide plan for bike and pedestrian infrastructure; and push CTA leadership to create a dynamic plan to enhance CTA service.",
  },
  {
    firstname: "Andre",
    lastname: "Peloquin",
    ballotorder: 4,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Real estate broker",
    dob: "07/19/1987",
    civic:
      "California State Univ., BA; member of City Year Chicago Corps Member, Chicago Public Schools; member, Friends of the Edgewater Library; member, Auxiliary Board of the Lincoln Park Zoo",
    candidatevideo: "",
    website: "https://andrefor48.com/",
    fb: "https://www.facebook.com/profile.php?id=100086747227940",
    twitter: "@andrefor48",
    ig: "https://www.instagram.com/andrefor48th/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/peloquinandre/",
    statement:
      "Reducing crime and improving safety by placing beat officers back in commercial corridors, getting guns off the streets, and working with CAPS program and ECPS officials. Maintain and improve ward services by strategically allocating funds through participatory budgeting and highest need. Thoughtful residential and commercial development through community involvement and a ward master plan. Quality of life for seniors to stay in our neighborhoods. Economic opportunities and ease of opening a local business in our community by cutting red tape. Maintain and improve the quality of our public schools working with LSC’s. Keeping our neighborhoods diverse and welcoming to all.",
  },
  {
    firstname: "Andy",
    lastname: "Peters",
    ballotorder: 9,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Small business owner",
    dob: "12/01/1987",
    civic:
      "UChicago, BA; commissioner, Special Service Area #22 Andersonville; member, Chicago Mayoral Business Council, Andersonville Chamber of Commerce, Illinois Restaurant Association; volunteer, Jewish United Fund",
    candidatevideo: "",
    website: "https://electandypeters.com/",
    fb: "https://www.facebook.com/profile.php?id=100088975776002",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/andrew-peters-7495199/",
    statement:
      'As a small business owner and resident of Edgewater for over a decade, I see firsthand that rising crime is the main issue facing the 48th Ward. The police department needs to address its manpower shortage by hiring more police officers, especially officers who look like the communities they serve. We should simultaneously expand the use of "co-responder models" to allow mental health professionals to respond to mental health emergencies with police. To bring down the murder rate, we need to get shooters off the streets.',
  },
  {
    firstname: "Brian",
    lastname: "Haag",
    ballotorder: 5,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Small business owner",
    dob: "01/19/1963",
    civic:
      "Former co-chair, current volunteer and sponsor, Edgewater Environmental Coalition; current board member and sponsor, Edgewater Historical Society",
    candidatevideo: "",
    website: "https://brianhaagforward48.org/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/brian-haag-0790b2b/",
    statement:
      "Public Safety - Hire more cops and create more bike lanes. Get public school kids caught back up to grade level after two years of covid zoom - pay for more tutoring. Create more affordable housing - expand and promote abilities for homeowners, landlords, & developers to create more ADUs (additional dwelling units) and repurpose / adaptive reuse of existing buildings - such as converting former office space (surplus due to new ways of working remotely) to residential housing. Explore converting storefront vacancy subsidies to something like a section 8 voucher but for people to live/work in long vacant store fronts. Such as an entrepreneurial artist who wants to have a gallery in the same place they live, or a start up accountant for the matter could also be workable for such a space.",
  },
  {
    firstname: "Isaac",
    lastname: "Freilich Jones",
    ballotorder: 6,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Assistant attorney general",
    dob: "01/01/1987",
    civic:
      "Harvard Law, JD; UChicago, BS; volunteer, Care For Real; board president, Howard Area Community Center; consultant, O-H Community Partners",
    candidatevideo: "",
    website: "https://www.isaacfor48.com/",
    fb: "https://www.facebook.com/profile.php?id=100085142917469",
    twitter: "@isaacfor48",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/isaac-freilich-jones-72b4a326/",
    statement:
      "As alderperson, I will fight for: Public Safety: My strategy focuses on (1) reimagining law enforcement and adopting a model that permanently stations community-based foot patrol officers in local neighborhoods; (2) incorporating safety considerations into infrastructure design (e.g., lighting, CTA stations); and (3) providing social services and economic opportunity City-wide. Housing Affordability: Expand affordable housing options with a focus on family-size housing, fight to make property taxes predictable, and minimize the burden on those least able to pay. Commercial Corridor Revitalization: Convene stakeholders to support local independent businesses and fill vacant storefronts. Fully funded neighborhood schools, libraries, and parks.",
  },
  {
    firstname: "Joe",
    lastname: "Dunne",
    ballotorder: 3,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Affordable housing developer",
    dob: "08/24/1972",
    civic:
      "Northwestern Univ., MBA; Columbia College, BA; former parent representative/council chair, Peirce Local School Council; former co-chair, Principal Selection Committee, Peirce elementary school",
    candidatevideo: "",
    website: "https://www.joedunnefor48.com/",
    fb: "https://www.facebook.com/joedunnefor48",
    twitter: "",
    ig: "https://www.instagram.com/joedunnefor48/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/joe-dunne-698b734/",
    statement:
      "Public safety and affordability are the biggest issues facing our ward. We need to rebuild trust between the community and police department and implement a sustained effort at reinvigorating community policing. We need our police officers to know the community and for the community to know the officers working our streets. Property taxes in Edgewater continue to increase year-over-year, pricing out long-term residents, pushing landlords to seek higher rents, and eroding the naturally occurring affordable housing that has existed in Edgewater for decades. We need to rescind the automatic property tax increase and expand exemptions for seniors and long-time homeowners.",
  },
  {
    firstname: "Larry",
    lastname: "Svabek",
    ballotorder: 1,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Educator and researcher",
    dob: "05/05/1993",
    civic:
      "UChicago, PhD, MA; Northwestern Univ., BA; former member, CPAC coalition; volunteer, Care for Real",
    candidatevideo: "",
    website: "https://larryfor48.org/",
    fb: "https://www.facebook.com/profile.php?id=100084464779444",
    twitter: "@larrysvabek",
    ig: "https://www.instagram.com/larry_for_48/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/larry-svabek-5a862346/",
    statement:
      "Public Safety: Incorporate police district councilors into decision-making; improve lighting near transit stops; push the city to spend already allocated funds on violence prevention. Expand Treatment not Trauma mental healthcare responders program. Housing Affordability: Reject campaign contributions from developers; establish a community-driven zoning process; maintain and expand affordability standards for new developments; Make permanent the Accessory Dwelling Units Pilot citywide. Environment: Invest in pedestrian, bike, and transit infrastructure; reconstitute the Department of the Environment; hold ComEd accountable to achieve rigorous climate and energy targets; fund climate resilience infrastructure including flooding mitigation.",
  },
  {
    firstname: "Leni",
    lastname: "Manaa-Hoppenworth",
    ballotorder: 7,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Small business owner and community organizer",
    dob: "09/25/1969",
    civic:
      "UIC, BS; board member, co-chair of Diversity, Equity, and Inclusion committee, Andersonville Chamber of Commerce; co-founder of Indivisible Illinois; founder of ILVOTE",
    candidatevideo: "",
    website: "https://www.lenifor48th.com/",
    fb: "https://www.facebook.com/lenifor48th",
    twitter: "@lenifor48th",
    ig: "https://www.instagram.com/lenifor48th/",
    tiktok: "https://www.tiktok.com/@lenifor48th",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/leni-manaa-hoppenworth/",
    statement:
      "Housing: Passing Bring Chicago Home, and working with neighbors on community-driven zoning, get us closer to equitable housing for all. Public safety: 40% of our current city budget goes to policing, and yet not everyone is safe. Investing in mental health care, substance-abuse treatment, housing, and education has a clear and sustainable impact on reducing crime. Healthcare: There is no health and wellness without mental health. I have worked with local advocates to pass CESSA (Community Emergency Services and Support Act) at the state level, and will champion expanding comprehensive, culturally relevant, and high-quality mental health care.",
  },
  {
    firstname: "Nassir",
    lastname: "Faulkner",
    ballotorder: 10,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Communications manager",
    dob: "08/04/1994",
    civic:
      "DePaul Univ., BA; former member, Obama Foundation's Community Leadership Corps.",
    candidatevideo: "",
    website: "https://faulkner48.com/",
    fb: "",
    twitter: "@Faulknerfor48",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I will prioritize public safety, housing affordability, public school funding and economic development. I will create a public safety advisory council, bringing neighbors, block clubs and other stakeholders together to work with me on local strategies CPD can implement to address quality of life crimes, while advocating on the council for anti-poverty measures and greater public school funding for social workers and youth programs. I will fight for affordable housing, including raising the minimum affordable units in new developments from 20% to 30%. I will work with local chambers to create technical assistance programs that will help us fill vacant storefronts.",
  },
  {
    firstname: "Nick",
    lastname: "Ward",
    ballotorder: 2,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Writer and arts administrator",
    dob: "08/01/1981",
    civic:
      "Miami Univ., BFA; secretary/community representative, Goudy Elementary Local School Council; volunteer with Care for Real, Cornerstone Community Outreach, and 48th Ward Neighbors for Justice",
    candidatevideo: "",
    website: "https://www.nickward48.com/",
    fb: "https://www.facebook.com/NickWardfor48/",
    twitter: "@NickWardFor48",
    ig: "https://www.instagram.com/NickWardFor48/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Affordability, public education, infrastructure, and workers’ rights. As alderman, I will support policies that encourage more family-sized affordable units and lower property taxes and costs for renters and owners. I will also fight for full funding for our neighborhood schools, increase language access services for students and their families, and work with state and federal legislators to fund improvement projects, like a new playground at Swift and a new roof at Senn. I will invest in walkable and accessible streets and sidewalks and use my office to support workers, like the newly-organized workers at Starbucks and Howard Brown.",
  },
  {
    firstname: "Roxanne",
    lastname: "Volkmann",
    ballotorder: 8,
    "ward#": 48,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Federal agency director",
    dob: "06/25/1969",
    civic:
      "Loyola Univ. Chicago, BA; board of directors, Chinese Mutual Aid Association; former Community Builder Fellow, HUD, White House Task Force; member, Asian American AIDS Foundation",
    candidatevideo: "",
    website: "https://www.roxannefor48.com/",
    fb: "https://www.facebook.com/Roxannefor48",
    twitter: "@RoxanneVolkmann",
    ig: "https://www.instagram.com/roxannefor48/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/roxanne-volkmann-09b841b/",
    statement:
      "Public safety is our top concern. I will work with CPD to mobilize more neighborhood beat officers and advance smarter hiring, better training, and clearer accountability. Mental health resources — for residents and CPD — can be a measurable step forward. My 30 years of federal experience sets me apart from other 48th Ward candidates. I will address affordability and community revitalization. I have the government knowledge and relationships to access overlooked funds to rebuild business districts and support community initiatives. I will be a champion for women’s issues from reproductive freedom, to fair pay, to affordable childcare.",
  },
  {
    firstname: "Belia",
    lastname: "Rodriguez",
    ballotorder: 2,
    "ward#": 49,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Business owner",
    dob: "02/28/1972",
    civic:
      "Bogan Technical High School; former president, vice president and director of the Rogers Park Business Alliance",
    candidatevideo: "",
    website: "https://www.beliafor49th.org/",
    fb: "https://www.facebook.com/beliafor49th/",
    twitter: "",
    ig: "https://www.instagram.com/beliafor49th/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/beliarodriguez",
    statement:
      "Community safety is the number one issue on residents’ minds. We can address it by rebuilding our relationship with the 24th district police, partnering with violence reduction organizations, and strengthening community outreach. The encampment at Touhy Park is also top of mind. If elected, my first order of business is to secure housing and wrap-around services for the people there and re-open the park to the public. Finally, Rogers Park has seen rapid economic decline in the last year. Addressing community safety and giving our local businesses the support they need to thrive will help us reverse the tide.",
  },
  {
    firstname: "Bill",
    lastname: "Morton",
    ballotorder: 3,
    "ward#": 49,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Marketing director",
    dob: "04/20/1977",
    civic:
      "President, Rogers Park Chamber of Commerce, Leone Beach Park Advisory Council; former member, Loyola Park and Touhy Park Advisory Councils; member, Chicago Missing Persons Task Force",
    candidatevideo: "",
    website: "https://www.billmorton49.com/",
    fb: "https://www.facebook.com/BillMorton49/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/mrmorton",
    statement:
      "The top issues facing my ward are violent crime and the Touhy Park encampment. I plan to address this by housing encampment occupants immediately, reopening Touhy Park and its programs to our residents and their children, and restoring the 11 p.m. curfew that our constituents are demanding. Touhy Park or any other park having park programs moved to another park was unprecedented and reflects a lack of leadership. I will have daily briefings with police, the parks, and other City of Chicago sister agencies and provide direction. I will provide the resources that the police need to address crime.",
  },
  {
    firstname: "Maria",
    lastname: "Hadden",
    ballotorder: 1,
    "ward#": 49,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "01/20/1981",
    civic:
      "DePaul Univ., MS; commissioner, Cook County Commission on Social Innovation; member, Democratic Party of the 49th Ward; former board member, Black Youth Project Chicago",
    candidatevideo: "",
    website: "https://www.mariafor49.org/",
    fb: "https://www.facebook.com/Mariafor49/",
    twitter: "@Mariafor49",
    ig: "https://www.instagram.com/mariafor49/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/mariahadden/",
    statement:
      "The issues facing the 49th Ward are the issues facing Chicago as a whole. People want to be safe, live affordably, have good schools and economic opportunity. As Alderwoman, I’ve increased investments in violence prevention, public health services, our schools, and fought to increase accessible and affordable housing. I’ve done so while increasing access to my office for constituents, setting up a rapid response team to meet extraordinary needs at the start of the pandemic, and increasing transparency and accountability through democratic process. I’d like to continue being a public servant for my ward and our city.",
  },
  {
    firstname: "Debra",
    lastname: "Silverstein",
    ballotorder: 2,
    "ward#": 50,
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Alderperson",
    dob: "10/04/1965",
    civic: "UIC, BA; Democratic Committeewoman, 50th Ward",
    candidatevideo: "",
    website: "https://debrafor50.com/",
    fb: "https://www.facebook.com/50thWardChicago/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I want to continue to deliver results for the 50th Ward. In 2019, we opened the first new library in the ward in 60 years. The $34 million project has been lauded for meeting multiple community needs. Since 2011, our CPS schools have received $68 million in additional funding for renovations and new playgrounds. We have invested $10 million in our parks. I am proud to be one of only a few Orthodox Jewish women elected officials in the United States and I hope to continue to serve as a Jewish voice in the City Council.",
  },
  {
    firstname: "Mueze",
    lastname: "Bawany",
    ballotorder: 1,
    "ward#": 50,
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Teacher and basketball coach",
    dob: "08/07/1987",
    civic:
      "Northeastern Illinois Univ., BA; former housing committee chair, COVID bargaining team at Chicago Teachers’ Union",
    candidatevideo: "",
    website: "https://muezefor50.com/",
    fb: "https://www.facebook.com/muezefor50",
    twitter: "@muezefor50",
    ig: "https://www.instagram.com/muezefor50/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The top issue facing our ward is the lack of ward democracy. There is no participatory budgeting process. We are one of the few wards in the city without a zoning council or indeed any form of community-driven zoning. The complete lack of transparency around the governance of the ward gives our current alderman almost unilateral control over decision-making. If elected, I will build a zoning advisory board of ward residents that reflect our ward’s diversity as well as implement a participatory budgeting process that allows constituents to decide how menu money [an annual allotment to each alderperson for ward projects] is disbursed.",
  },
  {
    firstname: "Abraham “Abe”",
    lastname: "Matthew",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 9,
    occupation: "Attorney",
    dob: "01/09/1987",
    civic: "St. Ignatius College Prep; UIC Law, JD",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/abe4pdc9",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "By serving as an open line of communication and the voice of the community, it will be my responsibility to advocate on issues of public safety. I will ensure transparency and communication between the community and law enforcement. I will work towards improving 911 call response times and morale among officers by tapping investigators to supplement officers and giving officers their days off. I will ensure the district receives its fair share of resources and personnel by conducting a staffing allocation study on the most effective placement of personnel.",
  },
  {
    firstname: "Albert “Al”",
    lastname: "Cacciottolo",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 8,
    occupation: "Streets and Sanitation superintendent",
    dob: "04/22/1963",
    civic: "Attended UIC; president, Garfield Ridge Neighborhood Watch Group",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "In the 8th District the police have been (especially through the Chicago Alternative Policing Strategy program) trying to be better neighbors to residents. I want to be able to allow everyone, resident and police personal, to open up and speak their minds so we can fix relations between the police and the community. I feel I can be that bridge to bring both sides to a level ground. The 8th District is the biggest district in the city and I’m looking forward to getting to know all the different beats in the district.",
  },
  {
    firstname: "Alees",
    lastname: "Edwards",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 11,
    occupation: "Analyst",
    dob: "02/07/1974",
    civic:
      "Volunteer in the community for various needs, block club president, community organizer",
    candidatevideo: "",
    website: "http://www.alees11policedistrictcouncil.com/",
    fb: "https://www.facebook.com/alees.edwards",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/alees-edwards-21b33b24/",
    statement:
      "My mission is to ensure the community’s safety is at the center of all strategies and actions of the Chicago Police Department (CPD). CPD is a large corporation with an enormous amount of power. Without accountability, that power can be used to harm the very community it was sworn to protect. My top priority is to establish processes that would make it almost impossible for officers to abuse their power and participate in historical behavior like police brutality, police cover-ups, retaliatory behavior and emotional distress towards the community.",
  },
  {
    firstname: "Alexander J.",
    lastname: "Perez",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 2,
    occupation: "Social media manager",
    dob: "09/12/1991",
    civic:
      "Aurora Univ., MBA; worked for Aurora's mayoral department of communications.",
    candidatevideo: "",
    website: "https://perezfor2nd.my.canva.site/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/alexanderjperez/",
    statement:
      "Lack of communication and trust are the top issues facing our district. I would use my communication skills to forge community partnerships and advocate for reinvestment into community anti-violence and mental health initiatives. I will also look to modernize how CPD and the community communicate by using data to develop action plans, gather feedback and generate community SMART goals.",
  },
  {
    firstname: "Amy",
    lastname: "Cross",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 18,
    occupation: "Attorney, policy advocate",
    dob: "12/22/1981",
    civic:
      "Queens College, MEd; Yeshiva Univ., JD; Smith College, BA; fellow, Charles H. Revson Law Student Public Interest",
    candidatevideo: "",
    website: "https://www.electamycross.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/amyliencross",
    statement:
      "Residents are concerned about gun violence and property crimes, officer shortages and response times, and systems of accountability when crime occurs. Often the responsibility for effective public safety rests on the community: proactive residents engage local businesses in crime-prevention strategies; others persistently appeal to their alderperson to address basic safety needs. As a district councilperson, I would elevate these concerns to support the commission’s work to improve CPD resource allocation and response times, seek out resources to expedite residents’ ongoing and future crime-reduction initiatives, and work collaboratively with residents, the commission, and CPD to foster transparent and thorough communication.",
  },
  {
    firstname: "Ana Marija",
    lastname: "Sokovic",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 3,
    occupation: "Computational scientist",
    dob: "06/06/1979",
    civic: "UChicago, PhD, computer science",
    candidatevideo: "",
    website: "https://caresfor3rd.com/",
    fb: "https://www.facebook.com/profile.php?id=100069485285159",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/ana-marija-s-0b667a20/",
    statement:
      "One of the biggest issues that the 3rd district faces with policing is response times. The Tribune published an article this year showing that District 3 is the worst in the city. When the police take too long to show up, not only are they unable to prevent certain crimes, but they are further unable to build trust with the community by not showing up when they are needed the most. As a member of the District Council I will do regular, robust analysis of police response times and other policing patterns in order to bring greater transparency and accountability of their charge - to serve and protect.",
  },
  {
    firstname: "Andre",
    lastname: "Pate",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 22,
    occupation: "Manager",
    dob: "02/24/1981",
    civic:
      "Univ. of Phoenix, MPA; Robert Morris Univ., BA; treasurer, block club; membership chair, Rotary Club",
    candidatevideo: "",
    website: "https://patefor22ndpolicedistrictcouncil.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "22nd District is a large and diverse district. The issues vary from ward to ward. I believe that the biggest issue facing our community is crime. Although there isn’t a single strategy or solution to these issues. I'd start by bringing the CPD and community together to develop a plan.",
  },
  {
    firstname: "Angelica P.",
    lastname: "Green",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 25,
    occupation: "Educator",
    dob: "08/03/1980",
    civic: "Community police class, community ambassador",
    candidatevideo: "",
    website: "https://www.angelicagreen25th.com/",
    fb: "https://www.facebook.com/AGfor25",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 25th District is one of the largest in Chicago. Therefore, I want to get the perspective from different areas. As District Council, I will advocate for the community. Some people feel the police do not respect them, there is a lack of trust, slow response times, and often feel they can agitate a situation. Others feel 25th District has improved with the special units, such as DCO’s. Some feel they do an amazing job, depending on where and who you ask in the 25th district. My community has expressed to me that we have bad apples in a good bunch that need to be removed.",
  },
  {
    firstname: "Anna",
    lastname: "Rubin",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 20,
    occupation: "Community organizer",
    dob: "09/24/1992",
    civic: "Princeton Univ., BA",
    candidatevideo: "",
    website: "https://www.our20thdistrict.com/",
    fb: "",
    twitter: "",
    ig: "https://www.instagram.com/our20thdistrict/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "In my conversations with residents in my district, most people want to know how they can address situations where they feel unsafe without relying on the police. I am committed to hearing what our communities need when it comes to cultivating safety in our city. I want to be a conduit for community-sourced insights to the district council and the commission, particularly from those who know that interacting with police is not a safe option for them. I hope I am able to share existing resources with the community and present proposals for alternatives based on community needs.",
  },
  {
    firstname: "Anthony David",
    lastname: "Bryant",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 3,
    occupation: "Government affairs associate",
    dob: "12/07/1993",
    civic:
      "Monmouth College, BA, sociology and anthropology; deputy voter registrar & youth council for the NAACP; committee member, Worker's Center for Racial Justice & Gender Equity",
    candidatevideo: "",
    website: "https://www.anthonydbryant.com/",
    fb: "https://www.facebook.com/voteanthonydbryant",
    twitter: "@Anthony_4_3rd",
    ig: "https://www.instagram.com/vote_anthony_d_bryant/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/anthony-d-bryant-9a6744bb/",
    statement:
      "The 3rd police district has slow 911 call response times. It is oversurveilled and approaches to solving crime have been inefficient. Residents feel watched, but not heard. They find it uncomfortable and unsafe to interact with the police. This campaign ensures residents will have a direct opportunity to impact the root issues of crime, address public safety issues and hold the police accountable. I will prioritize the community when working with different stakeholders to develop strategies to implement healing spaces and restorative justice practices.",
  },
  {
    firstname: "Anthony Michael",
    lastname: "Tamez",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 17,
    occupation: "Civil servant",
    dob: "06/22/1999",
    civic:
      "City Colleges of Chicago, AA; former chair, Center for Native American Youth, Youth Advisory Board; fellow, Aspen Ideas Festival; former co-president, Chi-Nations",
    candidatevideo: "",
    website: "https://anthonytamez.com/",
    fb: "https://www.facebook.com/anthonypochel/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "https://www.youtube.com/channel/UCPSWbEYMhxMcUMKXgYzs1JA",
    linkedin: "https://www.linkedin.com/in/anthony-pochel",
    statement:
      "Chicagoans have also been experiencing the impacts of decades of disinvestment that have left our communities without adequate mental health services. We know the presence of the police during mental health emergencies can dramatically escalate a situation, increasing the risk of being killed during a police encounter by 16 times more likely, according to the Treatment Advocacy Center. As your next 17th District Council member, we must invest and remain committed to initiatives like treatment, not trauma. Our communities understand what we require: preventative, proactive, and evidence-based solutions to Chicago's public safety crisis. Finally, police accountability can become a reality through co-governance.",
  },
  {
    firstname: "Brad",
    lastname: "Kessler",
    ballotorder: 7,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 18,
    occupation: "Lawyer, business operator",
    dob: "07/29/1983",
    civic:
      "Northwestern Univ., JD; Univ. of Wisconsin, BA; committee chair,  Lincoln Park High School Local School Council; leader, CPS Anti-Violence Task Force; advisory board member, Chicago Children’s Advocacy Center",
    candidatevideo: "",
    website: "https://bradkesslerchicago.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Tragically, many of us in the 18th District have seen crimes first-hand on our blocks, within our stores, or while riding the CTA. Families can only flourish in a safer Chicago, in which our police beat officers are members of a neighborhood’s extended family, keeping our communities safe. There are several reasons driving our increase in crime, and we are tragically ill-equipped and under-staffed. We are in a desperate need of more beat officers with consistent schedules, more mental health expertise, more effective training and partnerships, and a greater investment in education and social services.",
  },
  {
    firstname: "Brandon",
    lastname: "Johnson",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Cook County commissioner",
    dob: "03/28/1976",
    civic: "",
    candidatevideo: "https://youtu.be/_dVyIRl4Q0o",
    website: "",
    fb: "https://www.facebook.com/Brandon4Chicago",
    twitter: "@Brandon4Chicago",
    ig: "https://www.instagram.com/brandon4chicago/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Brenda",
    lastname: "Waters",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 4,
    occupation: "Healthcare worker",
    dob: "11/01/1958",
    civic:
      "President, Friends of Merrill Park; serves on the Merrill Park Advisory Council through the park district",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Build better communication between residents of the 4th police district and the police department. I will work with the community to hold the police accountable, promote public safety and develop community policies.",
  },
  {
    firstname: "Brian",
    lastname: "Sullivan",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 17,
    occupation: "Firefighter",
    dob: "09/25/1981",
    civic: "",
    candidatevideo: "",
    website: "https://www.sullyfor017.com/",
    fb: "",
    twitter: "@for_017",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The root causes of violent crime are complex and extremely difficult to solve, but society must do everything it can to solve them. That being said, keeping the public safe from violent gun offenders shouldn't be politically divisive. Everyone in Chicago has the right to live in a gun violence free environment. As the 17th district's gang conflicts spiral out of control, our request to increase the staffing levels of our dangerously understaffed district has fallen on deaf ears. Specialized units that could have addressed our district's gang violence, have either been disbanded or have had their staffing levels dramatically reduced. CPD needs to start making policies that follow basic logic.",
  },
  {
    firstname: "Brian J.",
    lastname: "Ramson Jr.",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 11,
    occupation: "Physicist",
    dob: "05/03/1987",
    civic: "Univ. of Michigan-Ann Arbor, PhD applied physics",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 11th District is characterized by its high frequency of crime. Conversations with residents reveal a deep frustration with the lack of effective enforcement in their neighborhoods, leading to an air of widespread lawlessness, and officers often express that the city has not dedicated enough manpower or resources to address the concerns of residents. Once in office, I will address the issues harming the effectiveness of police and work with the Community Commission on Pubic Safety and Accountability to implement solutions that have the full support of the community.",
  },
  {
    firstname: "Carisa",
    lastname: "Parker",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 22,
    occupation: "Healthcare professional",
    dob: "06/18/1975",
    civic:
      "Chair, Local School Council, Morgan Park High School; founding member, Moms of CPD, Heart of 21 Community Collaborative, Wonderful Woman Wednesday; member, League of Women Voters",
    candidatevideo: "",
    website: "https://www.carisafor22.com/",
    fb: "https://www.facebook.com/CParkerfor22",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/carisa-parker-5012a212/",
    statement:
      "The neighborhoods in the eastern sections of the 22nd Police District are most impacted by crime. Residents in this area are concerned, but also frustrated about limited information regarding prevention and resolution efforts. Lack of beat integrity and lack of trust and communication between residents and officers have an impact on public safety. As crime increases, the entire district has to acknowledge that crime has no zip code. Crime anywhere impacts us all. I hope to empower residents and create opportunities for them to have valued voices in what policing and restorative justice looks like in our entire community.",
  },
  {
    firstname: "Carlos",
    lastname: "Sanchez",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 9,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Carmelita P.",
    lastname: "Earls",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 15,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Cherli",
    lastname: "Montgomery",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 7,
    occupation: "",
    dob: "",
    civic:
      "Gage Park High School; serves as a chaplin at Stateville Prison; former radio host",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100088806187801",
    twitter: "@CherliM_7thDisC",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "One of the biggest issues that we still face in the 7th district is that Englewood & West Englewood is a training ground for new recruits. Take the Stop and frisk policy which is still being done in the district. The recruits are told that if they can work in the Englewood area then they can work anywhere. I want to change that scenario—those new recruits should train in their own neighborhoods. I promise to keep the community engaged in the 7th Police district council meetings.",
  },
  {
    firstname: "Chloe",
    lastname: "Vitale",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 12,
    occupation: "Community advocate",
    dob: "08/21/1986",
    civic: "Univ. of California, Los Angeles, BA, Sociology",
    candidatevideo: "",
    website: "http://ecpsdistrict12.com/",
    fb: "https://www.facebook.com/profile.php?id=100088488740412",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The community's trust must be earned. The way one earns trust is by doing the right thing, consistently. Chicago needs accountability and transparency, which the district councils are meant to achieve. This historic election is an opportunity to address a system of policing that has operated illegitimately with no external oversight. It is crucial that these councils remain fair and impartial without FOP obstruction. Violence prevention and restorative justice initiatives will be prioritized.",
  },
  {
    firstname: "Christopher M.",
    lastname: "Laurent",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 14,
    occupation: "Legal assistant",
    dob: "01/16/1973",
    civic: "Northeastern Illinois Univ., BA communications and media",
    candidatevideo: "",
    website: "http://laurentforchicago.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/chris-laurent-71322514/",
    statement:
      "Without our police, there would be zero accountability in our society. As with many careers, there are outstanding models, just as there are marginal ones. I intend to address these issues with an open conversation about accountability on law enforcement and with the community. Accountability needs to be addressed at all levels.",
  },
  {
    firstname: "Colleen",
    lastname: "Murphy",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 16,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Colleen Mary",
    lastname: "Dillon",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 16,
    occupation: "Transportation manager",
    dob: "07/29/1959",
    civic:
      "Western Illinois Univ., BA; deputy registrar, Chicago Board of Elections; member, Citizens in Action Community Group",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The number of police officers patrolling in the 16th District is terribly inadequate. Especially when compared to the other police districts. The 16th District is one of the largest of the 22 districts but is given the least manpower. My top priority would be to increase police presence and improve deterrence in the 16th district.",
  },
  {
    firstname: "Constance",
    lastname: "Melton",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 15,
    occupation: "Outreach coordinator",
    dob: "04/19/1982",
    civic: "AS, AAS, City Colleges; local food pantry volunteer",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "One of the major issues is that the police department follows old practices of law enforcement and personnel are uneducated about the culture. Not everyone who wears a certain type of clothing, certain tattoos, or listens to a certain type of music is a gang member or is affiliated with a gang. Also, strategic plans are executed with minimal follow-up due to officers moving up in rank. I plan to work closely with my district, faith-based organizations and community members to create the change we need in CPD.",
  },
  {
    firstname: "Coston",
    lastname: "Plummer",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 2,
    occupation: "Homecare worker",
    dob: "11/30/1979",
    civic:
      "Attended Robert Fulton Grade School; member of SEIU, United Working Families and the Chicago Alliance Against Racist and Political Repression (CAARPR).",
    candidatevideo: "",
    website: "https://www.votecostonplummer.net/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issue facing the 2nd police district is that the powers to be do not include the community when it comes to making decisions that affect the community. And the community doesn't have a say in what policing looks like in their community.",
  },
  {
    firstname: "Craig T.",
    lastname: "Carrington",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 3,
    occupation: "Paralegal",
    dob: "09/13/1963",
    civic:
      "Chicago State Univ., paralegal certification; community court case manager for the Restorative Justice Community Court in Englewood; served as a court liaison at the Cook County Office of the Chief Judge",
    candidatevideo: "",
    website: "https://carringtonfor3rdpolicedistrictcouncil.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/craigtracecarrington/",
    statement:
      "The biggest issues facing the 3rd district are the lack of trust between residents and the police, the cultural insensitivity when it comes to policing and the heavy-handed tactics employed by CPD. I will facilitate open and ongoing dialogue by hosting public forums where residents will have a voice, create programs where residents will be able to engage with district councilors and implement restorative justice hubs to nurture and repair the harm between the residents and the police. I will also work to have bad police officers removed from the force.",
  },
  {
    firstname: "Cynthia",
    lastname: "McFadden",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 24,
    occupation: "Employment specialist",
    dob: "04/14/1964",
    civic:
      "Lincoln Univ., BA; 2002 Democratic primary winner, Missouri state representative",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100088712797419",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Number one issue in my community is the game violence and crime. The members of my community want the officers to be trained on the 1st Amendment rights, 5th Amendment rights and the right to attain a subset. The issue to address to combat crime and ensure the safety of the officers in the 24th District is training — proper regular training for officers. The second issue is communication and collaboration between the police commander and the community, and collaborating on other public safety ideas to create safety in the community. I will meet with the community in a town hall meeting every month getting their corrections, directions and concerns, take it back to my committee members, and address the commissioners on the city ordinance level and the superintendent of the police department to get them active on the legislative level.",
  },
  {
    firstname: "Dan",
    lastname: "Richman",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 19,
    occupation: "Radio station sales manager",
    dob: "02/24/1967",
    civic:
      "Bradley Univ., BS; board member, head of security, Roscoe Village Neighbors; CAPS beat facilitator (1921); board member, 19th Dist. District Council",
    candidatevideo: "",
    website: "n/a",
    fb: "https://www.facebook.com/profile.php?id=100088219916598",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Carjackings and crime are on the rise. Many residents do not trust the police. Safety of the unhoused and mental health reform need to be addressed. I will continue to educate the community to make sure residents know to call 911 if they are in or witness a potentially dangerous situation. I will do my best to make sure the police are properly trained, so their community interactions are fair and unbiased. Residents need to be made aware of the new CARE program. I will work on these concerns by building trust between residents and the police.",
  },
  {
    firstname: "Daniel",
    lastname: "Butterworth",
    ballotorder: 7,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 16,
    occupation: "Financial inclusion advocate",
    dob: "08/11/1987",
    civic:
      "DePaul Univ., MBA; UIC, BA; participant, Chicago Police Community Academy; board member, Portage Park Chamber of Commerce",
    candidatevideo: "",
    website: "https://www.butters416.com/",
    fb: "https://www.facebook.com/butters416th",
    twitter: "@DanButtersChi",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/dan-butterworth-284a8056",
    statement:
      "I will work with the residents, officers and community stakeholders of the 16th District and around the city to strengthen our community connection and bring our neighborhoods (and neighbors) closer together. From increased awareness of community policing initiatives, accurate and transparent reporting and information, to open and interactive meetings — I will keep my district engaged and informed. Every community’s voice deserves to be heard on important discussions regarding policy, especially when they impact community and officer safety. Safety is non-partisan and takes all of us working together. I seek to build consensus not tear apart what connects us.",
  },
  {
    firstname: "Daniel",
    lastname: "Wolk",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 24,
    occupation: "Self-employed tutor",
    dob: "07/17/1955",
    civic:
      "UChicago, MA; Univ. of Pennsylvania, BA; member, Represent.US; Civic Saturday Fellow, Citizen University",
    candidatevideo: "",
    website: "https://danielwolkfor24.wixsite.com/wolk1",
    fb: "https://www.facebook.com/danielwolkfor24",
    twitter: "@qariwa",
    ig: "https://www.instagram.com/daniel4pdc24/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I perceive two main sets of concerns. On the one hand, many people are worried about the dramatic spike in crime, including murder, car theft, burglaries, shootings, and hate crimes, and feel that the police and detectives have been insufficiently responsive. On the other hand, many feel a dearth of alternatives to policing such as crisis intervention. Both problems can be addressed by bringing violence interruption programs and the Chicago Neighborhood Policing Initiative, a resident-centric community policing approach, to the district. The challenges would be to avoid endangering violence interrupters and be tailored to the local community.",
  },
  {
    firstname: "Daniel",
    lastname: "Martin",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 16,
    occupation: "Legislative aide",
    dob: "09/23/1993",
    civic: "Univ. of Dayton, BA political science",
    candidatevideo: "",
    website: "https://danmartin16.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The largest issue in the 16th District is manpower. While this is a city wide issue it is significant here on the Northwest Side as we live in one the largest police districts in the city. Officers won’t be hired in today's political climate. Pay and benefits do not matter when you are trying to recruit candidates for a job that is not respected. Respect on behalf of officers must be returned in order to recruit officers and address the lack of manpower in the police department.",
  },
  {
    firstname: "Darius",
    lastname: "Newsome",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 15,
    occupation: "Higher education administrator",
    dob: "11/26/1993",
    civic:
      "UIC, MA, public administration; director for educational partnerships, UIC",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/dariusnewsome/",
    statement:
      "Within the 15th district and black and brown communities across Chicago, there is a lack of trust in the police. This stems from a long history of abuse of power by the police and police brutality. If I am fortunate to be elected a member of the district council, I will raise the concerns of the community to the police department and the CCPSA. This will entail me holding frequent meetings with the community where they can come and share concerns and ideas to address the issues as it relates to policing in our community.",
  },
  {
    firstname: "Darrell",
    lastname: "Dacres",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 20,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "https://www.our20thdistrict.com/",
    fb: "",
    twitter: "",
    ig: "https://www.instagram.com/our20thdistrict/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "David",
    lastname: "Boykin",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 6,
    occupation: "Musician",
    dob: "09/03/1969",
    civic: "Northeastern Illinois Univ., MA, Inner City Studies; CPS teacher",
    candidatevideo: "",
    website: "https://electdavidboykin.com/index.html",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/david-boykin-68340a9/",
    statement:
      "The biggest issues facing my district when it comes to policing are the disparity in all crime-related statistics between my district and those with higher incomes and larger populations of white residents. To address these issues I will facilitate a safe space for residents to convene to discuss, strategize, and organize around this issue. I will effectively communicate their concerns and demands to the commission that presides over the District Council and can directly influence police policy and procedure. I will support the efforts of the community to engage in policing alternatives with the full authority of my office.",
  },
  {
    firstname: "David",
    lastname: "Orlikoff",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 14,
    occupation: "Grassroots organizer",
    dob: "01/19/1989",
    civic: "Columbia College Chicago, BA, film and journalism",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Chicago spends among the most per capita of any U.S. or global city on police. It's not a question of bad apples but a system that allows them to abuse their position. Police should not be above the law or the people. There isn't anyone you should trust to use their power and authority to police themselves. And there isn't a single politician you should trust saying the police are the solution to all our problems.",
  },
  {
    firstname: "David Earl",
    lastname: "Williams III",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 24,
    occupation: "Medical logistics specialist",
    dob: "01/08/1984",
    civic:
      "Lethbridge College, BA; former candidate, 9th US House District (Republican), 48th Ward Ald. (Independent); volunteer, Chuy Garcia's 2015 and Lori Lightfoot’s 2019 mayoral campaigns",
    candidatevideo: "",
    website: "https://dewforpolitics.com/",
    fb: "https://www.facebook.com/dewforpolitics",
    twitter: "@dewforpolitics",
    ig: "https://www.instagram.com/dewforpolitics/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Public safety is an issue not just in Chicago’s 24th Police District, but Chicago as a whole. Now, what’s the solution? We need to have a conversation and get the city council, along with the mayor, to reconsider not using taxpayer funds of $82 million annually to bail out CPD misconduct settlements. They have a union; they need to pay for their own liability insurance as everyone else does. Also, we need to investigate where the annual CPD budget of $1.9 Billion (as of 2022) is going. It’s kind of odd that a police officer when injured, disabled, or when deceased the families have to rely on GoFundMe donations when they’re a part of a union.",
  },
  {
    firstname: "David M.",
    lastname: "Feller",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 16,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Deirdre",
    lastname: "O'Connor",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 20,
    occupation: "Community organizer",
    dob: "09/23/1987",
    civic:
      "Lincoln Park High School; St. Xavier Univ., BA; former volunteer for Ald. Patrick O'Connor; volunteer, Neighbors for Andre; advocate leader, OCRA",
    candidatevideo: "",
    website: "https://www.our20thdistrict.com/",
    fb: "",
    twitter: "",
    ig: "https://www.instagram.com/our20thdistrict/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "We have spoken with hundreds of neighbors and public safety is a top priority. We are in a unique position to re-envision how we approach public safety in our communities. Neighbors are interested in seeing investment in Treatment Not Trauma and violence prevention. Partnering up with various community organization's and our local elected officials can help us communicate to neighbors in real time what is happening in their neighborhoods. Engaging in open and transparent dialogue while working alongside the commission will ensure overall improvement in public safety.",
  },
  {
    firstname: "Demerike",
    lastname: "Palecek",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 19,
    occupation: "Marketing/events director",
    dob: "05/31/1991",
    civic:
      "Columbia College Chicago, BA; veteran, Army National Guard, US Air Force; president, 46th Ward Democrats; veterans caucus director, Young Democrats of Illinois",
    candidatevideo: "",
    website: "https://www.demerikepalecek.com/",
    fb: "https://www.facebook.com/Palecekfor19thDistrict",
    twitter: "",
    ig: "https://www.instagram.com/palecekfor19thdistrict/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Police accountability: I support thorough diversity, equity, and implicit bias training for all law enforcement personnel, and external investigations of all misconduct allegations. Reallocation of police funding: I support reallocation of funds to better address root causes of crime, including insecurity in access to healthcare, housing, food, and jobs. I will collaborate with social service providers in these efforts. Restorative justice: I support building restorative justice programs that prioritize rehabilitation over punishment. By building programs that help to improve mental health, build workplace skills, and alleviate other root causes of crime, we will keep our communities safer and healthier.",
  },
  {
    firstname: "Denise E.",
    lastname: "McBroom",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 9,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Deondre",
    lastname: "Rutues",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 15,
    occupation: "Community organizer",
    dob: "06/24/1987",
    civic: "The Chicago School, PhD, business psychology",
    candidatevideo: "",
    website: "https://deondrerutues.com/district-council-candidate/",
    fb: "https://www.facebook.com/Rutuesfor15thDC",
    twitter: "@deondrerutues",
    ig: "https://www.instagram.com/deondrerutues/",
    tiktok: "",
    youtube: "",
    linkedin:
      "https://www.linkedin.com/in/deondre-rutues-maio-mba-phd-candidate-a144875a/",
    statement:
      "Recent studies from the ACLU suggest that Black and Latino neighborhoods typically receive slow or no response to 911 calls. Similarly, 2020 traffic stop data reveals that Black drivers in West Side neighborhoods are disproportionately subjected to police bias. To ensure the police department is held accountable, I am advocating for the publication of police response times and for policy changes that will promote equal service across all communities. Additionally, I am pushing for data that details the reasoning behind the inequity. By increasing transparency and accountability of the police department, we can create more equitable policies and better services.",
  },
  {
    firstname: "Dion Terrell",
    lastname: "McGill",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 7,
    occupation: "Violence prevention advocate",
    dob: "09/10/1979",
    civic:
      "Saint Xavier Univ., BA, social sciences; Civic Leadership Academy fellow at the UChicago; former program manager, Illinois Council Against Handgun Violence",
    candidatevideo: "",
    website: "https://www.mcgillfor7thdistrict.com/",
    fb: "https://www.facebook.com/profile.php?id=100085570837293",
    twitter: "@McGillFor7th",
    ig: "https://www.instagram.com/mcgillfor7th/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/dion-mcgill-2b7084b0",
    statement:
      "One of the biggest issues within the community is the absence of a positive relationship between large portions of the community and the police department. After the installment of the District Councils, I would love to develop a series of peace circles, healing circles, and love circles to engage all members of the 7th Police District, particularly youth to allow for relationship and community building. It will be a long road to reconciliation between police and community members and CPD needs to fall within full compliance with the consent decree.",
  },
  {
    firstname: "Edgar “Edek”",
    lastname: "Esparza",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 25,
    occupation: "Elementary school teacher",
    dob: "12/15/1995",
    civic:
      "Univ. of Chicago, MA; Columbia University  BA; Wilbur Wright College, AA",
    candidatevideo: "",
    website: "https://electedgar.com/",
    fb: "",
    twitter: "@ElectEdgar",
    ig: "https://www.instagram.com/ElectEdgar/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I'm running for three reasons: public safety, reform & constituent inclusion. We can't have public safety without reform, and we certainly can't fix a system without input from those who live under such a system every day. I want to bring about the much-needed return to safe neighborhoods while also moving us towards a better police department with community-involved policing methods, policies and tactics. The 25th Police District in Chicago is vast: seven neighborhoods, eight wards and fifteen beats. We have experts in fields that include and surround criminal justice and policing; they're called residents. And for years these residents have organized to become part of the solution when it comes to issues of community engagement, reform and public safety.",
  },
  {
    firstname: "EdVette W.",
    lastname: "Jones",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 24,
    occupation: "Professional photographer, writer",
    dob: "03/28/1970",
    civic:
      "Teaching artist, Envisioning Justice Initiative; volunteer, Circles and Ciphers Youth Organization; policy writing team, GAPA police accountability ordinance; federal and state lobbyist",
    candidatevideo: "",
    website: "https://www.uniting24.com/",
    fb: "https://www.facebook.com/uniting24",
    twitter: "@uniting24",
    ig: "https://www.instagram.com/uniting24/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "My current issues are the gang database, lack of accountability for crimes, lack of beat presence/ community involvement, budget transparency and racial profiling.",
  },
  {
    firstname: "Elena X.",
    lastname: "Thompson",
    ballotorder: 7,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 15,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Elianne",
    lastname: "Bahena",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 10,
    occupation: "Community outreach director",
    dob: "01/25/1991",
    civic:
      "Roosevelt Univ., BA, history; board member, Directors of Mujeres Latinas en Accion; chair, Young Women’s Giving Council at the Chicago Foundation for Women",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100089550816235",
    twitter: "",
    ig: "https://www.instagram.com/bahenafor10/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/elianne-bahena-156a681a8/",
    statement:
      "As a lifelong Little Village resident and a community advocate, I am running for the police district council to ensure that the voice of our community is at the forefront of policy making decisions. Our community should decide what our priorities are and how they should be addressed when it comes to policing our own neighborhoods, and have opportunities for community engagement with the appropriate resources (safe spaces, language accessibility, access to programming) to effectively communicate and foster community. Together, we can begin to build stronger and safer communities across the 10th police district.",
  },
  {
    firstname: "Elizabeth “Beth”",
    lastname: "Rochford",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 17,
    occupation: "Nurse practitioner",
    dob: "06/15/1965",
    civic:
      "Rush Univ., MS; Boston College, BS; organizer, Northside Police Accountability Task Force and Violence Prevention Coalition; member St. Clement Church Justice Ministry, Immigration Ministry, Creation Care Ministry",
    candidatevideo: "",
    website: "https://www.rochfordfordistrictcouncil.com/",
    fb: "https://www.facebook.com/profile.php?id=100085261031416",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I hear many constituents say the biggest issue is that the voice of the community is not heard on policing. From vulnerable and marginalized residents I hear that unequal treatment is their major concern. The monthly neighbor-to-neighbor meetings we will hold will give community members a forum that is not run by the police where they can bring their issues and ideas. I will engage the community to help develop the policies that govern the police and ensure that they are evidence-based.",
  },
  {
    firstname: "Ephraim",
    lastname: "Lee",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 2,
    occupation: "Naval officer",
    dob: "07/17/1970",
    civic:
      "UIC MA, social work; Chicago Alternative Policing Strategy beat 215 facilitator",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issues affecting my district are police visibility, accountability and an organizational code of conduct. We must focus on building a new bridge of trust between citizens of the 2nd police district and the police department. For too long, this city has allowed CPD to act without a clear code of conduct and ethical values. This failure has created a gulf between those who seek justice and those paid and sworn to deliver it. A renewed commitment towards working together against evil in our neighborhoods must be clear, concise, and unfettered to past mistakes.",
  },
  {
    firstname: "Eric",
    lastname: "Russell",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 6,
    occupation: "Civil rights advocate",
    dob: "09/05/1964",
    civic: "Director, Tree of Life Justice League",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The two biggest issues facing the 6th police district is the need for real police transparency, reform and accountability. The other issue is the need for a comprehensive public safety plan where the community and police form a partnership to help curb gun violence.",
  },
  {
    firstname: "Erin",
    lastname: "Vogel",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 9,
    occupation: "Insurance advisor",
    dob: "12/05/1989",
    civic:
      "UIC BA, sociology and criminology, law, and justice; former director, I Grow Chicago",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100089149004466",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest policing-related issues facing the 9th police district are trauma and lack of connectedness. While canvassing throughout the 9th district, neighbors expressed worry about the impact of the job on officers and mental health not prioritized within CPD and the government. Many noted the fractured relationship between CPD and the community. I'd address these issues by bringing people together -- preferably over a meal. We are safer when we know our neighbors. Public safety includes support for services known to reduce crime like education, housing and mental and physical healthcare. Together, as a community, we can shape accountability with care.",
  },
  {
    firstname: "Evelyn",
    lastname: "Razo",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 9,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Gloria",
    lastname: "Jenkins",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 4,
    occupation: "Workforce development manager",
    dob: "10/02/1978",
    civic: "Chicago State Univ., BA, psychology",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Working to ensure we express the concerns of the community to make the 4th police district safer is my primary priority. Advocacy for underserved populations has been my priority throughout my professional career. Oftentimes community members don’t feel heard and are hesitant to make their complaints public at beat meetings. It's important to me that residents in the 4th police district voices are heard. Together we are stronger when we are informed of issues and resources available to us. I want to keep my neighbors informed about issues and resources that affect us all.",
  },
  {
    firstname: "Ja'Mal",
    lastname: "Green",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Community activist",
    dob: "08/09/1995",
    civic: "",
    candidatevideo: "https://youtu.be/uiWhxoR9Tv0",
    website: "",
    fb: "https://www.facebook.com/Jaymalgreen",
    twitter: "@JaymalGreen",
    ig: "https://www.instagram.com/jaymalgreen/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jaymalgreen/",
    statement: "",
  },
  {
    firstname: "Jacob",
    lastname: "Arena",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 25,
    occupation: "Event planner",
    dob: "09/15/2000",
    civic: "Burlington High School; volunteer, Elevated Chapter Coat Drive",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Trust and confidence between the community and our police is the biggest issue facing our district. I am personally aware of the sacrifices and risks that our police take to protect us. However, due to poor resources and being understaffed, our police are put in situations where life changing consequences can occur. On the district council, I plan to promote opportunities for the community to have positive interactions with our police and support our police. By promoting familiarity between our communities and our police, we can inspire our community’s trust and confidence in our police.",
  },
  {
    firstname: "Jamie E.",
    lastname: "Brown",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 1,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jebrown11/",
    statement: "",
  },
  {
    firstname: "Janice",
    lastname: "Jones",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 3,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Jason",
    lastname: "Huff",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 8,
    occupation: "City of Chicago employee",
    dob: "11/02/1983",
    civic: "Kennedy High School; oversees the Scottsdale Neighborhood Watch",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/jhuff6232/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Currently, biggest issues are the size of district, manpower, and response times. I will work with others to redraw all districts or split the 8th police district into two. Reducing size will help with manpower and response time issues.",
  },
  {
    firstname: "Jennifer A.",
    lastname: "Schaffer",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 19,
    occupation: "Community activist",
    dob: "07/09/1981",
    civic:
      "Northeastern Illinois Univ., MA; Miami Univ., BA; former special education teacher; founder, Coonley Elementary Antiracism Group; former member Embarc Auxiliary Board",
    candidatevideo: "",
    website: "https://www.19thtogether.com/",
    fb: "https://www.facebook.com/19thTogether",
    twitter: "@19thTogether",
    ig: "https://www.instagram.com/19thtogether/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issue is people do not feel safe in their neighborhood. As a Police District Council member, I will push forward innovative, research-based strategies that will make our neighborhoods safer for all residents. My primary goal is to create a modernized vision of public safety. This includes advocating for more responsible, effective, and fair policing, but also expanding emergency services to include mental health crisis teams, drug addiction treatment programs, and homelessness response providers. I will bring agency to our community, elevate and amplify marginalized voices, and use people-power to drive government officials to modernize our overarching public safety system.",
  },
  {
    firstname: "Jesús “Chuy”",
    lastname: "García",
    ballotorder: 9,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Congressman, 4th District",
    dob: "04/12/1956",
    civic: "",
    candidatevideo: "https://youtu.be/OlNHrYpJaq8",
    website: "",
    fb: "https://www.facebook.com/ChuyForChicago/",
    twitter: "@RepChuyGarcia",
    ig: "https://www.instagram.com/repchuygarcia/?hl=en",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Jim",
    lastname: "Blissitt III",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 3,
    occupation: "Doctoral student and lecturer",
    dob: "10/25/1985",
    civic:
      "Depaul Univ., MA, sociology; program manager at the Chicago Urban League",
    candidatevideo: "",
    website: "https://www.3rdpolicedistrict.com/",
    fb: "https://www.facebook.com/groups/1394251851033543/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jim-blissitt-iii-2a502570/",
    statement:
      "The 3rd police district has slow police response times. We must hold apathetic leadership, officers and operators accountable. We must also address structural recruitment issues that have led to low hiring rates of African Americans to CPD. We must engage ancillary municipal departments such as DFSS to promote mental health intervention through the dissemination of treatment as opposed to trauma in the maintenance of public safety. We must increase the use of technology, including video surveillance, to arrive at public safety. We must also decrease the time it takes for COPA to investigate reports of abuse.",
  },
  {
    firstname: "Jocelyn A.",
    lastname: "Woodards",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 11,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "John",
    lastname: "Donatelli",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 12,
    occupation: "Real estate broker",
    dob: "06/21/1967",
    civic: "Attended Loyola Univ. Chicago",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/john-donatelli-85986615/",
    statement:
      "Theft of all sorts. Too few police officers to handle the district.",
  },
  {
    firstname: "John M.",
    lastname: "Marcatante",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 16,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Joseph",
    lastname: "Williams",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 7,
    occupation: "Nonprofit director",
    dob: "07/06/1989",
    civic:
      "Chicago State Univ., BS, criminal justice; founded Mr. Dad’s Father’s Club to help fathers become actively involved in their children’s lives; chair, Local School Council and Parent Adivsory Council of the Beasley Academic Center",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/josephgwilliams32/",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "One of the most important things for our district is building stronger connections between the police and the community. My goal is to help connect our district to multiple outlets such as churches, nonprofits, and local community members to help build better relationships. Police should know the community they serve.",
  },
  {
    firstname: "Joshua",
    lastname: "D'Antonio",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 20,
    occupation: "Former nonprofit fundraiser",
    dob: "11/11/1991",
    civic:
      "George Mason Univ., BA; volunteer, educator, Chicago Alliance Against Racist and Political Repression",
    candidatevideo: "",
    website: "https://www.joshfor20th.com/",
    fb: "",
    twitter: "",
    ig: "https://www.instagram.com/joshfor20th/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/joshua-d-antonio/",
    statement:
      "The 20th district is very diverse. Homeowners pay for the bloated police budget through high taxes, unhoused neighbors are often the victims of abuse, and the LGBTQ population has long been the target of police violence. Our district is generally safe. When harm is committed there can be a sense of fear and distrust of our neighbors. I plan to use this position to help strengthen the bonds of the community and find solutions to harm that do not require the police. Interactions with the police come with a threat of violence. We can do better in the 20th district.",
  },
  {
    firstname: "Juan",
    lastname: "Lopez",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 12,
    occupation: "Security consultant",
    dob: "12/15/1984",
    civic: "Loyola Univ. Chicago, BA, criminal justice",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100088940132070",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 12th district is one of the largest districts in the city of Chicago. A few of the issues that we are facing are high crime rates due to shortage in officers, community mistrust, mental health issues, and violent crimes needing to be fully prosecuted from start to end. I will ensure these topics continue to be a prime focus and work with the community to ensure we are kept in the loop as changes occur.",
  },
  {
    firstname: "Julia",
    lastname: "Kline",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 2,
    occupation: "Sales and marketing consultant",
    dob: "09/09/1970",
    civic:
      "National Louis Univ., MA, elementary education; cofounded Cleveland of Neighbors Who Vote",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "@Julia_Kline",
    ig: "https://www.instagram.com/Julia_Kline4/",
    tiktok: "",
    youtube: "",
    linkedin: "https://linkedin.com/in/juliakline",
    statement:
      "The 2nd police district isn't thought of as a particularly high-crime area. But the recent spike in carjackings along with a few high-profile shootings have made many neighbors feel afraid. Unfortunately, response times by police are often unacceptable. The path to safety is through restorative justice practices, violence intervention, outreach to the most at-risk people and community investment. Our role as district councilors is to organize the community and prioritize these issues. Then we can start addressing them one step at a time.",
  },
  {
    firstname: "Julienn “Julie”",
    lastname: "Kaviar",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 19,
    occupation: "Chief of staff for a Cook County commissioner",
    dob: "07/17/1987",
    civic:
      "Tufts Univ., BA; attendee, 2023 Illinois Women’s Institute for Leadership Training Academy",
    candidatevideo: "",
    website: "https://www.juliekaviar.com/",
    fb: "https://www.facebook.com/JulieForPoliceDistrictCouncil/",
    twitter: "",
    ig: "https://www.instagram.com/juliekaviar/",
    tiktok: "https://www.tiktok.com/@juliekaviar",
    youtube: "",
    linkedin: "",
    statement:
      "We don’t have to choose between community safety and police accountability. We can create collaborative, accountable, responsible, and equitable community safety. In District 19, motor vehicle thefts alone were up 94% in 2022. Additional safety operations are needed in the short-term like catalytic converter marking and license plate readers. Local victim advocacy helps residents understand what the police are doing to solve the crime and supports choices for justice and restoration. Simultaneously, long-term investment is needed to create resourced communities with real access to opportunities citywide. Addressing officer implicit bias and misconduct repairs trust in communities which keeps us all safer.",
  },
  {
    firstname: "Julio",
    lastname: "Miramontes",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 4,
    occupation: "Community organizer",
    dob: "11/19/1990",
    civic:
      "Southern Illinois Univ., BA, pyschology; board member, East Side Chamber of Commerce; co-founder, United United Neighbors of the 10th Ward Independent Political Organization",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100089571243153",
    twitter: "@julio4ecps",
    ig: "https://www.instagram.com/julio4ecps/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/julio-miramontes-89435827/",
    statement:
      "Our biggest issue is our lack of resources. We must address the root causes of our public safety issues by investing in people. Communities should have access to youth programs, mental health resources, affordable housing and groceries, quality schools, jobs, healthcare and clean parks. We should reduce our reliance on the police for mental health related 911 calls. I support the Treatment not Trauma initiative because we must stop the criminalization of those suffering from addiction or experiencing homelessness. Every child in Chicago should have access to the resources that will ensure they reach their fullest potential.",
  },
  {
    firstname: "Kam",
    lastname: "Buckner",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "State representative",
    dob: "05/12/1985",
    civic: "",
    candidatevideo: "https://youtu.be/3DS4uXNcqzo",
    website: "",
    fb: "https://www.facebook.com/RepKamBuckner",
    twitter: "@RepKamBuckner",
    ig: "https://www.instagram.com/kambucknerchi/",
    tiktok: "https://www.tiktok.com/@repkambuckner",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/kam-buckner-7b29613a/",
    statement: "",
  },
  {
    firstname: "Karen",
    lastname: "Winters",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 15,
    occupation: "Organizer and activist",
    dob: "11/03/1965",
    civic:
      "Advocate with the Chicago Consent Decree Coalition; member, Chicago Torture Justice Center.",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issue facing my district when it comes to policing is systemic and institutional racism and how it impacts residents on many levels. One of the ways I hope to address this is by implementing racial equity training within the department, followed by racial healing & restorative justice circles. Possibly working with the Community Policing department on having officers, especially new officers, spend time in the community, authentically engaging with residents and getting to know them in an unofficial capacity, before they have to respond to a call.",
  },
  {
    firstname: "Karen",
    lastname: "Kane",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 18,
    occupation: "Financial consultant",
    dob: "05/07/1955",
    civic:
      "Northern Illinois Univ., BS; Northwestern Univ., MBA; past chair, Board of Trustees, Marillac St. Vincent Family Services; board member, Anixter Center Foundation, Civic Federation’s Advisory Council",
    candidatevideo: "",
    website: "https://karenkane.carrd.co/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      'Crime in the 18th has increased significantly, but police staffing/911 response times have decreased significantly. I will advocate for a police budget that contains adequate funding to improve the staffing levels and resources in the 18th Ward. Use of technology should increase — additional LPR cameras (License Plate Readers), PTZ (pan, tilt zoom) should be funded and installed. I will coordinate efforts with the community to increase the number of private cameras connected with CPD. Air support (helicopters/drones) is needed. "Public engagement equals public safety" means building high levels of community engagement will build public safety. Will create an advisory council to fight crime.',
  },
  {
    firstname: "Kenya",
    lastname: "Franklin",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 3,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Kiisha",
    lastname: "Smith",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 10,
    occupation: "Youth advocate",
    dob: "02/28/1978",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issues we face in the 10th police district are abuse, disrespect, harassment, sexual assault, vulgar language and behavior … Excessive force, illegal searches and arrests and murder. Holding the police accountable would include conducting an investigation to ensure that they are properly serving and protecting our communities. And if not, a penalty or punishment that fits the crime they’ve committed would suffice. Whether it be a conviction, fines, jail time, suspension without pay or termination.",
  },
  {
    firstname: "Kimberly Lynn",
    lastname: "Bowman",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 18,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "https://kimbowman.carrd.co/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Krystal",
    lastname: "Peters",
    ballotorder: 7,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 7,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Larry",
    lastname: "Lawrence",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 10,
    occupation: "Pastor and Cook County employee",
    dob: "02/20/1969",
    civic: "Florida Memorial Univ., BA psychology",
    candidatevideo: "",
    website: "https://larrylawrenceforpolicedistrict10.org/",
    fb: "https://www.facebook.com/profile.php?id=100089205661300",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issues facing the district where I live are the responses to incidents in our communities that put the lives of citizens at risk, and the treatment of our citizens as if they are not human. If elected, I will work with the police department by holding them accountable to protect and serve the communities in which they work.",
  },
  {
    firstname: "Lee",
    lastname: "Bielecki",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 22,
    occupation: "Retired Chicago Police Sgt.",
    dob: "08/03/57",
    civic:
      "Former Chicago Police Sergeant; volunteer, Chicago Police Department Employee Assistance Program, Chicago Police Memorial Foundation",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I will be a voice for my community. The biggest issue facing our district is the lack of police personnel. The department is currently understaffed by at least 2,000 officers. Despite the hiring in 2022 it still does not make up for retirements and resignations of officers leaving for other departments. This makes the citizens in my community and the city at large less safe.",
  },
  {
    firstname: "Leo",
    lastname: "Guzman",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 10,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Leonardo",
    lastname: "Quintero",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 12,
    occupation: "Violence interrupter and substance abuse counselor",
    dob: "11/07/1989",
    civic: "Wilbur Wright College, certified alcohol & drug counselor",
    candidatevideo: "",
    website: "http://ecpsdistrict12.com/",
    fb: "https://www.facebook.com/profile.php?id=100086099723887&mibextid=LQQJ4d",
    twitter: "",
    ig: "https://www.instagram.com/leofordistrict12/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The relationship between law enforcement and our communities has been marked by tension, mistrust, and hostility. These issues must be addressed for the relationship to begin mending. This means having civilian-led oversight, and continued training and evaluations amongst police is needed. We must also ensure that the criminal justice system is fair and just for all. Restorative justice approaches have been effective in reducing recidivism and creating a more just and equitable system; prevention, intervention, mediation and second opportunity programming along with community courts are all examples.",
  },
  {
    firstname: "Letina K.",
    lastname: "Brady Pettis",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 8,
    occupation: "Community organizer",
    dob: "02/28/1975",
    civic:
      "Purdue Univ. Global, MA, legal studies; graduate, Citizens Police Academy program",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100084224266786",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 8th police district is among the largest in Chicago. There is a need for more policing in my community. We need more consistent police presence and traffic enforcement in our commercial areas—more police involvement in the communities of the 8th district, with the Chicago Alternative Policing Strategy (CAPS) assisting with businesses and youth. I plan to hit the ground running, networking with the constituents to learn what issues they deem necessary and what changes they would like to see. Bridging the gap and holding all stakeholders accountable is very important to me.",
  },
  {
    firstname: "Linda J.",
    lastname: "Austin Sr.",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 7,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Lisa",
    lastname: "Seigneur",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 18,
    occupation: "Business consultant",
    dob: "06/01/1977",
    civic: "Augustana College, BA",
    candidatevideo: "",
    website: "https://voteforlisa.com/home",
    fb: "https://www.facebook.com/profile.php?id=100089376906643",
    twitter: "@CPDDistCouncil",
    ig: "https://www.instagram.com/18thDistPoliceCouncil/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issue facing our Near North District 18 is crime committed by non-residents, leaving residents unsafe and uncertain of how to remedy. As the pro-police 18th District Councilperson, I'll act as a listening agent and trusted advisor to form a safety strategy with our residents and businesses. In monthly public town hall meetings I intend to collect feedback/concerns, escalate input, partner with CPD/local officials, influence safety policy, and be the safety advocate that addresses our needs and supports law enforcement. I’ll deliver overall crime reduction rates and partner with our justice system to also reduce repeat offender crime rates.",
  },
  {
    firstname: "Lori E.",
    lastname: "Lightfoot",
    ballotorder: 7,
    "ward#": "",
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Mayor of Chicago",
    dob: "08/04/1962",
    civic: "",
    candidatevideo: "https://youtu.be/xNa1ePyJWK0",
    website: "",
    fb: "https://www.facebook.com/LightfootForChicago",
    twitter: "@LoriLightfoot",
    ig: "https://www.instagram.com/chicagosmayor/",
    tiktok: "https://www.tiktok.com/@mayorlightfoot?lang=en",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/lori-lightfoot-27a60aa/",
    statement: "",
  },
  {
    firstname: "Lovie",
    lastname: "Bernard",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 4,
    occupation: "Volunteer for alderperson",
    dob: "02/28/1952",
    civic: "Univ. of Illinois, BA political science",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Lack of police presence. Sometimes they respond to our calls, sometimes not. [Police] not being respectful nor being familiar with the area. Was told we need 10 callers before they urgently respond.",
  },
  {
    firstname: "Maggie",
    lastname: "Finucane",
    ballotorder: 7,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 9,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Marilyn",
    lastname: "Pagán-Banks",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 24,
    occupation: "Community organizer",
    dob: "07/13/67",
    civic:
      "McCormick Theological Seminary, MDiv; Chicago Theological Seminary, DMin; member, Use of Force Task Force",
    candidatevideo: "",
    website: "https://www.uniting24.com/",
    fb: "https://www.facebook.com/uniting24",
    twitter: "@uniting24",
    ig: "https://www.instagram.com/uniting24/",
    tiktok: "",
    youtube: "",
    linkedin:
      "https://www.linkedin.com/in/rev-dr-marilyn-pag%C3%A1n-banks-370b3433/",
    statement:
      "As a District Council member, I plan to work with the community in addressing the issues of: a) Community events and spaces that bring folks together and keeps our children safe (something I hear from many community members); b) Know Your Rights Wisdom Sharing; c) Healing and restorative justice opportunities; d) Working to stop the war between the two factions in the district; e) Safety from police violence and harassment; f) Safety from economic violence and disenfranchisement",
  },
  {
    firstname: "Mark",
    lastname: "Hamberlin",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 8,
    occupation: "Teacher",
    dob: "01/20/1972",
    civic: "Attended Alcorn State Univ.",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Basically, I am a humble servant ready to service the 8th district. I am a former school teacher and currently a Illinois High School Association official. I am also a union steward at Avis Budget. I think I can bridge the gap between police and civilians. I know how to deal with people from all walks of life. I am also a member of Kappa Alpha Psi fraternity.",
  },
  {
    firstname: "Matthew",
    lastname: "Bianciotto",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 22,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Maurilio",
    lastname: "Garcia",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 19,
    occupation: "Market research consultant",
    dob: "08/18/1987",
    civic:
      "Northwestern Univ., MS, BS; founder, Connell Community Collaboration",
    candidatevideo: "",
    website: "https://www.19thtogether.com/",
    fb: "https://www.facebook.com/19thTogether",
    twitter: "@19thTogether",
    ig: "https://www.instagram.com/19thtogether/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Running alongside Jenny Schaffer and Sam Schoenburg, our primary goal is to work as a community to advocate for a modernized vision of public safety so that every resident feels safe. This includes expanding emergency services to include mental health crisis teams, substance abuse treatment programs, and homelessness response providers in addition to advocating for more responsible, effective, and fair policing. As District Council members, we’ll push for innovative, research-based strategies that provide more agency to our community members, elevate and amplify marginalized voices, and use people-power to drive government officials to modernize how we approach our district’s overarching public safety system.",
  },
  {
    firstname: "Meredith Vanae",
    lastname: "Hammer",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 4,
    occupation: "Attorney",
    dob: "10/22/1970",
    civic:
      "Indiana Univ. Law, JD; deputy general counsel, Clerk of the Circuit Court of Cook County",
    candidatevideo: "",
    website: "https://www.hammer4policedistrictcouncil.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "There are few, if any, services that address the long-term effects of the lack of affordable housing, mental health challenges and poverty in my community. Police aren’t trained to identify those individuals who need mental health treatment. Police also don’t have the mental health services they need to adequately serve the community. Police don’t reside in my police district and aren’t invested in the community where they could become a police force that protects and serves.",
  },
  {
    firstname: "Michelle D.",
    lastname: "Page",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 12,
    occupation: "Pre-K teacher assistant",
    dob: "06/07/1966",
    civic: "Attended Malcolm X College; member, Chicago Teachers Union",
    candidatevideo: "",
    website: "http://ecpsdistrict12.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest issues facing the 12th district are the unfair and sometimes abusive treatment of black and brown people. There is a lack of trust among residents toward the police. As a result, crimes are under-reported and people of color are hesitant to provide crime-solving information to the police. As a district council member, I would listen to residents about their concerns, help facilitate conversations between the police and residents to build trust and provide input to the Community Commission for Public Safety and Accountability on policies that would ensure that abusive police are held accountable.",
  },
  {
    firstname: "Mitchell",
    lastname: "D. Rose",
    ballotorder: 7,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 24,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Monserrat E.",
    lastname: "Ayala",
    ballotorder: 8,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 9,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "https://www.facebook.com/profile.php?id=100089149004466",
    twitter: "",
    ig: "https://www.instagram.com/monse_esme/?hl=en",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Nick",
    lastname: "Carusi",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 17,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Nolberto",
    lastname: "Casas",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 9,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Oddis",
    lastname: "O. J Johnson",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 15,
    occupation: "Civil rights activist",
    dob: "07/04/1950",
    civic: "Director of United Front Anti-Crime Organization of Illinois",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Biggest problem we have with the 15th police district is the lack of service and the way that CPD personnel police our communities.",
  },
  {
    firstname: "Patrick",
    lastname: "Kennedy",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 22,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Patrick T.",
    lastname: "McNeil",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 20,
    occupation: "Retired US diplomat",
    dob: "01/08/1965",
    civic:
      "Stanford Law School, JD; Univ. of Chicago, BS; volunteer, Credit Abuse Resistance Education; literacy tutor, Jane Addams Resources Corporation",
    candidatevideo: "",
    website: "https://nickoval.wixsite.com/patrickfor20th",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Residents of the 20th District deserve a common sense, centrist approach to police oversight that advocates for police funding while supporting robust oversight of police to end misconduct. The biggest challenges for our residents are property crimes such as break-ins and thefts of vehicles and catalytic converters. I will advocate to fill vacant police positions to ensure adequate police presence in our neighborhoods, prompt response to 911 calls, and timely investigation of crimes. I will also work with residents to build trust with the police, and promptly and transparently respond to complaints about police conduct.",
  },
  {
    firstname: "Paul",
    lastname: "Vallas",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Former city budget director",
    dob: "06/10/1953",
    civic: "",
    candidatevideo: "https://youtu.be/SZygZC79XhM",
    website: "",
    fb: "https://www.facebook.com/PaulGVallas",
    twitter: "@PaulVallas",
    ig: "https://www.instagram.com/paulgvallas/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/paul-vallas-b2564816a/",
    statement: "",
  },
  {
    firstname: "Perry",
    lastname: "Abbasi",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 25,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Ponchita",
    lastname: "Moore",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 5,
    occupation: "Labor organizer",
    dob: "07/26/1974",
    civic: "Attended Northeastern Illinois Univ.",
    candidatevideo: "",
    website: "https://www.voteforponchita.com/home",
    fb: "https://www.facebook.com/voteforponchita",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest policing issues the 5th District face is alarming rates of poverty, unemployment and violence. I will help bridge the gap between the Chicago police and The citizens of the 5th police district. I will work toward sound & reasonable policing/public safety which could be a likely entry point to a thriving community and establishing trust with authorities as well as the public.",
  },
  {
    firstname: "Robert",
    lastname: "Johnson",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 18,
    occupation: "Retired police officer, fire chief",
    dob: "06/08/1944",
    civic:
      "Univ. of Dayton, MBA, BS; former 18th District Police Advisory Committee member, CAPS beat 1833 facilitator, SOAR Safety & Security Task Force chair",
    candidatevideo: "",
    website: "https://bobjohnson.carrd.co/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "Inability of community members and businesses to express their questions and concerns to local law enforcement. Acting as a conduit, I would facilitate answers to their concerns.",
  },
  {
    firstname: "Roderick T.",
    lastname: "Sawyer",
    ballotorder: 8,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Alderperson, 6th Ward",
    dob: "04/12/1963",
    civic: "",
    candidatevideo: "https://youtu.be/3TLGPHIGGo0",
    website: "",
    fb: "https://www.facebook.com/SawyerforChicago",
    twitter: "@Sawyer4Chicago",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/roderick-t-sawyer-29842634/",
    statement: "",
  },
  {
    firstname: "Rosemarie",
    lastname: "Dominguez",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 10,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Samuel E.",
    lastname: "Schoenburg",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 19,
    occupation: "Lawyer",
    dob: "08/10/1989",
    civic:
      "New York Univ., JD; Yale Univ., BA; associate board co-chair, Cabrini Green Legal Aid; committee member, Community Safety Committee; former law clerk, Northern District of Illinois",
    candidatevideo: "",
    website: "https://www.19thtogether.com/",
    fb: "https://www.facebook.com/19thTogether",
    twitter: "@19thTogether",
    ig: "https://www.instagram.com/19thtogether/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "My goal is to work with my neighbors toward a modern public safety system in which all 19th Police District residents feel safe. I, alongside my co-candidates Maurilio Garcia and Jenny Schaffer, will advocate to expand emergency services to include mental health crisis teams, substance abuse treatment, and homelessness response providers—which in turn will allow officers to focus on serious crime. I also want to ensure community members are empowered in public safety decision-making, and that 19th District officers have the resources—like sufficient days off, wellness supports, and up-to-date training—to do their jobs fairly, responsibly, and effectively.",
  },
  {
    firstname: "Sarah",
    lastname: "Kammerer",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 1,
    occupation: "Nonprofit advisor and photographer",
    dob: "11/26/1982",
    civic:
      "UIC, MPH; Virginia TechUniv., BA; serves on ProPublica's Leadership council",
    candidatevideo: "",
    website: "https://www.sarahk.co/civic",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/sarahkammerer/",
    statement:
      "I am looking forward to serving as a liaison between the community and the police to help build relationships and trust. My background leaves me well-positioned to excel in the role and create opportunities for better communication and safer, stronger, and more welcoming neighborhoods.",
  },
  {
    firstname: "Saúl",
    lastname: "Arellano",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 25,
    occupation: "Student aide",
    dob: "12/18/1998",
    civic: "Co-founder, Sanctuary movement; immigration reform advocate",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      'I’m a believer in participatory democracy. By working closely with neighbors, local independent political organizations, and community organizations to come up with the best solutions for our communities. We plan to work with local organizations and IPOs to continue community outreach and educating communities on the importance of reallocating funds towards life-saving city services. Initiatives like "Treatment Not Trauma," a healing program addressing our mental health crisis. The Bring Chicago Home campaign seeks to invest in anti-homelessness efforts. I plan to work alongside progressive legislators to develop ideas to help invest in people. We will engage directly with community members.',
  },
  {
    firstname: "Simeon",
    lastname: "Henderson",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 10,
    occupation: "Teacher",
    dob: "09/09/1972",
    civic: "Attended Roosevelt Univ.; former CPD officer",
    candidatevideo: "",
    website: "https://www.simeonhendersonfor10thdistrictcouncil.com/",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The biggest problem is that there is no communication between the police and the community. There should also be more officers in the community. They understand and know the people. If the community can communicate with the district and the officers and give more input, things can be better. I’m a former CPD officer so I know first hand how how important communication is. I know that I can help bridge the communication gap between the officers in the district and the people to help make it safer for everyone.",
  },
  {
    firstname: "Sophia",
    lastname: "King",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Alderperson, 4th Ward",
    dob: "02/14/1966",
    civic: "",
    candidatevideo: "https://youtu.be/BfT4ShiJz8A",
    website: "",
    fb: "https://www.facebook.com/aldsophiaking",
    twitter: "@aldsophiaking",
    ig: "https://www.instagram.com/aldsophiaking/?hl=en",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Steve",
    lastname: "Spagnolo",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 17,
    occupation: "Government affairs specialist",
    dob: "07/17/1987",
    civic:
      "Seton Hall Univ., BA; fundraiser, violence interruption, Lake County State’s Attorney’s Office; former community Representative, Local School Council, Roosevelt High School, Albany Park Multicultural Academy",
    candidatevideo: "",
    website: "https://steveforchicago.com/",
    fb: "https://www.facebook.com/SteveForChicago",
    twitter: "@SteveForChicago",
    ig: "https://www.instagram.com/steveforchicago/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I think the issues impacting the district are a feeling of lacking accountability for the police, competence issues in police responses to calls, and that there is little transparency willingly provided by CPD or officers. I have been a victim of violent crime and theft in the district and in both instances have seen minimal response from CPD. As a district council member, I will push for creation of a citywide violence reduction strategy, use of evidence-based practices, more investment in violence interrupters, and adoption of the 2019 BJA/PERF recommendations regarding the Bureau of Detectives.",
  },
  {
    firstname: "Teresa R.",
    lastname: "Chandler",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 7,
    occupation: "Community outreach strategist",
    dob: "04/12/1964",
    civic:
      "Northeastern Illinois Univ., MA, inner city studies; volunteer, Peer Plus Education,Training and Voices of West Englewood.",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I have witnessed CPD officers abuse their power toward young African American males. Last month my nephew was wrongly arrested and then later released after his background was cleared. He felt helpless against the officers. I will address issues like this in my district by ensuring police officers wear body cams and have them turned on, creating a community database that provides information on arrests and requiring police partners to report abuses of power to the district councils, COPA, and the CCPSA. I will also create a police hotline where CPD officers can report the wrongdoings of other officers.",
  },
  {
    firstname: "Thomas L.",
    lastname: "McMahon",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 5,
    occupation: "Retired police captain",
    dob: "08/26/1951",
    civic:
      "Chicago State Univ., MS criminal justice; board member, Chicago Neighborhood Initiatives; served as a CAPS District Advisory Council Chair",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "I believe in police accountability through community involvement. The CPD needs to understand that it is the community that wants change. The community wants to have dialogue and communication with its police officers. The community wants a voice in policy changes. Based on my past employment and continued interaction with my local police district, I can help CPD embrace these changes. A better police department means a better and safer community.",
  },
  {
    firstname: "Trisha",
    lastname: "Lynn Kannon Lloyd",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 16,
    occupation: "Real estate broker",
    dob: "09/07/1997",
    civic: "Western Illinois Univ., BA, political science and history",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      "The 16th district is the largest police district in the city and covers over 30 square miles. Our manpower has been reduced over several years. This leaves some beats with no coverage at times. That can also mean that our 911 calls may go unattended. This leaves us with not enough police cars to perform proactive patrolling to act as a deterrent. We need to do a full review of department budgets and analyze how to allocate resources to cover every district in the city and help all Chicagoans including the 16th district neighbors to feel safe.",
  },
  {
    firstname: "Verna",
    lastname: "Swan",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 7,
    occupation: "",
    dob: "",
    civic: "",
    candidatevideo: "",
    website: "",
    fb: "",
    twitter: "",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Veronica I.",
    lastname: "Arreola",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 24,
    occupation: "Educator",
    dob: "12/28/1974",
    civic:
      "UIC, MPA, BS; director of UIC’s Hispanic Serving Institution Initiatives; board member, West Ridge Community Organization; founder, 50th Ward Action Network",
    candidatevideo: "",
    website: "https://www.uniting24.com/",
    fb: "https://www.facebook.com/uniting24",
    twitter: "@uniting24",
    ig: "https://www.instagram.com/uniting24/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/veronicaarreola/",
    statement:
      "The biggest issue facing the 24th police district is balancing the diverse views of what public safety looks like. At the doors, neighbors tell me they want to see police stop harassing young people, especially Black and Latino men. They also want to see police get to know our neighborhoods by getting out of their cars and walking around. This is also a main theme from business owners. As a council member, my goal is to create a mechanism for diverse opinions to be shared in a manner that not only results in innovative ideas, but better understanding among neighbors.",
  },
  {
    firstname: "William “The Kid”",
    lastname: "Guerrero",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": 12,
    occupation: "Community organizer, artist",
    dob: "05/12/2001",
    civic: "Attended Chicago Bulls College Prep",
    candidatevideo: "",
    website: "https://thekidfrompilsen.com/",
    fb: "https://www.facebook.com/thekidforecps12/?show_switched_toast=0&show_invite_to_follow=0&show_switched_tooltip=0&show_podcast_settings=0&show_community_transition=0&show_community_review_changes=0&show_community_rollback=0&show_follower_visibility_disclosure=0",
    twitter: "",
    ig: "https://www.instagram.com/thekidforecps12th/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement:
      'As [one of the youngest district council candidates], I\'ve seen some things that make me believe community residents have the answer. If we can all collectively come together, put our differences aside, and have a serious discussion about what public safety looks like, we can find a common ground. Although I have strong opinions about the police, I understand fully and respect that the definition of "Public Safety" means different things for all community residents. It is our job as community members to find that common ground. I know we can.',
  },
  {
    firstname: "Willie L.",
    lastname: "Wilson",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Businessman",
    dob: "06/16/1948",
    civic: "",
    candidatevideo: "https://youtu.be/ZMECtDM9MSE",
    website: "",
    fb: "https://www.facebook.com/DrWillieWilson",
    twitter: "@DrWillieWilson",
    ig: "https://www.instagram.com/williewilsonforsenate/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
];
